
import { Component, ViewChild, TemplateRef, ElementRef, Input, ChangeDetectorRef, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DatePipe } from '@angular/common';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { AppService } from '../app.service';
import { qmsService } from '../qms/qms.service';
import { firstValueFrom, forkJoin } from 'rxjs';
import { PaginationService } from '../PaginationService';
import { messageService } from '../message.service';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { SuccessSnackbarComponent } from '../support/success-snackbar/success-snackbar.component';
import { EditorComponent } from '../editor/editor.component';
import html2canvas from 'html2canvas';
import jspdf, { jsPDF } from 'jspdf';
import { CanvasJS } from '@canvasjs/angular-charts';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { StaticAuditTrailComponent } from '../support/static-audit-trail/static-audit-trail.component';
import { DomSanitizer } from '@angular/platform-browser';
import { GridReorderComponent } from '../grid-reorder/grid-reorder.component';
import { EChartsOption } from 'echarts';

import moment from 'moment';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

interface dropDownInterface {
  codelistCode: any;
  codelistName: any;
}
@Component({
  selector: 'app-one-qms-dashboard',
  templateUrl: './one-qms-dashboard.component.html',
  styleUrls: ['./one-qms-dashboard.component.scss']
})
export class OneQMSDashboardComponent implements OnInit {
  reportName: any;
  isSaveReport: boolean = false;
  isProcessing: boolean = false;
  specificIntervalVal: boolean = true;
  showPercentage: boolean = false;
  showSpecificInterval: boolean = false;
  showCharts: boolean = false;
  singleModule: boolean = false;
  showGroupGrid: boolean = false;
  showReportFlagValue: any;
  statusList: any = [];
  dmsCountList: any = [];
  overAllCountList: any = [];
  typeNameList: any = [];
  chartWith: string = '100%';
  chartOptionsForDMSCount: any;
  chartOptionsForStatus: any;
  chartOptionsForDocType: any;
  pdfSearchText: string = '';
  chartOptionsForDMSCountZoom: any;
  chartOptionsForStatusZoom: any;
  chartOptionsForDocTypeZoom: any;
  dateCustomClasses: DatepickerDateCustomClasses[];
  selectedOrgValue: any = [];
  selectedQmsGroup: any = [];
  selectedQmsDept: any = [];
  selectedQmsDepartment: any = [];
  selectedIntervalValue: any = null;
  orgValueDropdown: any = [];
  qmsGroupValueDropdown: any = [];
  qmsDeptValueDropdown: any = [];
  intervalValueDropdown: any = [];
  dropDownForInterval: any = [];
  dropDownForOrg: any = [];
  selectedModule: any = null;
  moduleValueDropdown: any = [];
  dropDownForModules: any = [];
  dashboardCountList: any = [];
  excelDashboardCountList: any = [];
  excelGroupDashboardCountList: any = [];
  dashboardCountListCR: any = [];
  dashboardCountListCAPA: any = [];
  dashboardCountListDV: any = [];
  dashboardCountListIN: any = [];
  dashboardCountListQI: any = [];
  dashboardCountListAU: any = [];
  dashboardCountListCC: any = [];
  dashboardCountListOOS: any = [];

  dashboardCountListCRDue: any = [];
  dashboardCountListCAPADue: any = [];
  dashboardCountListDVDue: any = [];
  dashboardCountListINDue: any = [];
  dashboardCountListQIDue: any = [];
  dashboardCountListAUDue: any = [];
  dashboardCountListCCDue: any = [];
  dashboardCountListOOSDue: any = [];

  dashboardCountListAction: any = [];
  dashboardCountListOOSActions: any = [];
  dashboardCountListCRAction: any = [];
  dashboardCountListCAPAAction: any = [];
  dashboardCountListDVAction: any = [];
  dashboardCountListINAction: any = [];
  dashboardCountListQIAction: any = [];
  dashboardCountListAUFinding: any = [];
  dashboardCountListCCAction: any = [];
  dashboardCountListOOSAction: any = [];

  dashboardCountListOOSActionsDue: any = [];
  dashboardCountListCRActionDue: any = [];
  dashboardCountListCAPAActionDue: any = [];
  dashboardCountListDVActionDue: any = [];
  dashboardCountListINActionDue: any = [];
  dashboardCountListQIActionDue: any = [];
  dashboardCountListAUFindingDue: any = [];
  dashboardCountListCCActionDue: any = [];
  dashboardCountListOOSActionDue: any = [];

  totalLineChart: any = [];
  overdueLineChart: any = [];
  overdueLineChartPercentage: any = [];
  dashboardGroupCountList: any = [];
  dashboardTableListVal: any = [];
  orgChartClickDataList: any = [];
  chartDataForGroupClick: any = [];
  fromDate: any;
  toDate: any;
  clickedStageStatusVal = "";
  uniqueOrgNames: any;
  moduless: any;
  uniqueOrgNamesForGroup: any;
  uniqueOrgNamesForGroups: any = [];
  modulesForGroup: any;


  chartOptionsForOrgTotal: any;
  chartOptionsForGroupTotal: any;
  lineChartOptionsForOrgTotal: any;
  lineChartOptionsForOrgOverdue: any;
  chartOptionsForModulesTotal: any;
  tableType: any = "";
  typeOfGrid: any = "";
  multiLineChartData: any;
  groupByOrg: any;
  multiLineChartDataForOverdue: any;
  groupByOrgForOverdue: any;


  titleName = '';
  clickedType = "";
  clickedVal = "";

  whereValsForExcel: any;
  tableReportDataList: any = [];
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  pager: any = {};
  pagedItems: any[];
  manuallyPicked: boolean;
  showingRowsText = "Showing rows";


  pagerSecond: any = {};
  pager3rd: any = {};
  pager4th: any = {};
  maxCountReached: boolean = false;
  selectedColumnsAsString: string = "";
  pdfPageSizes: any = [];
  @Input() excelPdf: any = {};

  activityOrActionList: any;

  pagedItemsSecond: any[];
  pagedItems3rd: any[];
  pagedItems4th: any[];

  departmentSearchText: string = '';
  departmentSearchText1: string = '';
  departmentSearchText2: string = '';
  qmsGroupSearchText: string = '';
  qmsDepartmentSearchText: string = '';
  typeSearchText: string = '';
  selectedReportType: any = null;
  selectedType: any = null;
  drpodownValReportType: any = [];
  selectedOption: any;
  selectedStatus: any;


  designationListDropdown: any = [];
  departmentListDropdown: any = [];
  selectedDesignationValue: any;
  selectedDepartmentValue: any;
  dropDownForDesignation: any = [];
  dropDownForDepartment: any = [];
  dropDownForqmsGroup: any = [];
  dropDownForqmsDept: any = [];

  //tms start
  @Input() tmsReport: any = {};
  @Input() showMarkAsCompleteAndRetake: any;

  ClickedSearchVal: any;
  ClickedStatusVal: any;
  selectedDateRangeValue: any = null;
  communicationData: any = {};
  searchUserName: any;
  markasCompletedBtndisable: boolean = true;
  searchUserId: any;
  chosenToUserId: any;
  chosenToUserName: any;
  searchOneQmsUserTrainingsRepVw: any;
  getOneQmsUsersTrainingsRepVwDetails: any = [];
  getOneQmsUsersTrainingsRepVw: any = [];
  getOneQmsUsersTrainingsRepVwTrainingCountByOr: any = [];
  getOneQmsUsersTrainingsRepVwUserCountByor: any = [];
  getOneQmsUsersTrainingsRepVwDetailsUserAndTraining: any = [];
  searchByDepartmentCodeMain: any = [];
  searchByGroupId = [];
  searchByInstructorTrainer: any = [];
  selectedInstructorTrainer: any;
  searchVals: any;
  additionalSearchVal: any;
  selectedGroup: any = null;
  selectedDepartment: any;
  selectedStageValue: any = [];
  markResult: any;
  resultType: any;
  showOnlyConsider = false;

  totalVal = 0;
  yetToBeAttemptedVal = 0;
  attemptedVal = 0;
  completedAtAttemptedVal = 0;
  failedAtAttemptedChartVal = 0;
  scheduledAtAttemptedChartVal = 0;
  passPerValForAll: any = 0;
  inprogressVal = 0;
  passedVal = 0;
  failedVal = 0;
  scheduledVal = 0;
  passPerVal: any = 0;
  lockedVal = 0;
  completedVal = 0;
  notCompletedVal = 0;
  overdueVal = 0;
  pendingVal = 0;
  lockedOverdueVal = 0;


  tmsUserTrainingsRepVwDataForGrid: any = [];
  type: any;
  repType: any;
  duedate: any;
  comments: any;
  retakeDuedateValue: any;
  popupVal: any;
  dateRangeValueDropdown: any = [];
  childGridShow: any;
  afterClickGenrate: boolean = false;
  notCompleted: boolean = false;
  teamUserLevel: boolean = false;
  departmentUserLevel: boolean = false;
  grouphTrainingLevel: boolean = false;
  instructorTrainingLevel: boolean = false;
  stageAndStatus: any = [];
  showTrainerLevel: boolean = false;
  stageValueDropdown: any = [];
  tmsReportchart: any;
  totalList: any = [];
  // statusList: any = [];
  chartList: any = [];
  trainingsList: any;
  trainingListVal: any;
  heddingListVal: any;
  groupListVal: any;
  dropDownForDateRange: any = [];
  statusValueDropdown: any = [];
  selectedStatusValue: any = [];

  selectedTrainingCategory: any = [];
  categoryCount: any;
  showTables: boolean = false;
  pagedItems2: any;


  trainerSearchText: string = '';

  selectedGroupVal: any = [];
  selectedDepVal: any = [];
  selectedTraininerVal: any = [];
  reportListDropdown: any[];
  reportTypeForDMSDropdown: any[];
  multiUsersArray: any = [];
  getSelectedInstructorTrainingName: string;
  searchByReportCodeMain: string = '';

  searchByDMSReportTypeMain: string = '';

  showDateRange: boolean = true;
  showInstructorTrainingSearchGrid: boolean;
  noUserAlert: boolean = false;
  searchUserParentCheckBox: boolean = false;

  itemsPerPageSecond = 5;
  currentPageSecond = 1;
  totalPagesSecond = 0;
  maxSizeSecond = 3;
  collectionSizeSecond: number;
  perPageSecond = 10;
  calculateTotalPagesSecond: number;

  itemsPerPage3rd = 5;
  currentPage3rd = 1;
  totalPages3rd = 0;
  maxSize3rd = 3;
  collectionSize3rd: number;
  perPage3rd = 10;
  calculateTotalPages3rd: number;
  itemsPerPage4th = 5;
  currentPage4th = 1;
  totalPages4th = 0;
  maxSize4th = 3;
  collectionSize4th: number;
  perPage4th = 10;
  calculateTotalPages4th: number;

  // Instructor Training

  InstructorTrainingGroupTrainingFieldData: any = {};
  @ViewChild('searchInstructorTraining', { static: true }) searchInstructorTraining: TemplateRef<any>;
  visibleSearchInstructorTrainingPopup: MatDialogRef<TemplateRef<any>>;

  searchByInstructorTrainingName: any = null;
  searchByInstructorTrainingScheduleId: any = null;
  searchByVersion: any = [];
  searchByTrainerName: any = [];
  searchByTrainingMode: any = [];
  searchByStatus: any = [];

  showUserSearchGrid: boolean;
  searchTmsInstructorTrainingsVwDetails: any;
  getTmsInstructorTrainingDetailsTableData: any = [];
  showUserSearchInstructorTrainingGrid: any;
  getSelectedInstructorTrainingId: any;

  searchInstructorTrainingConfig = {
    width: '100%',
    height: 'auto',
    disableClose: true,
    hasBackdrop: true,
    position: { top: '30px' },
  };
  //DMS start
  onSelectedOptionForDMS: any = 'Default';
  dmsGroupFoldersFieldData: any = {};
  selectedFolderPath: any;
  selectedDocumentTypeName: any;
  selectedDocContainer: any;
  documentTypeSearchText: string = '';

  documentTypeDropdown: any = [];
  selectedDocumentType: any = [];
  selectedDocumentTypeValue: any = "";
  dropDownFordocumentTypeList: any = [];


  physicalFolderLevel: boolean = true;
  distributedFolderLevel: boolean = true;
  includeAmendmentsFlg: boolean = true;
  associatedDocFlg: boolean = true;
  individualDocFlg: boolean = true;

  dynamicGridName: any;
  dynamicGridViewName: any;
  visibleSearchFoldersPopup: MatDialogRef<TemplateRef<any>>;
  makeStickyColumns: any;
  visibleDmsGroupFoldersReasonForUpdateField: boolean;

  showNoRecordFoundMasterIndex: boolean = false;
  showNoRecordFoundInventry: boolean = false;
  pagedItems1: any[];
  newdocumentTypeSelection = false;
  snackbarRef: any;
  searchText: any;
  searchValue: any;
  _temp: any = {};
  columnLists: any = {};
  dataTypeList: any = [];
  visibleDataGrid: boolean = false;
  tableReportExpireCheckList: any = [];
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  users: any[];
  error = '';

  pagedItemsDMS1: any[];
  pagedItemsDMS2: any[];
  selectedOrgValueForDMS: any;

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;
  constructor(public dialog: MatDialog, public cdr: ChangeDetectorRef, public appService: AppService, public router: Router, public snackBar: MatSnackBar,
    public elem: ElementRef, public qmsservice: qmsService, public message: messageService, public datePipe: DatePipe, public activatedRoute: ActivatedRoute,
    public paginationService: PaginationService, public sanitizer: DomSanitizer) {
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
    appService.isProcessingRep = false;
  }


  @ViewChild('reportPopup', { static: true }) reportPopup: TemplateRef<any>;
  visibleReportPopup: MatDialogRef<TemplateRef<any>>;

  @ViewChild('reportPopup1', { static: true }) reportPopup1: TemplateRef<any>;
  visibleReportPopup1: MatDialogRef<TemplateRef<any>>;

  @ViewChild('reportPopupAction', { static: true }) reportPopupAction: TemplateRef<any>;
  visibleReportPopupAction: MatDialogRef<TemplateRef<any>>;

  @ViewChild('reportPopupForDMSChart', { static: true }) reportPopupForDMSChart: TemplateRef<any>;
  visibleReportPopupForDmsChart: MatDialogRef<TemplateRef<any>>;

  @ViewChild('reportPopupForZoom', { static: true }) reportPopupForZoom: TemplateRef<any>;
  visibleReportPopupForZoom: MatDialogRef<TemplateRef<any>>;
  @ViewChild('columns') columns: MatSelect;
  isAllColumns = false;
  @ViewChild('documentType') newDocumentType: MatSelect;
  @ViewChild('searchFoldersPopup', { static: true }) searchFoldersPopup: TemplateRef<any>;
  searchFoldersPopupConfig = {
    width: '60%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };
  @ViewChild('documentType') documentType: MatSelect;
  documentTypeSelection = false;
  @ViewChild(BreadcrumbComponent) breadcrumbComponent!: BreadcrumbComponent;
  @ViewChild('chartContainer') chartContainer: ElementRef;
  @ViewChild('chartContainer2') chartContainer2: ElementRef;
  @ViewChild('chartContainer3') chartContainer3: ElementRef;
  @ViewChild('chartContainerTMS') chartContainerTMS: ElementRef;
  @ViewChild('orgVal') orgVal: MatSelect;
  @ViewChild('qmsGroupVal') qmsGroupVal: MatSelect;
  @ViewChild('qmsDeptVal') qmsDeptVal: MatSelect;
  orgSelection = false;
  qmsGroupSelection = false;
  qmsDeptSelection = false;
  qmsDepartmentSelection = false;
  showAdditionalMenus = false;
  showDelete = false;
  toggleMenus() {
    this.showAdditionalMenus = !this.showAdditionalMenus;
  }

  onTraininerSelectAllnew(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.selectedTraininerVal = item;
      })
    }
  }

  toggleAllSelectionForGroup() {
    if (this.qmsGroupSelection) this.qmsGroupVal.options.forEach((item: MatOption) => item.select());
    else {
      this.qmsGroupVal.options.forEach((item: MatOption) => item.deselect())
      this.selectedQmsGroup = [];
    }

  }

  toggleAllSelectionForDept() {

    if (this.qmsDeptSelection) {
      this.qmsDeptVal.options.forEach((item: MatOption) => item.select());
    } else {
      this.qmsDeptVal.options.forEach((item: MatOption) => item.deselect())
      this.selectedQmsDept = [];
    }

  }
  toggleAllSelection() {
    if (this.orgSelection) this.orgVal.options.forEach((item: MatOption) => item.select());
    else {
      this.orgVal.options.forEach((item: MatOption) => item.deselect())
      this.selectedOrgValue = [];
    }
    setTimeout(() => {
      if (this.selectedOrgValue.length == 1 || this.selectedOrgValue.length == 0) {
        this.reportListDropdown = [
          { valueExp: 'Organization', displayExp: 'Organization' },
          { valueExp: 'Department', displayExp: 'Department' },
          { valueExp: 'Training Groups', displayExp: 'Training Groups' },
          { valueExp: 'Instructor Trainings', displayExp: 'Instructor Trainings' }
        ];
      } else {
        this.reportListDropdown = [
          { valueExp: 'Organization', displayExp: 'Organization' }
        ];
        this.searchByReportCodeMain = 'Organization';
      }
      if (this.selectedOrgValue.length < 1) {
        const field = document.getElementById('orgNameAlert') as HTMLInputElement;
        field.style.color = 'red';
      } else {
        const field = document.getElementById('orgNameAlert') as HTMLInputElement;
        field.style.color = '#005c8a';
      }
    });
  }
  onModulesSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.selectedQmsGroup = [];
      this.selectedQmsDept = [];
      this.dashboardCountListCR = [];
      this.dashboardCountListCAPA = [];
      this.dashboardCountListDV = [];
      this.dashboardCountListIN = [];
      this.dashboardCountListQI = [];
      this.dashboardCountListAU = [];
      this.dashboardCountListCC = [];
      this.dashboardCountListOOS = [];
      this.dashboardCountListCRAction = [];
      this.dashboardCountListCAPAAction = [];
      this.dashboardCountListDVAction = [];
      this.dashboardCountListINAction = [];
      this.dashboardCountListQIAction = [];
      this.dashboardCountListAUFinding = [];
      this.dashboardCountListCCAction = [];
      this.dashboardCountListOOSAction = [];


      this.dashboardCountListCRActionDue = [];
      this.dashboardCountListCAPAActionDue = [];
      this.dashboardCountListDVActionDue = [];
      this.dashboardCountListINActionDue = [];
      this.dashboardCountListQIActionDue = [];
      this.dashboardCountListAUFindingDue = [];
      this.dashboardCountListCCActionDue = [];
      this.dashboardCountListOOSActionDue = [];
      setTimeout(() => {
        console.log("item.valueExp=", item.valueExp);
        console.log("this.selectedType=", this.selectedType);
        if (this.selectedType == "Finding" && item.valueExp != "AU") {
          alert("You selected Finding Type, so select AU.")
          this.selectedModule = "AU";
        } else {
          this.selectedModule = item.valueExp;
        }
      });
    }
  }
  onOrgsSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.orgSelection = this.orgValueDropdown.length == this.selectedOrgValue.length;
        let selectedOrgValue1 = "";
        if (this.selectedOrgValue.length > 0) {
          if (this.selectedOrgValue.length != 0) {
            for (let j = 0; j < this.selectedOrgValue.length; j++) {
              selectedOrgValue1 += this.selectedOrgValue[j];
              selectedOrgValue1 += j == this.selectedOrgValue.length - 1 ? "" : ",";
            }
          }
          this.data = {

            orgIds: selectedOrgValue1
          }
          forkJoin([
            this.appService.getDistinctMasterModules(this.data),
            this.appService.getDistinctMasterGroups(this.data),
            this.appService.getDepartmentMasterByOrgIds(this.data)
          ]).subscribe(([dropDownForModuless, dropDownForqmsGroups, dropDownForQmsDepartmentCode]) => {
            this.dropDownForModules = dropDownForModuless;
            this.selectBoxForModule();
            this.dropDownForqmsGroup = dropDownForqmsGroups;
            this.selectBoxForQmsGroup();
            this.dropDownForqmsDept = dropDownForQmsDepartmentCode;
            this.selectBoxForQmsDept();

            this.drpodownValReportType = [];
            this.appService.getMasterMainModuleByOrgIds(this.data)
              .subscribe((data: any) => {
                this.oneQmsPrive = data;
                this.drpodownValReportType = [];
                const qualityModules = new Set([
                  "CR",
                  "CAPA",
                  "DV",
                  "IN",
                  "QI",
                  "AU",
                  "CC",
                  "OOS",
                ]);
                if (this.oneQmsPrive.some((m: string) => qualityModules.has(m))) {
                  this.drpodownValReportType.push("Quality");
                }
                if (this.oneQmsPrive.includes('TRN')) {
                  this.drpodownValReportType.push("Trainings");
                }
                if (this.oneQmsPrive.includes('DOCS')) {
                  this.drpodownValReportType.push("Documents");
                }
                console.log("Report Types:", this.drpodownValReportType);
                // ✅ Auto select
                this.selectedReportType = null;

                setTimeout(() => {
                  this.selectedReportType = this.drpodownValReportType[0];
                });
                console.log("this.selectedReportType==", this.selectedReportType)
              });
          })

        }
        if (this.selectedOrgValue.length == 1) {
          this.selectedOrgValueForDMS = this.selectedOrgValue[0];
          this.appService.setOrgVal(this.selectedOrgValueForDMS);
          this.appService.getDocumentTypeBasedOnModule("DOCS")
            .subscribe((data: any) => {
              this.dropDownFordocumentTypeList = data;
              this.documentTypeDropdown = [];
              for (const documentType of this.dropDownFordocumentTypeList) {
                this.documentTypeDropdown.push({
                  valueExp: documentType.documentTypeCode,
                  displayExp: documentType.documentTypeName
                });
              }
            });

        }
        if (this.selectedOrgValue.length == 1 || this.selectedOrgValue.length == 0) {
          this.reportListDropdown = [
            { valueExp: 'Organization', displayExp: 'Organization' },
            { valueExp: 'Department', displayExp: 'Department' },
            { valueExp: 'Training Groups', displayExp: 'Training Groups' },
            { valueExp: 'Instructor Trainings', displayExp: 'Instructor Trainings' }
          ];
        } else {
          this.reportListDropdown = [
            { valueExp: 'Organization', displayExp: 'Organization' }

          ];
          this.searchByReportCodeMain = 'Organization';
        }
        if (this.selectedOrgValue.length < 1) {
          const field = document.getElementById('orgNameAlert') as HTMLInputElement;
          field.style.color = 'red';
        } else {
          const field = document.getElementById('orgNameAlert') as HTMLInputElement;
          field.style.color = '#005c8a';
        }
      })
    } else {
      setTimeout(() => {
        console.log("cccccccc")
        this.orgSelection = this.orgValueDropdown.length == this.selectedOrgValue.length;
        let selectedOrgValue1 = "";
        if (this.selectedOrgValue.length > 0) {
          if (this.selectedOrgValue.length != 0) {
            for (let j = 0; j < this.selectedOrgValue.length; j++) {
              selectedOrgValue1 += this.selectedOrgValue[j];
              selectedOrgValue1 += j == this.selectedOrgValue.length - 1 ? "" : ",";
            }
          }
          this.data = {

            orgIds: selectedOrgValue1
          }
          forkJoin([
            this.appService.getDistinctMasterModules(this.data),
            this.appService.getDistinctMasterGroups(this.data),
            this.appService.getDepartmentMasterByOrgIds(this.data)
          ]).subscribe(([dropDownForModuless, dropDownForqmsGroups, dropDownForQmsDepartmentCode]) => {
            console.log("ccccttttcccc")
            this.dropDownForModules = dropDownForModuless;
            console.log("this.dropDownForModules=", this.dropDownForModules);
            this.selectBoxForModule();
            this.dropDownForqmsGroup = dropDownForqmsGroups;
            this.selectBoxForQmsGroup();
            this.dropDownForqmsDept = dropDownForQmsDepartmentCode;
            this.selectBoxForQmsDept();

            this.drpodownValReportType = [];
            this.appService.getMasterMainModuleByOrgIds(this.data)
              .subscribe((data: any) => {
                this.oneQmsPrive = data;
                this.drpodownValReportType = [];
                const qualityModules = new Set([
                  "CR",
                  "CAPA",
                  "DV",
                  "IN",
                  "QI",
                  "AU",
                  "CC",
                  "OOS",
                ]);
                if (this.oneQmsPrive.some((m: string) => qualityModules.has(m))) {
                  this.drpodownValReportType.push("Quality");
                }
                if (this.oneQmsPrive.includes('TRN')) {
                  this.drpodownValReportType.push("Trainings");
                }
                if (this.oneQmsPrive.includes('DOCS')) {
                  this.drpodownValReportType.push("Documents");
                }
                console.log("Report Types:", this.drpodownValReportType);

                // ✅ Auto select
                this.selectedReportType = null;

                setTimeout(() => {
                  this.selectedReportType = this.drpodownValReportType[0];
                });
                console.log("this.selectedReportType==", this.selectedReportType);

              });
          })

        }
        if (this.selectedOrgValue.length == 1) {
          this.selectedOrgValueForDMS = this.selectedOrgValue[0];
          this.appService.setOrgVal(this.selectedOrgValueForDMS);
          this.appService.getDocumentTypeBasedOnModule("DOCS")
            .subscribe((data: any) => {
              this.dropDownFordocumentTypeList = data;
              this.documentTypeDropdown = [];
              for (const documentType of this.dropDownFordocumentTypeList) {
                this.documentTypeDropdown.push({
                  valueExp: documentType.documentTypeCode,
                  displayExp: documentType.documentTypeName
                });
              }
            });

        }
        if (this.selectedOrgValue.length == 1 || this.selectedOrgValue.length == 0) {
          this.reportListDropdown = [
            { valueExp: 'Organization', displayExp: 'Organization' },
            { valueExp: 'Department', displayExp: 'Department' },
            { valueExp: 'Training Groups', displayExp: 'Training Groups' },
            { valueExp: 'Instructor Trainings', displayExp: 'Instructor Trainings' }
          ];
        } else {
          this.reportListDropdown = [
            { valueExp: 'Organization', displayExp: 'Organization' }

          ];
          this.searchByReportCodeMain = 'Organization';
        }
        if (this.selectedOrgValue.length < 1) {
          const field = document.getElementById('orgNameAlert') as HTMLInputElement;
          field.style.color = 'red';
        } else {
          const field = document.getElementById('orgNameAlert') as HTMLInputElement;
          field.style.color = '#005c8a';
        }
      })



    }
  }
  @ViewChild('pdfColumnVal') pdfColumnVal: MatSelect;
  pdfColumnSelection = false;
  toggleAllSelection1() {
    if (this.pdfColumnSelection) {
      this.pdfColumnVal.options.forEach((item: MatOption) => item.select());
    } else {
      this.pdfColumnVal.options.forEach((item: MatOption) => item.deselect())
      this.selectedColumns = [];
    }
    setTimeout(() => {
      this.handleDropDownValidation('select-tms-data', this.selectedColumns)
      this.convertArrayToString(this.selectedColumns);
    });
  }
  onPDFSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        console.log("this.selectedColumns=", this.selectedColumns);
        this.pdfColumnSelection = this.excelPdf.dropDown.length == this.selectedColumns.length;

        this.convertArrayToString(this.selectedColumns);
      })
    }
  }

  focusSearch(value: any) {
    console.log("value", value)
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      console.log("searchBox", searchBox)
      searchBox?.focus();
    }, 0)
  }

  reportPopupConfig = {
    width: '120%',
    height: '680px',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px', left: '125px' },
    maxWidth: '90vw',
  };

  colorList: string[] = [
    '#F9F871',
    '#6B7887',
    '#00A6A9',
    '#BF83FF',
    '#005C8A',
    '#05004E',
    '#834160',
    '#9EADBD',
    '#BA7393',
    '#DEEBFE',
    '#96E480',
    '#839EFF',
    '#00A6A9',
    '#0081A5',
    '#291F1E',
    '#401F3E',
    '#C0DFA1',
    '#14342B',
    '#D0DB97',
    '#B07BAC',
    '#CF1259',
    '#E6B89C'
  ];

  colorMethod(val: any, iVal: any) {
    if (val == "Closed" || val == "Completed" || val == "Passed") {
      return "#96E480";
    } else if (val == "Critical" || val == "High") {
      return "#EB5757";
    } else if (val == "Major" || val == "Medium") {
      return "#FF947A";
    } else if (val == "In Progress" || val == "Minor") {
      return "#005C8A";
    } else {
      return this.colorList[iVal];
    }
  }
  selectedTab: any;
  selectedTabIndex: any;
  tabIndex: number = 10;
  onTabChanged($event: any) {
    this.selectedTab = $event.tab.textLabel;
    this.tabIndex = $event.index;

  }
  selectedTotalVsOverDueTab: any;
  selectedTotalVsOverDueTabIndex: any;
  totalVsOverDueTabIndex: number = 0;
  previousTotalVsOverDueTabValue: any;
  handleDropDownValidation(fieldId: string, selectedItems: string | null) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = !selectedItems && field ? 'red' : '#005c8a';
  }
  specificIntervalFun(e: any) {
    if (e.checked) {
      this.specificIntervalVal = true;
      this.showSpecificInterval = true;
      this.toDate = new Date();
      // Set the date 365 days before the current date
      this.fromDate = new Date();
      this.fromDate.setDate(this.toDate.getDate() - 90);
      // Set the minDate and maxDate for the date picker
    } else {
      this.specificIntervalVal = false;
      this.showSpecificInterval = false;
    }
  }
  showPercentagFun(e: any) {
    if (e.checked) {
      this.showPercentage = true;
    } else {
      this.showPercentage = false;
    }
  }
  datePickerConfiguration = {
    dateInputFormat: 'DD-MMM-YYYY',
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    maxDate: new Date(),
    todayPosition: 'center'
  }
  selectBoxForInterval() {
    this.intervalValueDropdown = [];
    for (const interval of this.dropDownForInterval) {
      this.intervalValueDropdown.push({
        valueExp: interval.codelistCode,
        displayExp: interval.codelistName
      });
    }
  }
  selectBoxForOrg() {
    this.orgValueDropdown = [];
    this.selectedOrgValue = [];
    for (const org of this.dropDownForOrg) {
      this.orgValueDropdown.push({
        valueExp: org.orgId,
        displayExp: org.orgLongName
      });
    }

    // ✅ Auto-select if only one value
    if (this.dropDownForOrg.length === 1) {
      this.selectedOrgValue = [this.orgValueDropdown[0].valueExp];
    }

    console.log("Auto selected:", this.selectedOrgValue);
  }
  selectBoxForModule() {
    this.moduleValueDropdown = [];

    let i = 0;
    for (const module of this.dropDownForModules) {
      console.log(module, "----")
      this.moduleValueDropdown.push({
        valueExp: module,
        displayExp: module
      });
      i++;
    }
  }

  selectBoxForQmsGroup() {
    this.qmsGroupValueDropdown = [];
    for (const grp of this.dropDownForqmsGroup) {
      this.qmsGroupValueDropdown.push({
        valueExp: grp,
        displayExp: grp
      });
    }
  }

  selectBoxForQmsDept() {
    this.qmsDeptValueDropdown = [];
    for (const dep of this.dropDownForqmsDept) {
      this.qmsDeptValueDropdown.push({
        valueExp: dep.codelistCode,
        displayExp: dep.codelistName
      });
    }
  }
  onNgModelChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = items ? '#005c8a' : 'red';
  }
  genReport() {
    this.tabIndex = 0;
    this.dashboardCountListCR = [];
    this.dashboardCountListCAPA = [];
    this.dashboardCountListDV = [];
    this.dashboardCountListIN = [];
    this.dashboardCountListQI = [];
    this.dashboardCountListAU = [];
    this.dashboardCountListCC = [];
    this.dashboardCountListOOS = [];

    this.dashboardCountListCRDue = [];
    this.dashboardCountListCAPADue = [];
    this.dashboardCountListDVDue = [];
    this.dashboardCountListINDue = [];
    this.dashboardCountListQIDue = [];
    this.dashboardCountListAUDue = [];
    this.dashboardCountListCCDue = [];
    this.dashboardCountListOOSDue = [];

    this.dashboardCountListCRAction = [];
    this.dashboardCountListCAPAAction = [];
    this.dashboardCountListDVAction = [];
    this.dashboardCountListINAction = [];
    this.dashboardCountListQIAction = [];
    this.dashboardCountListAUFinding = [];
    this.dashboardCountListCCAction = [];
    this.dashboardCountListOOSAction = [];


    this.dashboardCountListCRActionDue = [];
    this.dashboardCountListCAPAActionDue = [];
    this.dashboardCountListDVActionDue = [];
    this.dashboardCountListINActionDue = [];
    this.dashboardCountListQIActionDue = [];
    this.dashboardCountListAUFindingDue = [];
    this.dashboardCountListCCActionDue = [];
    this.dashboardCountListOOSActionDue = [];

    this.getOneQmsUsersTrainingsRepVw = false;
    console.log("this.selectedReportType=");
    console.log("this.selectedReportType.length=", this.selectedReportType);
    if (this.selectedOrgValue.length < 1) {
      const field = document.getElementById('orgNameAlert') as HTMLInputElement;
      field.style.color = 'red';
    } else if (this.selectedReportType == null || !this.selectedReportType) {
      const field = document.getElementById('reportType') as HTMLInputElement;
      field.style.color = 'red';
    } else if (this.selectedReportType == 'Quality') {
      if (this.selectedOrgValue.length < 1) {
        const field = document.getElementById('orgNameAlert') as HTMLInputElement;
        field.style.color = 'red';
      } else if (this.specificIntervalVal && this.fromDate && this.toDate && (this.toDate < this.fromDate)) {
        alert('To Date cannot be before From Date');
      } else if (this.specificIntervalVal && (this.fromDate == null || this.fromDate == "" || this.fromDate == undefined)) {
        const field = document.getElementById('fromDateAlert') as HTMLInputElement;
        field.style.color = 'red';
      } else if (this.specificIntervalVal && (this.toDate == null || this.toDate == "" || this.toDate == undefined)) {
        const field = document.getElementById('toDateAlert') as HTMLInputElement;
        field.style.color = 'red';
      } else {
        if (this.selectedType == "Activity") {
          let selectedOrgValue1 = "";
          let selectedQmsGroup1 = "";
          let selectedQmsDept1 = "";
          if (this.selectedQmsGroup.length != 0) {
            for (let j = 0; j < this.selectedQmsGroup.length; j++) {
              selectedQmsGroup1 += "'" + this.selectedQmsGroup[j] + "'";
              selectedQmsGroup1 += j == this.selectedQmsGroup.length - 1 ? "" : ",";
            }
          }

          if (this.selectedQmsDept.length != 0) {
            for (let j = 0; j < this.selectedQmsDept.length; j++) {
              selectedQmsDept1 += "'" + this.selectedQmsDept[j] + "'";
              selectedQmsDept1 += j == this.selectedQmsDept.length - 1 ? "" : ",";
            }
          }

          if (this.selectedOrgValue.length != 0) {
            for (let j = 0; j < this.selectedOrgValue.length; j++) {
              selectedOrgValue1 += this.selectedOrgValue[j];
              selectedOrgValue1 += j == this.selectedOrgValue.length - 1 ? "" : ",";
            }
          }
          let data = {
            groupId: null,
            module: this.selectedModule ?? null,
            dateRangeAt: this.specificIntervalVal ? 'CREATED' : null,
            fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
            toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
            intervals: this.selectedIntervalValue ? this.selectedIntervalValue : null,
            stageName: null,
            status: null,
            deptCode: null,
            annualRefNo: null,
            refno: null,
            taskId: selectedOrgValue1,
            taskNo: this.selectedOrgValue[0] ? this.selectedOrgValue[0] : null,
            groupIds: selectedQmsGroup1,
            deptIds: selectedQmsDept1,
          }

          this.isProcessing = true;

          const promises = [
            firstValueFrom(this.appService.getDashboardCountList(data)),
            firstValueFrom(this.appService.getDashboardCountListForlineChart(data)),
            firstValueFrom(this.appService.getDashboardCountListForlineChartOverduePercentage(data))
          ];
          Promise.all(promises)
            .then(([dashboardCountListVal, dashboardCountListForlineChart, dashboardCountListForlineChartOverdue]) => {
              this.dashboardCountList = dashboardCountListVal;
              this.excelDashboardCountList = this.generateModuleSummary(this.dashboardCountList);
              //  this.exportExcelFromFrontend( this.excelDashboardCountList)
              console.log("this.excelDashboardCountList==", this.excelDashboardCountList);
              this.totalLineChart = dashboardCountListForlineChart;
              this.overdueLineChart = dashboardCountListForlineChartOverdue;
              this.uniqueOrgNames = Array.from(new Set(this.dashboardCountList.map((data: { orgLongName: any }) => data.orgLongName)));
              console.log("this.uniqueOrgNames=", this.uniqueOrgNames);
              this.moduless = Array.from(new Set(this.dashboardCountList.map((data: { module: any }) => data.module)));
              const chartData = this.prepareChartData();
              this.orgChartClickDataList = chartData;
              this.configureChart(chartData);

              this.showGroupGrid = false;
              if (this.selectedOrgValue[0]) {
                this.singleModule = true;
              } else {
                this.singleModule = false;

              }

              if (this.selectedModule) {

                if (this.selectedModule) {
                  if (this.selectedModule == 'CR') {
                    this.dashboardCountListCR = this.generateChartData(this.dashboardCountList);
                    this.dashboardCountListCRDue = this.generateChartDataDue(this.dashboardCountList);
                    console.log("this.dashboardCountListCR==", this.dashboardCountListCR)
                  } else if (this.selectedModule == 'CAPA') {
                    this.dashboardCountListCAPA = this.generateChartData(this.dashboardCountList);
                    this.dashboardCountListCAPADue = this.generateChartDataDue(this.dashboardCountList);
                  } else if (this.selectedModule == 'DV') {
                    this.dashboardCountListDV = this.generateChartData(this.dashboardCountList);
                    this.dashboardCountListDVDue = this.generateChartDataDue(this.dashboardCountList);
                  } else if (this.selectedModule == 'IN') {
                    this.dashboardCountListIN = this.generateChartData(this.dashboardCountList);
                    this.dashboardCountListINDue = this.generateChartDataDue(this.dashboardCountList);
                  } else if (this.selectedModule == 'QI') {
                    this.dashboardCountListQI = this.generateChartData(this.dashboardCountList);
                    this.dashboardCountListQIDue = this.generateChartDataDue(this.dashboardCountList);
                  } else if (this.selectedModule == 'CC') {
                    this.dashboardCountListCC = this.generateChartData(this.dashboardCountList);
                    this.dashboardCountListCCDue = this.generateChartDataDue(this.dashboardCountList);
                  } else if (this.selectedModule == 'AU') {
                    this.dashboardCountListAU = this.generateChartData(this.dashboardCountList);
                    this.dashboardCountListAUDue = this.generateChartDataDue(this.dashboardCountList);
                  } else if (this.selectedModule == 'OOS') {
                    this.dashboardCountListOOS = this.generateChartData(this.dashboardCountList);
                    this.dashboardCountListOOSDue = this.generateChartDataDue(this.dashboardCountList);
                  }
                  setTimeout(() => {
                    this.moduleCharts();
                  }, 1000)

                  setTimeout(() => {
                    this.moduleCharts();
                  }, 2000)
                }
              }
              else {
                for (const module of this.dropDownForModules) {

                  if (module == 'CR') {
                    this.dashboardCountListCR = this.generateChartData(this.dashboardCountList.filter(
                      (item: { module: string; }) => item.module === 'CR'
                    ));
                    this.dashboardCountListCRDue = this.generateChartDataDue(this.dashboardCountList.filter(
                      (item: { module: string; }) => item.module === 'CR'
                    ));
                    console.log("this.dashboardCountListCR==", this.dashboardCountListCR)
                  } else if (module == 'CAPA') {
                    this.dashboardCountListCAPA = this.generateChartData(this.dashboardCountList.filter(
                      (item: { module: string; }) => item.module === 'CAPA'
                    ));
                    this.dashboardCountListCAPADue = this.generateChartDataDue(this.dashboardCountList.filter(
                      (item: { module: string; }) => item.module === 'CAPA'
                    ));
                  } else if (module == 'DV') {
                    this.dashboardCountListDV = this.generateChartData(this.dashboardCountList.filter(
                      (item: { module: string; }) => item.module === 'DV'
                    ));
                    this.dashboardCountListDVDue = this.generateChartDataDue(this.dashboardCountList.filter(
                      (item: { module: string; }) => item.module === 'DV'
                    ));
                  } else if (module == 'IN') {
                    this.dashboardCountListIN = this.generateChartData(this.dashboardCountList.filter(
                      (item: { module: string; }) => item.module === 'IN'
                    ));
                    this.dashboardCountListINDue = this.generateChartDataDue(this.dashboardCountList.filter(
                      (item: { module: string; }) => item.module === 'IN'
                    ));
                  } else if (module == 'QI') {
                    this.dashboardCountListQI = this.generateChartData(this.dashboardCountList.filter(
                      (item: { module: string; }) => item.module === 'QI'
                    ));
                    this.dashboardCountListQIDue = this.generateChartDataDue(this.dashboardCountList.filter(
                      (item: { module: string; }) => item.module === 'QI'
                    ));
                  } else if (module == 'CC') {
                    this.dashboardCountListCC = this.generateChartData(this.dashboardCountList.filter(
                      (item: { module: string; }) => item.module === 'CC'
                    ));
                    this.dashboardCountListCCDue = this.generateChartDataDue(this.dashboardCountList.filter(
                      (item: { module: string; }) => item.module === 'CC'
                    ));
                  } else if (module == 'AU') {
                    this.dashboardCountListAU = this.generateChartData(this.dashboardCountList.filter(
                      (item: { module: string; }) => item.module === 'AU'
                    ));
                    this.dashboardCountListAUDue = this.generateChartDataDue(this.dashboardCountList.filter(
                      (item: { module: string; }) => item.module === 'AU'
                    ));
                  } else if (module == 'OOS') {
                    this.dashboardCountListOOS = this.generateChartData(this.dashboardCountList.filter(
                      (item: { module: string; }) => item.module === 'OOS'
                    ));
                    this.dashboardCountListOOSDue = this.generateChartDataDue(this.dashboardCountList.filter(
                      (item: { module: string; }) => item.module === 'OOS'
                    ));
                  }
                  setTimeout(() => {
                    this.moduleCharts();
                  }, 1000)

                }

              }
              this.isProcessing = false;
              setTimeout(() => {
                this.configureChart(chartData);
              }, 2000)
            },
              error => {
                console.error('Error in forkJoinObservable:', error);
              });
        }
        else if (this.selectedType == "Action") {
          let selectedOrgValue1 = "";
          let selectedQmsGroup1 = "";
          let selectedQmsDept1 = "";
          if (this.selectedQmsGroup.length != 0) {
            for (let j = 0; j < this.selectedQmsGroup.length; j++) {
              selectedQmsGroup1 += "'" + this.selectedQmsGroup[j] + "'";
              selectedQmsGroup1 += j == this.selectedQmsGroup.length - 1 ? "" : ",";
            }
          }

          if (this.selectedQmsDept.length != 0) {
            for (let j = 0; j < this.selectedQmsDept.length; j++) {
              selectedQmsDept1 += "'" + this.selectedQmsDept[j] + "'";
              selectedQmsDept1 += j == this.selectedQmsDept.length - 1 ? "" : ",";
            }
          }

          if (this.selectedOrgValue.length != 0) {
            for (let j = 0; j < this.selectedOrgValue.length; j++) {
              selectedOrgValue1 += this.selectedOrgValue[j];
              selectedOrgValue1 += j == this.selectedOrgValue.length - 1 ? "" : ",";
            }
          }
          let data = {
            groupId: null,
            module: this.selectedModule ?? null,
            dateRangeAt: this.specificIntervalVal ? 'CREATED' : null,
            fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
            toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
            intervals: this.selectedIntervalValue ? this.selectedIntervalValue : null,
            stageName: null,
            status: null,
            deptCode: null,
            annualRefNo: null,
            refno: null,
            taskId: selectedOrgValue1,
            groupIds: selectedQmsGroup1,
            deptIds: selectedQmsDept1,
            taskNo: this.selectedOrgValue[0] ? this.selectedOrgValue[0] : null,
          }

          this.isProcessing = true;

          const promises = [
            firstValueFrom(this.appService.getDashboardCountListAction(data))
          ];
          Promise.all(promises)
            .then(([dashboardCountListValAction]) => {
              this.dashboardCountListAction = dashboardCountListValAction;
              this.uniqueOrgNames = Array.from(new Set(this.dashboardCountListAction.map((data: { orgLongName: any }) => data.orgLongName)));
              console.log("this.uniqueOrgNames=", this.uniqueOrgNames);
              this.moduless = Array.from(new Set(this.dashboardCountListAction.map((data: { module: any }) => data.module)));

              this.showGroupGrid = false;
              if (this.selectedOrgValue[0]) {
                this.singleModule = true;
              } else {
                this.singleModule = false;
              }

              if (this.selectedModule) {
                if (this.selectedModule) {
                  if (this.selectedModule == 'CR') {
                    this.dashboardCountListCRAction = this.generateChartData(this.dashboardCountListAction);
                    this.dashboardCountListCRActionDue = this.generateChartDataDue(this.dashboardCountListAction);
                    console.log("this.dashboardCountListCRAction==", this.dashboardCountListCRAction)
                  } else if (this.selectedModule == 'CAPA') {
                    this.dashboardCountListCAPAAction = this.generateChartData(this.dashboardCountListAction);
                    this.dashboardCountListCAPAActionDue = this.generateChartDataDue(this.dashboardCountListAction);
                  } else if (this.selectedModule == 'DV') {
                    this.dashboardCountListDVAction = this.generateChartData(this.dashboardCountListAction);
                    this.dashboardCountListDVActionDue = this.generateChartDataDue(this.dashboardCountListAction);
                  } else if (this.selectedModule == 'IN') {
                    this.dashboardCountListINAction = this.generateChartData(this.dashboardCountListAction);
                    this.dashboardCountListINActionDue = this.generateChartDataDue(this.dashboardCountListAction);
                  } else if (this.selectedModule == 'QI') {
                    this.dashboardCountListQIAction = this.generateChartData(this.dashboardCountListAction);
                    this.dashboardCountListQIActionDue = this.generateChartDataDue(this.dashboardCountListAction);
                  } else if (this.selectedModule == 'CC') {
                    this.dashboardCountListCCAction = this.generateChartData(this.dashboardCountListAction);
                    this.dashboardCountListCCActionDue = this.generateChartDataDue(this.dashboardCountListAction);
                  }

                }

                setTimeout(() => {
                  console.log("in")
                  this.moduleChartsAction();

                }, 1000)
              }
              else {
                for (const module of this.dropDownForModules) {
                  if (module == 'CR') {
                    this.dashboardCountListCRAction = this.generateChartData(this.dashboardCountListAction.filter(
                      (item: { module: string; }) => item.module === 'CR'
                    ));
                    this.dashboardCountListCRActionDue = this.generateChartDataDue(this.dashboardCountListAction.filter(
                      (item: { module: string; }) => item.module === 'CR'
                    ));
                    console.log("this.dashboardCountListCRAction==", this.dashboardCountListCRAction);
                    console.log("this.dashboardCountListCRActionDue==", this.dashboardCountListCRActionDue)
                  } else if (module == 'CAPA') {
                    this.dashboardCountListCAPAAction = this.generateChartData(this.dashboardCountListAction.filter(
                      (item: { module: string; }) => item.module === 'CAPA'
                    ));
                    this.dashboardCountListCAPAActionDue = this.generateChartDataDue(this.dashboardCountListAction.filter(
                      (item: { module: string; }) => item.module === 'CAPA'
                    ));
                  } else if (module == 'DV') {
                    this.dashboardCountListDVAction = this.generateChartData(this.dashboardCountListAction.filter(
                      (item: { module: string; }) => item.module === 'DV'
                    ));
                    this.dashboardCountListDVActionDue = this.generateChartDataDue(this.dashboardCountListAction.filter(
                      (item: { module: string; }) => item.module === 'DV'
                    ));
                  } else if (module == 'IN') {
                    this.dashboardCountListINAction = this.generateChartData(this.dashboardCountListAction.filter(
                      (item: { module: string; }) => item.module === 'IN'
                    ));
                    this.dashboardCountListINActionDue = this.generateChartDataDue(this.dashboardCountListAction.filter(
                      (item: { module: string; }) => item.module === 'IN'
                    ));
                  } else if (module == 'QI') {
                    this.dashboardCountListQIAction = this.generateChartData(this.dashboardCountListAction.filter(
                      (item: { module: string; }) => item.module === 'QI'
                    ));
                    this.dashboardCountListQIActionDue = this.generateChartDataDue(this.dashboardCountListAction.filter(
                      (item: { module: string; }) => item.module === 'QI'
                    ));
                  } else if (module == 'CC') {
                    this.dashboardCountListCCAction = this.generateChartData(this.dashboardCountListAction.filter(
                      (item: { module: string; }) => item.module === 'CC'
                    ));

                    this.dashboardCountListCCActionDue = this.generateChartDataDue(this.dashboardCountListAction.filter(
                      (item: { module: string; }) => item.module === 'CC'
                    ));
                  }


                }

                setTimeout(() => {
                  console.log("all")
                  this.moduleChartsAction();
                }, 1000)

              }
              this.isProcessing = false;
            },
              error => {
                console.error('Error in forkJoinObservable:', error);
              });


          const promises1 = [
            firstValueFrom(this.appService.getDashboardCountListOOSAction(data)),
          ];
          Promise.all(promises1)
            .then(([dashboardCountListValOOSAction]) => {
              this.dashboardCountListOOSActions = dashboardCountListValOOSAction;
              this.showGroupGrid = false;
              if (this.selectedOrgValue[0]) {
                this.singleModule = true;
              } else {
                this.singleModule = false;
              }
              if (this.selectedModule) {
                if (this.selectedModule == 'OOS') {
                  this.dashboardCountListOOSAction = this.generateChartData(this.dashboardCountListOOSActions);
                }
                setTimeout(() => {
                  console.log("in")
                  this.moduleChartsAction();
                }, 1000)
              }
              else {
                for (const module of this.dropDownForModules) {
                  if (module == 'OOS') {
                    this.dashboardCountListOOSAction = this.generateChartData(this.dashboardCountListOOSActions.filter(
                      (item: { module: string; }) => item.module === 'OOS'
                    ));
                  }
                }
                setTimeout(() => {
                  console.log("all")
                  this.moduleChartsAction();
                }, 1000)

              }
              this.isProcessing = false;
            },
              error => {
                console.error('Error in forkJoinObservable:', error);
              });

        } else if (this.selectedType == "Finding") {
          let selectedOrgValue1 = "";
          let selectedQmsGroup1 = "";
          let selectedQmsDept1 = "";
          if (this.selectedQmsGroup.length != 0) {
            for (let j = 0; j < this.selectedQmsGroup.length; j++) {
              selectedQmsGroup1 += "'" + this.selectedQmsGroup[j] + "'";
              selectedQmsGroup1 += j == this.selectedQmsGroup.length - 1 ? "" : ",";
            }
          }

          if (this.selectedQmsDept.length != 0) {
            for (let j = 0; j < this.selectedQmsDept.length; j++) {
              selectedQmsDept1 += "'" + this.selectedQmsDept[j] + "'";
              selectedQmsDept1 += j == this.selectedQmsDept.length - 1 ? "" : ",";
            }
          }

          if (this.selectedOrgValue.length != 0) {
            for (let j = 0; j < this.selectedOrgValue.length; j++) {
              selectedOrgValue1 += this.selectedOrgValue[j];
              selectedOrgValue1 += j == this.selectedOrgValue.length - 1 ? "" : ",";
            }
          }
          let data = {
            groupId: null,
            module: this.selectedModule ?? null,
            dateRangeAt: this.specificIntervalVal ? 'CREATED' : null,
            fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
            toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
            intervals: this.selectedIntervalValue ? this.selectedIntervalValue : null,
            stageName: null,
            status: null,
            deptCode: null,
            annualRefNo: null,
            refno: null,
            taskId: selectedOrgValue1,
            groupIds: selectedQmsGroup1,
            deptIds: selectedQmsDept1,
            taskNo: this.selectedOrgValue[0] ? this.selectedOrgValue[0] : null,
          }
          this.isProcessing = true;
          const promises = [
            firstValueFrom(this.appService.getDashboardCountListAuFindings(data)),
          ];
          Promise.all(promises)
            .then(([dashboardCountListVal]) => {
              this.dashboardCountList = dashboardCountListVal;
              this.uniqueOrgNames = Array.from(new Set(this.dashboardCountList.map((data: { orgLongName: any }) => data.orgLongName)));
              console.log("this.uniqueOrgNames=", this.uniqueOrgNames);
              this.moduless = Array.from(new Set(this.dashboardCountList.map((data: { module: any }) => data.module)));
              this.showGroupGrid = false;
              if (this.selectedOrgValue[0]) {
                this.singleModule = true;
              } else {
                this.singleModule = false;
              }
              this.dashboardCountListAUFinding = this.generateChartDataFindings(this.dashboardCountList);
              this.dashboardCountListAUFindingDue = this.generateChartDataFindingsDue(this.dashboardCountList);
              console.log(" this.dashboardCountListAUFinding==", this.dashboardCountListAUFinding);
              setTimeout(() => {
                console.log("in")
                this.moduleChartsFinding();
              }, 1000)
              this.isProcessing = false;
            },
              error => {
                console.error('Error in forkJoinObservable:', error);
              });

        }
      }

    } else if (this.selectedReportType == 'Trainings') {
      if (this.searchByReportCodeMain.length < 1) {
        const field = document.getElementById('manageReportNameAlert') as HTMLInputElement;
        field.style.color = 'red';
      } else if (this.selectedOption) {
        console.log(this.selectedOrgValue.length + "========" + this.selectedOption)
        if (this.selectedOrgValue.length != 0 && this.selectedOrgValue.length == 1 && this.selectedOption != 'Organization') {
          this.getOneQmsUsersTrainingsRepVwUserCountByor = [];
          this.getOneQmsUsersTrainingsRepVwTrainingCountByOr = [];
          if (this.selectedOption == 'Department') {
            if (this.searchByDepartmentCodeMain.length < 1) {
              const field = document.getElementById('departmentNameAlert') as HTMLInputElement;
              field.style.color = 'red';
            } else {
              const field = document.getElementById('departmentNameAlert') as HTMLInputElement;
              field.style.color = '#005c8a';
              this.getUsers();
            }
          } else if (this.selectedOption == 'Instructor Trainings') {
            this.getUsersInstructorTraining();
          } else if (this.selectedOption == 'Training Groups') {
            if (this.selectedGroup == null || this.selectedGroup == '') {
              const field = document.getElementById('groupNameAlert') as HTMLInputElement;
              field.style.color = 'red';
            } else {
              const field = document.getElementById('groupNameAlert') as HTMLInputElement;
              field.style.color = '#005c8a';
              this.getUsersForGroup();
            }
          }
          console.log(this.selectedOrgValue.length + "====1====" + this.selectedOption)
        } else if (this.selectedOrgValue.length != 0 && this.selectedOption == 'Organization') {
          this.getOrgs();
          console.log(this.selectedOrgValue.length + "====2====" + this.selectedOption)
        }
      }
    } else if (this.selectedReportType == 'Documents') {
      if (this.searchByDMSReportTypeMain.length < 1) {
        const field = document.getElementById('manageDMSReportNameAlert') as HTMLInputElement;
        field.style.color = 'red';
        console.log("data", this.searchByDMSReportTypeMain)
        console.log("data", this.onSelectedOptionForDMS)
      } else if (this.onSelectedOptionForDMS == 'Inventory') {
        this.isProcessing = true;
        let folderPath = this.dmsGroupFoldersFieldData.folderPath;
        if (folderPath && folderPath !== "Repository") {
          this.selectedFolderPath = folderPath;
        } else {
          this.selectedFolderPath = null;
        }
        this.selectedDocContainer = "";
        console.log(this.physicalFolderLevel, "----------", this.distributedFolderLevel, "-----", this.selectedFolderPath);
        if (this.physicalFolderLevel && this.distributedFolderLevel && (this.selectedFolderPath == null || this.selectedFolderPath == "Repository")) {
          this.selectedDocContainer = "";
        } else if (!this.physicalFolderLevel && this.distributedFolderLevel && (this.selectedFolderPath == null || this.selectedFolderPath == "Repository")) {
          this.selectedDocContainer = "Distributed";
        } else if (this.physicalFolderLevel && !this.distributedFolderLevel && (this.selectedFolderPath == null || this.selectedFolderPath == "Repository")) {
          this.selectedDocContainer = "Physical";
        }
        this.dynamicGridName = "DOCUMENT_INVENTORY";
        this.dynamicGridViewName = "DMS_DOCUMENTS_INVENTORY_VW";
        console.log('Selected Folder Path:', this.selectedFolderPath);
        this.getcallMethod();
      } else if (this.onSelectedOptionForDMS == 'Master Index') {
        let str = "";
        this.selectedFolderPath = this.selectedFolderForCreateDoc.folderPath;
        console.log(" this.selectedFolderPath = 1", this.selectedFolderPath)
        if (this.selectedFolderPath == "Repository" || this.selectedFolderPath == "undefined" || !this.selectedFolderPath) {
          console.log(" this.selectedFolderPath = 2", this.selectedFolderPath)

          const field = document.getElementById('folderMasterAlert') as HTMLInputElement;
          field.style.color = 'red';
        } else {
          console.log(" this.selectedFolderPath = 3", this.selectedFolderPath)
          this.whereValsForExcel = "";
          this.whereValsForExcel += " WHERE ORG_ID=" + this.selectedOrgValue[0];

          if (this.selectedFolderPath) {
            this.whereValsForExcel += " AND FOLDER_ID_PATH LIKE '" + this.selectedFolderPath + "%'";
          }
          this.selectedDocumentTypeName = "";
          if (this.selectedDocumentType != null && this.selectedDocumentType.length > 0) {
            const codesArray: string[] = this.selectedDocumentType.join(',').split(",");
            this.selectedDocumentTypeName = codesArray.map(code => `'${code.trim()}'`).join(",");
          } else {
            this.selectedDocumentTypeName = null;
          }
          if (this.selectedDocumentTypeName) {
            str += " AND DOCUMENT_TYPE_CODE IN (" + this.selectedDocumentTypeName + ")";
          }
          //  console.log(this.selectedDocumentType.length)
          console.log(this.includeAmendmentsFlg + "===" + this.associatedDocFlg + "===" + this.individualDocFlg);
          if (!this.includeAmendmentsFlg && !this.associatedDocFlg) {
            str += " AND IS_ASSOCIATED_DOCUMENT_TYPE = 'N'";
          } else if (!this.includeAmendmentsFlg && this.associatedDocFlg) {
            str += " AND (IS_ASSOCIATED_DOCUMENT_TYPE = 'N' OR (IS_ASSOCIATED_DOCUMENT_TYPE = 'Y' AND IS_AMENDEMENT_DOC_TYPE = 'N'))";
          } else if (this.includeAmendmentsFlg && !this.associatedDocFlg) {
            str += " AND (IS_ASSOCIATED_DOCUMENT_TYPE = 'N' OR (IS_ASSOCIATED_DOCUMENT_TYPE = 'Y' AND IS_AMENDEMENT_DOC_TYPE = 'Y'))";
          }
          if (!this.individualDocFlg) {
            str += " AND BELONGS_TO_INDIVIDUAL='N'";
          }
          this.whereValsForExcel += str;
          if (str == "") {
            str += null;
          }
          this.isProcessing = true;
          forkJoin([
            this.appService.getDocumentRevisionHistoryRepVw(str, this.selectedFolderPath ? this.selectedFolderPath : null)]).subscribe(([MilestonesIntervalsRepVw]) => {
              this.tableReportDataList = MilestonesIntervalsRepVw;
              this.showNoRecordFoundMasterIndex = this.tableReportDataList.length === 0;
              this.showTables = true;
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.collectionSize = this.tableReportDataList.length;
              this.totalPages = Math.ceil(this.tableReportDataList.length / this.itemsPerPage);
              this.setPageDMS2(1, 0);
              this.isProcessing = false;
            });
          this.columnList = "Document Type Name,Document No,Document Name,Version,Effective Date,Expiration Date";
        }
      } else if (this.onSelectedOptionForDMS == 'Default') {
        if (this.fromDate && this.toDate && (this.toDate <= this.fromDate)) {
          alert('To Date cannot be before From Date');
        } else {
          let data = {
            groupId: null,
            module: "DOCS",
            dateRangeAt: this.selectedDateRangeValue,
            fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
            toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
            intervals: this.selectedIntervalValue,
            stageName: null,
            status: null
          }
          this.isProcessing = true;
          const promises = [
            firstValueFrom(this.appService.getDMSCountReportValForMain(data)),
            firstValueFrom(this.appService.getDocumentCountRepDmsForMain(data)),
            firstValueFrom(this.appService.getDocumentTypeNameCountRepDmsForMain(data)),
          ];
          Promise.all(promises)
            .then(([dmsCountList, statusCountList, documentTypeList]) => {
              this.dmsCountList = dmsCountList;
              this.statusList = statusCountList;
              this.typeNameList = documentTypeList;
              if (this.typeNameList.length > 50) {
                this.chartWith = "3000px";
              } else if (this.typeNameList.length > 30) {
                this.chartWith = "2000px";
              } else {
                this.chartWith = "100%"
              }
              this.createChart();
              this.isProcessing = false;
            },
              error => {
                console.error('Error in forkJoinObservable:', error);
              });
        }
      }

    }
  }
  moveTop() {
    this.showCharts = true;
    setTimeout(() => {
      window.scrollTo({ top: 220, behavior: 'smooth' });
    }, 1000);
  }
  getUsersForGroup() {
    this.pagedItemsSecond = [];
    if (this.selectedOption == 'Training Groups') {
      if (this.selectedGroup) {
        console.log("this.selectedOption=", this.selectedOption);
        this.newRunForGroup("tg", this.selectedGroup);
      } else {
        const field = document.getElementById('groupNameAlert') as HTMLInputElement;
        field.style.color = 'red';
      }
    }
  }
  applyFilter7(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItemsDMS1 = this.tmsUserTrainingsRepVwDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItemsDMS1 = this.tmsUserTrainingsRepVwDataForGrid.filter((item: any) => {
        const columnValue = item[column];
        // Check if columnValue is a string before calling toLowerCase()
        if (val === 'd') {
          if (columnValue == null) {
            return false;
          } else {
            let formattedDate = this.datePipe.transform(columnValue, this.appService.organizationDetails?.dateFormat ? 'DD-MMM-YYYY' : this.appService.organizationDetails?.dateFormat);
            return formattedDate ? formattedDate.toString().toLowerCase().includes(filter) : false;

          }
        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          // Convert number to string before checking for inclusion
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          // Format date to string before checking for inclusion
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        // If it's not a string, return false to exclude it from filtering
        return false;
      });
    }
  }
  showAlert(message: string, type: string) {
    this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: 5000,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName:
          this.message.breadcrumbData.thirdLevel ??
          this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    this.snackbarRef.onAction().subscribe(() => {
      this.snackbarRef.dismiss();
    });
  }

  getUsers() {
    this.pagedItemsSecond = [];
    if (this.selectedOption == 'Department') {
      console.log("dedede=", this.searchByDepartmentCodeMain)
      if (this.searchByDepartmentCodeMain.length > 0) {
        if (this.searchByDepartmentCodeMain.length > 15) {
          console.log("len=", this.searchByDepartmentCodeMain.length);
          this.showAlert('Kindly note, all departments were selected.', 'S');
          this.newRun("de", "01010");
        } else {
          console.log("len1=", this.searchByDepartmentCodeMain.length);
          let selectedDep1 = "";
          if (this.searchByDepartmentCodeMain.length > 0) {
            for (let j = 0; j < this.searchByDepartmentCodeMain.length; j++) {
              selectedDep1 += this.searchByDepartmentCodeMain[j];
              selectedDep1 += j == this.searchByDepartmentCodeMain.length - 1 ? "" : ",";
            }
          }
          const parts: string[] = selectedDep1.split(',');
          const formattedParts: string[] = parts.map(part => `'${part}'`);
          const result: string = formattedParts.join(',');
          console.log("de result=", result)
          this.newRun("de", result);
        }
      } else {
        this.newRun("de", "01010");
      }
    }
  }
  getOrgs() {
    this.pagedItemsSecond = [];
    let selectedOrgValue1 = "";
    if (this.selectedOrgValue.length != 0 && this.selectedOrgValue.length > 1) {
      for (let j = 0; j < this.selectedOrgValue.length; j++) {
        selectedOrgValue1 += this.selectedOrgValue[j];
        selectedOrgValue1 += j == this.selectedOrgValue.length - 1 ? "" : ",";
      }

      this.item = null;
      this.item1 = selectedOrgValue1;
    } else {
      this.item = this.selectedOrgValue[0] ? this.selectedOrgValue[0] : null;
      this.item1 = null;
    }
    if (this.selectedOrgValue.length != 0) {
      console.log(this.selectedOrgValue.length + "====3====" + this.selectedOption)
      this.newOrgRun("or", this.item, this.item1);
    }
  }
  newRunForGroup(type: any, val: any) {
    this.isProcessing = true;
    let i = 0;
    this.afterClickGenrate = false;
    this.totalVal = 0;
    this.attemptedVal = 0;
    this.yetToBeAttemptedVal = 0;
    this.completedAtAttemptedVal = 0;
    this.failedAtAttemptedChartVal = 0;
    this.scheduledAtAttemptedChartVal = 0;
    this.passPerValForAll = 0;
    this.inprogressVal = 0;
    this.passedVal = 0;
    this.failedVal = 0;
    this.scheduledVal = 0;
    this.lockedVal = 0;
    this.completedVal = 0;
    this.overdueVal = 0;
    this.pendingVal = 0;
    this.lockedOverdueVal = 0;
    this.chartList = [];
    let attaptedVal = "";
    if (this.notCompleted) {
      attaptedVal = "att"
    } else {
      attaptedVal = "notatt"
    }
    this.appService.getOneQmsUserTrainingsRepVwMainForGroup(this.selectedOrgValue[0], type, val, attaptedVal).subscribe((data: any) => {
      this.afterClickGenrate = true;
      this.getOneQmsUsersTrainingsRepVwDetails = data;
      this.calculateTotalPages = this.collectionSize / this.perPage;
      this.pager.totalPages = undefined;
      this.collectionSize = this.getOneQmsUsersTrainingsRepVwDetails.length;
      this.totalPages = Math.ceil(this.getOneQmsUsersTrainingsRepVwDetails.length / this.itemsPerPage);
      this.setPageMain(1, 0);
      console.log("this.getOneQmsUsersTrainingsRepVwDetails=", this.getOneQmsUsersTrainingsRepVwDetails)
      data.forEach((item: any, index: any) => {
        this.totalVal += item.total;
        this.attemptedVal += item.attempted;
        this.completedAtAttemptedVal += item.completedAtAttemptedChart;
        this.failedAtAttemptedChartVal += item.failedAtAttemptedChart;
        this.scheduledAtAttemptedChartVal += item.scheduledAtAttemptedChart;
        this.yetToBeAttemptedVal += item.yetToBeAttempted;
        this.passPerValForAll = (this.completedAtAttemptedVal / this.totalVal * 100).toFixed(1);
        this.pendingVal += item.pending;
        this.inprogressVal += item.inprogress;
        this.failedVal += item.failed;
        this.scheduledVal += item.scheduled;
        this.completedVal += item.completed;
        this.overdueVal += item.overdue;
        this.lockedVal += item.locked;
        this.passPerVal = (this.completedVal / this.totalVal * 100).toFixed(1);
      });
      if (this.notCompleted) {
        this.chartList.push(
          { lable: "Pending", value: this.pendingVal, color: "yellow" },
          { lable: "Attempted", value: this.attemptedVal, color: "DodgerBlue" },
          { lable: "Inprogress", value: this.inprogressVal, color: "green" },
          { lable: "Completed", value: this.completedVal, color: "green" },
          { lable: "Failed", value: this.failedVal, color: "red" },
          { lable: "Scheduled", value: this.scheduledVal, color: "gray" },
          { lable: "Overdue", value: this.overdueVal, color: "green" },
          { lable: "locked", value: this.lockedVal, color: "green" }
        );
      } else {
        this.chartList.push(
          { lable: "Attempted", value: this.attemptedVal, color: "DodgerBlue" },
          { lable: "Yet To Be Attempted", value: this.yetToBeAttemptedVal, color: "yellow" },
          { lable: "Scheduled At Attempted Chart", value: this.scheduledAtAttemptedChartVal, color: "DodgerBlue" },
          { lable: "Failed At Attempted Chart", value: this.failedAtAttemptedChartVal, color: "green" },
          { lable: "Completed At Attempted", value: this.completedAtAttemptedVal, color: "green" }
        );
      }
      this.chartOptionsForUser = {
        animationEnabled: true,
        exportEnabled: true,
        zoomEnabled: true,
        zoomType: "xy",
        toolbar: {
          itemBackgroundColor: "#d3d3d3",
          itemBackgroundColorOnHover: "#3e3e3e",
          buttonBorderColor: "#3e3e3e",
          icon: {
            zoom: {
              backgroundColor: "#007BFF", // Set the background color for the zoom icon
              borderColor: "#007BFF",     // Set the border color for the zoom icon
              borderWidth: 1             // Set the border width for the zoom icon
            }
          }
        },
        legend: {
          cursor: "pointer",
          fontFamily: "Poppins",
          fontColor: "#0F3659",
        },
        title: {
          text: "Status",
          fontSize: 20,
          fontFamily: "Poppins",
          horizontalAlign: "left",
          fontColor: "#0F3659",
          fontWeight: "bold",
          click: function (e: any) {
            console.log("Title clicked!");
          }
        },
        data: [{
          type: "doughnut",
          startAngle: -90,
          indexLabel: "{lable}:{value}",
          showInLegend: true,
          legendText: "{indexLabel}",
          yValueFormatString: "#,###.##''",
          dataPoints: this.getDataPointsForCharts(),
        }]
      }
      setTimeout(() => {
        let chart = new CanvasJS.Chart("chartContainerTMS", this.chartOptionsForUser);
        chart.render();
      }, 1000);
      this.isProcessing = false;
    })
  }
  getCount(org: string, module: string, status: string): number {
    return this.dashboardCountList.filter((d: { module: string; chartStatus: string; orgLongName: string }) => d.module === module && d.chartStatus === status && d.orgLongName === org).reduce((acc: number, curr: { count: number }) => acc + curr.count, 0);
  }
  getOverdueCount(org: string, module: string): number {
    return this.dashboardCountList.filter((d: { module: string; overdue: string; orgLongName: string }) => d.module === module && d.overdue === 'Y' && d.orgLongName === org).reduce((acc: number, curr: { count: number }) => acc + curr.count, 0);
  }
  getTotalCount(org: string, module: string): number {
    const closed = this.getCount(org, module, 'Closed');
    const open = this.getCount(org, module, 'Open');
    const deleted = this.getCount(org, module, 'Deleted/Obsoleted');
    return closed + open + deleted;
  }
  getCountBymodule(module: string, status: string): number {
    return this.dashboardCountList.filter((d: { module: string; chartStatus: string; orgLongName: string }) => d.module === module && d.chartStatus === status).reduce((acc: number, curr: { count: number }) => acc + curr.count, 0);
  }
  getOverdueCountBymodule(module: string): number {
    return this.dashboardCountList.filter((d: { module: string; overdue: string; orgLongName: string }) => d.module === module && d.overdue === 'Y').reduce((acc: number, curr: { count: number }) => acc + curr.count, 0);
  }
  getTotalCountBymodule(module: string): number {
    const closed = this.getCountBymodule(module, 'Closed');
    const open = this.getCountBymodule(module, 'Open');
    const deleted = this.getCountBymodule(module, 'Deleted/Obsoleted');
    return closed + open + deleted;
  }
  //group
  getCountForGroup(groupName: string, module: string, status: string): number {
    return this.dashboardGroupCountList.filter((d: { module: string; chartStatus: string; groupName: string }) => d.module === module && d.chartStatus === status && d.groupName === groupName).reduce((acc: number, curr: { count: number }) => acc + curr.count, 0);
  }
  getOverdueCountForGroup(groupName: string, module: string): number {
    return this.dashboardGroupCountList.filter((d: { module: string; overdue: string; groupName: string }) => d.module === module && d.groupName === groupName && d.overdue === 'Y').reduce((acc: number, curr: { count: number }) => acc + curr.count, 0);
  }
  getTotalCountForGroup(groupName: string, module: string): number {
    const closed = this.getCountForGroup(groupName, module, 'Closed');
    const open = this.getCountForGroup(groupName, module, 'Open');
    const deleted = this.getCountForGroup(groupName, module, 'Deleted/Obsoleted');
    return closed + open + deleted;
  }
  getOrgNameForGroup(groupName: string, module: string): number {
    return this.dashboardGroupCountList.find(
      (d: { groupName: string; orgLongName: string }) =>
        d.groupName === groupName
    )?.orgLongName;
  }

  resetFunction1() {
    this.getOneQmsUsersTrainingsRepVwTrainingCountByOr = false;
    this.getOneQmsUsersTrainingsRepVwUserCountByor = false;
    this.getOneQmsUsersTrainingsRepVw = false;
    this.showNoRecordFoundInventry = false;
    this.totalVal = 0;
    this.specificIntervalVal = true;
    this.toDate = new Date();
    // Set the date 365 days before the current date
    this.fromDate = new Date();
    this.fromDate.setDate(this.toDate.getDate() - 90);
    // Set the minDate and maxDate for the date picker
    this.tableReportDataList = null;
    this.showCharts = false;
    this.selectedModule = null;
    this.selectedGroup = null;
    this.getSelectedInstructorTrainingName = "";
    this.getSelectedTrainingId = null;
    this.searchByInstructorTrainer = [];
    this.searchByReportCodeMain = 'Organization';
    this.searchByDepartmentCodeMain = [];
    this.showCharts = false;
    this.showGroupGrid = false;
    this.tableType = "";
    this.orgSelection = false;
    this.qmsGroupSelection = false;
    this.dmsGroupFoldersFieldData.folderName = '';
    this.selectedDocumentType = [];
    this.documentTypeSearchText = '';
    this.newdocumentTypeSelection = false;
    this.groupSearchText = '';
    this.selectedFolderPath = '';
    this.tmsUserTrainingsRepVwDataForGrid = [];
    this.selectedOption = '';
    this.selectedReportType = '';
    this.groupSearchText = '';
    this.documentTypeSearchText = '';
    this.dmsGroupFoldersFieldData = {
      folderName: '',
      folderPath: ''
    };
    this.selectedDocumentType = [];
    this.newdocumentTypeSelection = false;
    this.selectedFolderForCreateDoc = {
      folderPath: ''
    };
    this.physicalFolderLevel = false;
    this.distributedFolderLevel = false;
    this.includeAmendmentsFlg = false;
    this.associatedDocFlg = false;
    this.individualDocFlg = false;
    this.selectedFolderPath = null;
    this.selectedReportType = '';
    this.tableReportDataList = [];
    this.showTables = false;
    this.showNoRecordFoundMasterIndex = false;
    this.isProcessing = false;
    const manageDMSReportNameAlert = document.getElementById('manageDMSReportNameAlert') as HTMLInputElement;
    const folderMasterAlert = document.getElementById('folderMasterAlert') as HTMLInputElement;
    if (manageDMSReportNameAlert) {
      manageDMSReportNameAlert.style.color = '';
    }
    if (folderMasterAlert) {
      folderMasterAlert.style.color = '';
    }
    this.collectionSize = 0;
    this.totalPages = 0;
    this.itemsPerPage = 10;
    this.currentPage = 1;
    this.selectedQmsGroup = [];
    this.selectedQmsDept = [];
    this.dashboardCountListCR = [];
    this.dashboardCountListCAPA = [];
    this.dashboardCountListDV = [];
    this.dashboardCountListIN = [];
    this.dashboardCountListQI = [];
    this.dashboardCountListAU = [];
    this.dashboardCountListCC = [];
    this.dashboardCountListOOS = [];

    this.dashboardCountListCRAction = [];
    this.dashboardCountListCAPAAction = [];
    this.dashboardCountListDVAction = [];
    this.dashboardCountListINAction = [];
    this.dashboardCountListQIAction = [];
    this.dashboardCountListAUFinding = [];
    this.dashboardCountListCCAction = [];
    this.dashboardCountListOOSAction = [];
  }
  resetFunction() {
    this.getOneQmsUsersTrainingsRepVwTrainingCountByOr = false;
    this.getOneQmsUsersTrainingsRepVwUserCountByor = false;
    this.getOneQmsUsersTrainingsRepVw = false;
    this.showNoRecordFoundInventry = false;
    this.totalVal = 0;
    this.specificIntervalVal = true;
    this.toDate = new Date();
    // Set the date 365 days before the current date
    this.fromDate = new Date();
    this.fromDate.setDate(this.toDate.getDate() - 90);
    // Set the minDate and maxDate for the date picker
    this.tableReportDataList = null;
    this.showCharts = false;
    this.selectedOrgValue = [];
    this.selectedModule = null;
    this.selectedReportType = null;
    this.selectedGroup = null;
    this.getSelectedInstructorTrainingName = "";
    this.getSelectedTrainingId = null;
    this.searchByInstructorTrainer = [];
    this.searchByReportCodeMain = 'Organization';
    this.searchByDepartmentCodeMain = [];
    this.showCharts = false;
    this.showGroupGrid = false;
    this.tableType = "";
    this.orgSelection = false;
    this.qmsGroupSelection = false;
    this.dmsGroupFoldersFieldData.folderName = '';
    this.selectedDocumentType = [];
    this.documentTypeSearchText = '';
    this.newdocumentTypeSelection = false;
    this.searchByDMSReportTypeMain = 'Default';
    this.groupSearchText = '';
    this.selectedFolderPath = '';
    this.tmsUserTrainingsRepVwDataForGrid = [];
    this.selectedOption = '';
    this.selectedReportType = '';
    this.groupSearchText = '';
    this.documentTypeSearchText = '';
    this.dmsGroupFoldersFieldData = {
      folderName: '',
      folderPath: ''
    };
    this.selectedDocumentType = [];
    this.newdocumentTypeSelection = false;
    this.selectedFolderForCreateDoc = {
      folderPath: ''
    };
    this.physicalFolderLevel = false;
    this.distributedFolderLevel = false;
    this.includeAmendmentsFlg = false;
    this.associatedDocFlg = false;
    this.individualDocFlg = false;
    this.selectedFolderPath = null;
    this.selectedReportType = '';
    this.onSelectedOptionForDMS = 'Default';
    this.tableReportDataList = [];
    this.showTables = false;
    this.showNoRecordFoundMasterIndex = false;
    this.isProcessing = false;
    const manageDMSReportNameAlert = document.getElementById('manageDMSReportNameAlert') as HTMLInputElement;
    const folderMasterAlert = document.getElementById('folderMasterAlert') as HTMLInputElement;
    if (manageDMSReportNameAlert) {
      manageDMSReportNameAlert.style.color = '';
    }
    if (folderMasterAlert) {
      folderMasterAlert.style.color = '';
    }
    this.collectionSize = 0;
    this.totalPages = 0;
    this.itemsPerPage = 10;
    this.currentPage = 1;
    this.selectedQmsGroup = [];
    this.selectedQmsDept = [];
    this.dashboardCountListCR = [];
    this.dashboardCountListCAPA = [];
    this.dashboardCountListDV = [];
    this.dashboardCountListIN = [];
    this.dashboardCountListQI = [];
    this.dashboardCountListAU = [];
    this.dashboardCountListCC = [];
    this.dashboardCountListOOS = [];

    this.dashboardCountListCRAction = [];
    this.dashboardCountListCAPAAction = [];
    this.dashboardCountListDVAction = [];
    this.dashboardCountListINAction = [];
    this.dashboardCountListQIAction = [];
    this.dashboardCountListAUFinding = [];
    this.dashboardCountListCCAction = [];
    this.dashboardCountListOOSAction = [];

    this.dashboardCountListOOSActionsDue = [];
    this.dashboardCountListCRActionDue = [];
    this.dashboardCountListCAPAActionDue = [];
    this.dashboardCountListDVActionDue = [];
    this.dashboardCountListINActionDue = [];
    this.dashboardCountListQIActionDue = [];
    this.dashboardCountListAUFindingDue = [];
    this.dashboardCountListCCActionDue = [];
    this.dashboardCountListOOSActionDue = [];
  }
  resetFunctionTmsReportDropdown() {
    this.specificIntervalVal = true;
    this.toDate = new Date();
    // Set the date 365 days before the current date
    this.fromDate = new Date();
    this.fromDate.setDate(this.toDate.getDate() - 90);
    // Set the minDate and maxDate for the date picker

    this.selectedModule = null;
    this.showCharts = false;
    this.showGroupGrid = false;
    this.selectedGroup = null;
    this.getSelectedInstructorTrainingName = "";
    this.getSelectedTrainingId = null;
    this.searchByInstructorTrainer = [];
    this.searchByDepartmentCodeMain = [];
    this.tableType = "";
  }
  clickedChartVal: any;
  chartDoubleClick(val: any) {
    this.createChartZoom(val);
    this.clickedChartVal = val;

    this.visibleReportPopupForZoom = this.dialog.open(this.reportPopupForZoom, this.reportPopupConfig);
    if (val == 1) {
      this.tableDataListForAll("DMSCount", "", "");
      this.clickedType = "DMSCount";
      this.clickedVal = "DMSCount";
      this.clickedStageStatusVal = "";
    } else if (val == 2) {
      this.tableDataListForAll("DMSStatus", "", "");
      this.clickedType = "DMSStatus";
      this.clickedVal = "DMSStatus";
      this.clickedStageStatusVal = "";
    } else if (val == 3) {
      this.tableDataListForAll("DocType", "", "");
      this.clickedType = "DocType";
      this.clickedVal = "DocType";
      this.clickedStageStatusVal = "";
    }

  }
  cancelReportPopupForZoomFunction() {
    this.visibleReportPopupForZoom.close();
  }

  createChartZoom(val: any) {
    if (val == 1) {
      this.chartOptionsForDMSCountZoom = {
        animationEnabled: true,
        exportEnabled: true,
        zoomEnabled: true,
        zoomType: "xy",
        legend: {
          cursor: "pointer",
          horizontalAlign: "left",
          fontSize: 12,
          fontFamily: "Poppins",
          fontColor: "#0F3659",
          fontWeight: "normal",
        },
        title: {
          text: `Document Count (${this.getTotalCountDmsCountChart()})`,
          fontSize: 18,
          fontFamily: "Poppins",
          horizontalAlign: "left",
          fontColor: "#0F3659",
          fontWeight: "bold",
        },
        axisX: {
          interval: 1,
          tickLength: 0,
          lineThickness: 0,
          labelFontSize: 12,
          labelFontColor: "#0F3659",
          labelFontFamily: "Poppins"
        },
        axisY: {
          gridThickness: 1,
          gridColor: "#DEEBFE80",
          tickLength: 0,
          lineThickness: 0,
          labelFontSize: 12,
          labelFontColor: "#0F3659",
          labelFontFamily: "Poppins"
        },
        toolTip: {
          shared: true
        },
        data: [{
          type: "line",
          name: "Document Count",
          showInLegend: true,
          yValueFormatString: "#,###",
          dataPoints: this.getDataPointsForActivityReport(),
          click: this.handleActivityReportChartClick.bind(this)
        }]

      }
    }
    if (val == 2) {
      this.chartOptionsForStatusZoom = {
        animationEnabled: true,
        exportEnabled: true,
        zoomEnabled: true,
        zoomType: "xy",
        toolbar: {
          itemBackgroundColor: "#d3d3d3",
          itemBackgroundColorOnHover: "#3e3e3e",
          buttonBorderColor: "#3e3e3e",
          icon: {
            zoom: {
              backgroundColor: "#007BFF", // Set the background color for the zoom icon
              borderColor: "#007BFF",     // Set the border color for the zoom icon
              borderWidth: 1             // Set the border width for the zoom icon
            }
          }
        },
        legend: {
          cursor: "pointer",
          fontFamily: "Poppins",
          fontColor: "#0F3659"
        },
        title: {
          text: `Status (${this.getTotalCountStatusCountChart()})`,
          fontSize: 20,
          fontFamily: "Poppins",
          horizontalAlign: "left",
          fontColor: "#0F3659",
          fontWeight: "bold",
          click: function (e: any) {
            // Your title click event handler logic goes here
            console.log("Title clicked!");
          }
        },
        data: [{
          type: "pie",
          startAngle: -90,
          indexLabel: "{status}:{count}",
          showInLegend: true,
          legendText: "{indexLabel}",
          yValueFormatString: "#,###.##''",
          dataPoints: this.getDataPointsForStatusCount(),
          click: this.handleStatusCountChartClick.bind(this) // Reference the click event handler for the entire pie chart
        }]
      }
    }
    if (val == 3) {
      this.chartOptionsForDocTypeZoom = {
        animationEnabled: true,
        exportEnabled: true,
        legend: {
          cursor: "pointer",
        },
        title: {
          text: `Document Type (${this.getTotalCountDocTypeChart()})`,
          fontSize: 20,
          fontFamily: "Poppins",
          horizontalAlign: "left",
          fontColor: "#0F3659",
          fontWeight: "bold",
          click: function (e: any) {
            console.log("Title clicked!");
          }
        },
        dataPointMaxWidth: 38,
        dataPointMinWidth: 38,
        scrollablePlotArea: {
          scrollEnabled: this.typeNameList.length > 10,  // Enable scrolling if data points are more than 10
          unit: "pixel",
          maxWidth: 1000,  // Set a larger width for the chart to force horizontal scroll
        },

        axisY: {
          gridThickness: 1,
          gridColor: "#DEEBFE80",
          tickLength: 0,
          lineThickness: 0,
          labelFontSize: 12,
          labelFontColor: "#0F3659",
          labelFontFamily: "Poppins"
        },
        axisX: {
          tickLength: 0,
          lineThickness: 0,
          labelAngle: this.typeNameList.length > 25 ? -45 : 0,
          interval: 1,
          labelFontSize: 12,
          labelFontColor: "#0F3659",
          labelFontFamily: "Poppins",
          labelFormatter: function (e: { label: any; value: string; }) {
            let label = null;
            if (e.label != null) {
              if (e.label.length > 15) {
                label = e.label.substring(0, 14) + '...';
              } else {
                label = e.label;
              }
            }
            return label;
          }
        },
        data: [{
          type: "column",
          color: "#00A6A9",
          indexLabel: "{y}",
          indexLabelFontColor: "#0F3659",
          indexLabelFontSize: 12,
          indexLabelFontFamily: "Poppins",
          dataPoints: this.getDataPointsForDocType(),
          click: this.handleDocTypeChartClick.bind(this)
        }]
      };
    }
  }


  tableDataList1(type: any, valueOfWhere: any, stageNameForTable: any) {
    console.log("tableDataList");
    let whereVals;
    if (type == "DMSCount") {
      this.showReportFlagValue = 1;
      whereVals = " WHERE AXIS_VALUE='" + valueOfWhere + "'"
    } else if (type == "DMSStatus") {
      this.showReportFlagValue = 1;
      whereVals = " WHERE STATUS='" + valueOfWhere + "'"
    } else if (type == "DocType") {
      this.showReportFlagValue = 1;
      whereVals = " WHERE DOCUMENT_TYPE_NAME='" + valueOfWhere + "'";
    }
    this.whereValsForExcel = whereVals;
    this.dynamicGridName = "INTERVALS_MAIN_REP";
    this.dynamicGridViewName = "DMS_INTERVALS_MAIN_REP_VW";
    if (this.showReportFlagValue == 1) {
      this.getcallMethodDmsChart(whereVals);
    }
  }

  getcallMethodDmsChart(whereVals: any) {

    this.whereValsForExcel = whereVals;
    this.isProcessing = true;

    this.tmsUserTrainingsRepVwDataForGrid = [];
    const data = {
      orgId: this.selectedOrgValue[0],
      gridName: "INTERVALS_MAIN_REP",
      groupId: null,
      mainOrg: "Yes"
    }
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {

        response.orderByClause ??= "";
        this.makeStickyColumns = response.fixedFieldCnt;
        const data1: any = {
          orgId: this.selectedOrgValue[0].toString(),

          gridName: this.dynamicGridViewName,
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          selectedUserId: null,
          manualEntryDataFields: `EFFECTIVE_DATE,EXPIRATION_DATE${response.manualEntryDataFields ? ',' + response.manualEntryDataFields : ''}`,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || "",
          mainOrg: "Yes",
          groupId: null,
          module: "DOCS",
          dateRangeAt: this.selectedDateRangeValue,
          fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
          toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
          intervals: this.selectedIntervalValue,
          stageName: null,
          status: null,
          wherVal: whereVals
        }

        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.isProcessing = false;
            this.tmsUserTrainingsRepVwDataForGrid = response1;
            this.showNoRecordFoundInventry = this.tmsUserTrainingsRepVwDataForGrid.length === 0;
            console.log('Data populated:', this.tmsUserTrainingsRepVwDataForGrid);
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            let rendereddata: any;
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const fieldSize of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(fieldSize + 'px');
            }
            for (let y = this.columnLists.columnsListarray.length - 1; y >= 0; y--) {
              for (const invisibleColumn of this.columnLists.invisibleColumnarray) {
                if (this.columnLists.columnsListarray[y] === invisibleColumn) {
                  this.columnLists.columnsListarray.splice(y, 1);
                  this.columnLists.fieldColumnarray.splice(y, 1);
                  this.columnLists.fieldSizeListArray.splice(y, 1);
                  break; // Exit the inner loop once a match is found
                }
              }
            }

            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const dataType of this.dataTypeList) {
                  if (dataType.columnName === this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = dataType.fieldType;
                  }
                }
              }
              for (const training of this.tmsUserTrainingsRepVwDataForGrid) {
                for (const dataType of this.dataTypeList) {
                  if (dataType.fieldType === 'CHECKBOX') {
                    training[dataType.columnName] = training[dataType.columnName] === "Y";
                  }
                }
              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.setPageDMS1(1, 0);
            });
            this.message.gridList = this.tmsUserTrainingsRepVwDataForGrid;
            this.collectionSize = this.tmsUserTrainingsRepVwDataForGrid.length;
            this.totalPages = Math.ceil(this.tmsUserTrainingsRepVwDataForGrid.length / this.itemsPerPage);
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }
  tableDataListForAll(type: any, valueOfWhere: any, stageNameForTable: any) {
    console.log("tableDataList");
    let whereVals = "";
    this.showReportFlagValue = 1;
    this.whereValsForExcel = whereVals;

    if (this.showReportFlagValue == 1) {
      this.getcallMethodDmsChart(whereVals);
    }
  }
  setPage1(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.tableReportDataList.length, page, this.perPage, targetpage);
    if (this.tableReportDataList.length > 0) {
      this.pagedItems = this.tableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }
  paginationCall1(value: number) {
    this.perPage = value;
    this.setPage1(this.pager.currentPage, 0);
  }
  getDataPointsForDocType() {
    const dataPoints = this.typeNameList.map((doc: { count: any; documentTypeName: any; }) => ({
      label: `${doc.documentTypeName}`,
      y: doc.count
    }));
    return dataPoints;
  }

  getDataPointsForStatusCount() {
    const dataPoints = this.statusList.map((item: { count: any; status: any; }, index: any) => ({
      y: item.count,
      indexLabel: `${item.status}:${item.count}`,
      color: this.colorMethod(item.status, index)
    }));
    return dataPoints;
  }
  getDataPointsForActivityReport() {
    const dataPoints = this.dmsCountList.map((item: { axisValue: any; count: any; }) => ({
      label: item.axisValue,
      y: item.count
    }));
    return dataPoints;
  }

  handleDocTypeChartClick(e: any): void {
    this.titleName = "Document Type"
    this.visibleReportPopupForDmsChart = this.dialog.open(this.reportPopupForDMSChart, this.reportPopupConfig);
    this.tableDataList1("DocType", this.typeNameList[e.dataPointIndex].documentTypeName, "");
    this.clickedType = "Doc Type";
    this.clickedVal = this.typeNameList[e.dataPointIndex].documentTypeName;
    this.clickedStageStatusVal = "";
  }
  getTotalCountDocTypeChart() {
    return this.typeNameList.reduce((total: number, item: { count: number }) => total + item.count, 0);
  }
  handleStatusCountChartClick(e: any): void {
    this.titleName = "DMS Status"
    this.visibleReportPopupForDmsChart = this.dialog.open(this.reportPopupForDMSChart, this.reportPopupConfig);
    this.tableDataList1("DMSStatus", this.statusList[e.dataPointIndex].status, "");
    this.clickedType = "DMS Status";
    this.clickedVal = this.statusList[e.dataPointIndex].status;
    this.clickedStageStatusVal = "";
  }
  getTotalCountStatusCountChart() {
    return this.statusList.reduce((total: number, item: { count: number }) => total + item.count, 0);
  }
  handleActivityReportChartClick(e: any): void {
    this.titleName = "Document Count"
    this.visibleReportPopupForDmsChart = this.dialog.open(this.reportPopupForDMSChart, this.reportPopupConfig);
    this.tableDataList1("DMSCount", this.dmsCountList[e.dataPointIndex].axisValue, "");
    this.clickedType = "DMS Count";
    this.clickedVal = this.dmsCountList[e.dataPointIndex].axisValue;
    this.clickedStageStatusVal = "";
  }
  getTotalCountDmsCountChart() {
    return this.dmsCountList.reduce((total: number, item: { count: number }) => total + item.count, 0);
  }

  prepareChartData() {
    console.log("this.uniqueOrgNames.length==", this.uniqueOrgNames.length);
    if (this.uniqueOrgNames.length == 1) {
      const chartData = this.moduless.map((module: string) => {
        return {
          label: module,
          y: this.getTotalCountBymodule(module)
        };
      });
      this.tableType = "single";
      return chartData;
    } else {
      const chartData = this.uniqueOrgNames.map((org: string) => {
        const totalCount = this.moduless.reduce((total: number, module: string) => {
          return total + this.getTotalCount(org, module);
        }, 0);
        return {
          label: org,
          y: totalCount
        };
      });
      this.tableType = "multi";
      return chartData;
    }
  }
  prepareChartDataForGroup() {
    const chartData = this.uniqueOrgNamesForGroup.map((groupName: string) => {
      const totalCount = this.modulesForGroup.reduce((total: number, module: string) => {
        return total + this.getTotalCountForGroup(groupName, module);
      }, 0);
      return {
        label: groupName,
        y: totalCount
      };
    });
    return chartData;
  }



  getYAxisInterval() {
    const maxValue = Math.max(...this.orgChartClickDataList.map((item: { cnt: number }) => item.cnt));
    if (maxValue <= 5) {
      return 1;
    } else if (maxValue <= 10) {
      return 2;
    } else if (maxValue <= 50) {
      return 5;
    } else if (maxValue <= 100) {
      return 10;
    } else if (maxValue <= 500) {
      return 50;
    } else if (maxValue <= 1000) {
      return 100;
    } else {
      return 200; // Adjust based on your data range
    }
  };
  configureChart(chartData: any) {
    this.chartOptionsForOrgTotal = {
      animationEnabled: true,
      exportEnabled: true,
      zoomEnabled: true,
      zoomType: "xy",
      toolbar: {
        itemBackgroundColor: "#d3d3d3",
        itemBackgroundColorOnHover: "#3e3e3e",
        buttonBorderColor: "#3e3e3e",
        icon: {
          zoom: {
            backgroundColor: "#007BFF", // Set the background color for the zoom icon
            borderColor: "#007BFF",     // Set the border color for the zoom icon
            borderWidth: 1             // Set the border width for the zoom icon
          }
        }
      },
      legend: {
        cursor: "pointer",
        maxWidth: 370,
        horizontalAlign: "left",
        fontSize: 12,
        fontFamily: "Poppins",
        fontColor: "#0F3659",
        fontWeight: "normal",
      },
      title: {
        text: "Organization",
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          // Your title click event handler logic goes here
          console.log("Title clicked!");
        }
      },
      data: [{
        type: "pie",
        startAngle: -90,
        indexLabel: "{label}:{y}",
        showInLegend: true,
        legendText: "{label}",
        yValueFormatString: "#,###.##''",
        dataPoints: chartData,
        click: this.handleOrgChartClick.bind(this) // Reference the click event handler for the entire pie chart
      }]
    };
    this.chartOptionsForModulesTotal = {
      animationEnabled: true,
      exportEnabled: true,
      legend: {
        cursor: "pointer",
      },
      title: {
        text: 'Modules',
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          console.log("Title clicked!");
        }
      },
      dataPointMaxWidth: 38,
      dataPointMinWidth: 38,

      axisY: {
        // gridThickness: 1,
        // gridColor: "#DEEBFE80",
        // tickLength: 0,
        gridThickness: this.orgChartClickDataList.length === 1 ? 0 : 1,
        gridColor: "#DEEBFE",
        tickLength: this.orgChartClickDataList.length === 1 ? 0 : 5,
        lineThickness: 0,
        // labelFontSize: 12,
        labelFontSize: this.orgChartClickDataList.length === 1 ? 0 : 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE",
        interval: this.getYAxisInterval(),
        labelFormatter: (e: any) => {
          return this.orgChartClickDataList.length === 1 ? "" : e.value;
        }
      },
      // axisY: {
      //   gridThickness: 1,
      //   gridColor: "#DEEBFE80",
      //   tickLength: 0,
      //   lineThickness: 0,
      //   labelFontSize: 12,
      //   labelFontColor: "#0F3659",
      //   labelFontFamily: "Poppins"
      // },
      axisX: this.orgChartClickDataList.length === 1 ? {
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any; }) => e.label,
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      } : {
        tickLength: 5,
        lineThickness: 1,
        labelAngle: this.orgChartClickDataList.length > 15 ? -45 : 0,
        interval: 1,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any }) => {
          let formattedLabel = null;
          if (e.label != null) {
            if (e.label.length > 10) {
              formattedLabel = e.label.substring(0, 9) + '...';
            } else {
              formattedLabel = e.label;
            }
          }
          return formattedLabel;
        }, lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      },
      // axisX: {
      //   tickLength: 0,
      //   startAngle: 0,
      //   lineThickness: 0,
      //   labelAngle: 0, // Rotate the labels at a 45-degree angle
      //   interval: 1, // Show every label
      //   labelFontSize: 12,
      //   labelFontColor: "#0F3659",
      //   labelFontFamily: "Poppins",
      //   labelFormatter: function (e: { label: any; value: string; }) {
      //     if (e.label == null) {
      //       return null;
      //     }

      //     if (e.label.length > 10) {
      //       return e.label.substring(0, 9) + '...';
      //     }
      //     return e.label;
      //   }
      // },
      data: [{
        type: "column", // Use "horizontalBar" for horizontal bar chart
        color: "#00A6A9",
        // width: 700,
        indexLabel: "{y}",
        indexLabelFontColor: "#0F3659",
        indexLabelFontSize: 12,
        indexLabelFontFamily: "Poppins",
        dataPoints: chartData,
        click: this.handleModuleChartClick.bind(this)
      }]
    };
    this.lineChartOptionsForOrgTotal = {
      animationEnabled: true,
      exportEnabled: true,
      zoomEnabled: true,
      zoomType: "xy",
      legend: {
        cursor: "pointer",
        horizontalAlign: "left",
        fontSize: 12,
        fontFamily: "Poppins",
        fontColor: "#0F3659",
        fontWeight: "normal",
      },
      dataPointMaxWidth: 10,
      title: {
        text: "Total",
        fontSize: 18,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
      },
      axisX: {
        interval: 1,
        tickLength: 0,
        lineThickness: 0,
        gridThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
      },
      axisY: {
        tickLength: 0,
        gridThickness: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
      },
      toolTip: {
        shared: true
      },
      data: this.dataPointsMultiLineTotal()
    };

    this.lineChartOptionsForOrgOverdue = {
      animationEnabled: true,
      exportEnabled: true,
      zoomEnabled: true,
      zoomType: "xy",
      legend: {
        cursor: "pointer",
        horizontalAlign: "left",
        fontSize: 12,
        fontFamily: "Poppins",
        fontColor: "#0F3659",
        fontWeight: "normal",
      },
      dataPointMaxWidth: 10,
      title: {
        text: "Overdue",
        fontSize: 18,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
      },
      axisX: {
        interval: 1,
        tickLength: 0,
        lineThickness: 0,
        gridThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins"
      },
      axisY: {
        tickLength: 0,
        gridThickness: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins"
      },
      toolTip: {
        shared: true
      },
      data: this.dataPointsMultiLineForOverdue()
    };


    try {
      let chart = new CanvasJS.Chart("chartContainer2", this.lineChartOptionsForOrgTotal);
      chart.render();
    } catch (error) {
      console.log("error", error);
    }

    try {
      let chart = new CanvasJS.Chart("chartContainer3", this.lineChartOptionsForOrgOverdue);
      chart.render();
    } catch (error) {
      console.log("error", error);
    }
  }

  handleOrgChartClick(e: any): void {
    console.log('Pie chart clicked:', e);
    console.log('Pie chart clicked:', e.dataPointIndex);
    this.titleName = "Organization Report"
    this.tableDataList(this.orgChartClickDataList[e.dataPointIndex].label, null, 'All', 'o');
  }

  handleModuleChartClick(e: any): void {
    console.log('Pie chart clicked:', e);
    console.log('Pie chart clicked:', e.dataPointIndex);
    this.titleName = "Module Report";
    console.log('org==:', this.orgChartClickDataList[e.dataPointIndex].label);
    this.tableDataList('', this.orgChartClickDataList[e.dataPointIndex].label, 'All', 'o');
  }
  handleGroupChartClick(e: any): void {
    console.log('Pie chart clicked:', e);
    console.log('Pie chart clicked:', e.dataPointIndex);
    this.titleName = "Group Report";
    console.log('org==:', this.chartDataForGroupClick[e.dataPointIndex].label);
    this.tableDataList(this.chartDataForGroupClick[e.dataPointIndex].label, this.selectedModules, 'All', 'g');
  }
  tableDataList(org: any, module: any, status: any, val: any) {
    this.typeOfGrid = "st";
    console.log("org=", org);
    console.log("module=", module)
    console.log("status=", status)
    console.log("val=", val)
    this.item = "";
    this.item1 = "";
    let selectedOrgValue1 = "";
    let selectedQmsGroup1 = "";
    let selectedQmsDept1 = "";

    if (this.selectedModule == null) {
      this.selectedModules = module;
    } else {
      this.selectedModules = this.selectedModule;

    }
    if (this.selectedQmsDept.length != 0) {
      for (let j = 0; j < this.selectedQmsDept.length; j++) {
        selectedQmsDept1 += "'" + this.selectedQmsDept[j] + "'";
        selectedQmsDept1 += j == this.selectedQmsDept.length - 1 ? "" : ",";
      }
    }

    if (this.selectedOrgValue.length != 0) {
      for (let j = 0; j < this.selectedOrgValue.length; j++) {
        selectedOrgValue1 += this.selectedOrgValue[j];
        selectedOrgValue1 += j == this.selectedOrgValue.length - 1 ? "" : ",";
      }
    }


    if (this.selectedQmsGroup.length != 0) {
      for (let j = 0; j < this.selectedQmsGroup.length; j++) {
        selectedQmsGroup1 += "'" + this.selectedQmsGroup[j] + "'";
        selectedQmsGroup1 += j == this.selectedQmsGroup.length - 1 ? "" : ",";
      }
    }

    this.whereValsForExcel = "";
    if (val == 'o' && org != '') {
      console.log("org")
      const itemObj = this.dashboardCountList.find((element: { orgLongName: any; }) => element.orgLongName === org);
      this.item = itemObj.orgId;
      this.item1 = "";
      if (status == "All") {
        this.whereValsForExcel = "";
      } else if (status == "Open") {
        this.whereValsForExcel = " AND CHART_STATUS='Open'";
      } else if (status == "Closed") {
        this.whereValsForExcel = " AND CHART_STATUS='Closed'";
      } else if (status == "Overdue") {
        this.whereValsForExcel = " AND CHART_STATUS='Open' AND OVERDUE='Y'";
      } else if (status == "Total") {
        this.whereValsForExcel = " AND CHART_STATUS!='Deleted/Obsoleted'";
      }
    }
    else if (val == 'o' && org == '') {
      this.item = this.selectedOrgValue[0] ? this.selectedOrgValue[0] : null;
      this.item1 = "";
      if (status == "All") {
        this.whereValsForExcel = "";
      } else if (status == "Open") {
        this.whereValsForExcel = " AND CHART_STATUS='Open'";
      } else if (status == "Closed") {
        this.whereValsForExcel = " AND CHART_STATUS='Closed'";
      } else if (status == "Overdue") {
        this.whereValsForExcel = " AND CHART_STATUS='Open' AND OVERDUE='Y'";
      } else if (status == "Total") {
        this.whereValsForExcel = " AND CHART_STATUS!='Deleted/Obsoleted'";
      }

    }
    else if (val == 'g') {
      const itemObj = this.dashboardGroupCountList.find((element: { groupName: any; }) => element.groupName === org);
      const groupIdVal = itemObj.groupId;
      let selectedOrgValue1 = "";
      if (this.selectedOrgValue.length > 0) {
        for (let j = 0; j < this.selectedOrgValue.length; j++) {
          selectedOrgValue1 += this.selectedOrgValue[j];
          selectedOrgValue1 += j == this.selectedOrgValue.length - 1 ? "" : ",";
        }
        this.item = null;
        this.item1 = selectedOrgValue1;
      } else {
        this.item = this.selectedOrgValue[0] ? this.selectedOrgValue[0] : null;
        this.item1 = null;
      }
      if (status == "All") {
        this.whereValsForExcel = " AND GROUP_ID=" + groupIdVal + "";
      }

    }


    if (selectedQmsGroup1) {
      this.whereValsForExcel = this.whereValsForExcel + " AND GROUP_NAME in(" + selectedQmsGroup1 + ")";
    }
    if (selectedQmsDept1) {
      this.whereValsForExcel = this.whereValsForExcel + " AND DEPT_CODE in(" + selectedQmsDept1 + ")";
    }

    let data = {
      groupId: null,
      module: this.selectedModules,
      dateRangeAt: this.specificIntervalVal ? 'CREATED' : null,
      fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
      toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
      intervals: this.selectedIntervalValue ? this.selectedIntervalValue : null,
      stageName: null,
      status: null,
      deptCode: null,
      annualRefNo: null,
      refno: null,
      taskId: this.item1,
      taskNo: this.item,
      groupIds: selectedQmsGroup1,
      deptIds: selectedQmsDept1,
      wherVal: this.whereValsForExcel
    }
    this.isProcessing = true;
    console.log("data=", data);
    forkJoin([this.appService.getDashboardTableList(data)]).subscribe(([dataList]) => {
      this.dashboardTableListVal = dataList;
      console.log("dashboardTableListVal=", this.dashboardTableListVal);
      this.calculateTotalPages = this.collectionSize / this.perPage;
      this.pager.totalPages = undefined;
      this.collectionSize = this.dashboardTableListVal.length;
      this.totalPages = Math.ceil(this.dashboardTableListVal.length / this.itemsPerPage);
      this.setPage(1, 0);
      this.clickedVal = module + "-" + this.selectedType + "-" + status;

      console.log(" this.clickedVal===", this.clickedVal);
      this.visibleReportPopup = this.dialog.open(this.reportPopup, this.reportPopupConfig);
      this.isProcessing = false;
    });

    this.columnList = "Organization Long Name,Organization Short Name,Module,Group Name,Is Group Active,Temp Task No,Task ID,Status,Task Type,Expected To Be Started On,Expected Closure On,Overdue,Chart Status,Stage Name,Short Description,Dept Code,Dept Name,Requested At,Core Business Area Name,Initiator Name,Initiator Fullname,Owner Name,Owner Fullname,Description,QA Acceptor / Schedule Approved By Fullname,QA Approver/Plan Approved By Fullname,Investigator Fullname,Created On,Started On,Completed On,Reopen or Revoked On,Final No Generated,Is Q and A Required,Effectiveness Check Required,Investigation Required,Final Risk Status,Stop Reminders,Last Action From Status,Last Action On";
  }
  configureChartForGroup(chartDataForGroup: any) {
    this.lineChartOptionsForOrgTotal = {
      animationEnabled: true,
      exportEnabled: true,
      zoomEnabled: true,
      zoomType: "xy",
      legend: {
        cursor: "pointer",
        horizontalAlign: "left",
        fontSize: 12,
        fontFamily: "Poppins",
        fontColor: "#0F3659",
        fontWeight: "normal",
      },
      dataPointMaxWidth: 10,
      title: {
        text: "Total",
        fontSize: 18,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
      },
      axisX: {
        interval: 1,
        tickLength: 0,
        lineThickness: 0,
        gridThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
      },
      axisY: {
        tickLength: 0,
        gridThickness: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
      },
      toolTip: {
        shared: true
      },
      data: this.dataPointsMultiLineTotal(),
    };
    this.lineChartOptionsForOrgOverdue = {
      animationEnabled: true,
      exportEnabled: true,
      zoomEnabled: true,
      zoomType: "xy",
      legend: {
        cursor: "pointer",
        horizontalAlign: "left",
        fontSize: 12,
        fontFamily: "Poppins",
        fontColor: "#0F3659",
        fontWeight: "normal",
      },
      dataPointMaxWidth: 10,
      title: {
        text: this.showPercentage ? "Overdue Count In %" : "Overdue Count",
        fontSize: 18,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
      },
      axisX: {
        interval: 1,
        tickLength: 0,
        lineThickness: 0,
        gridThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins"
      },
      axisY: {
        tickLength: 0,
        gridThickness: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins"
      },
      toolTip: {
        shared: true
      },
      data: this.dataPointsMultiLineForOverdue()
    };
    try {
      let chart = new CanvasJS.Chart("chartContainer2", this.lineChartOptionsForOrgTotal);
      chart.render();
    } catch (error) {
      console.log("error", error);
    }
    try {
      let chart = new CanvasJS.Chart("chartContainer3", this.lineChartOptionsForOrgOverdue);
      chart.render();
    } catch (error) {
      console.log("error", error);
    }
  }
  dataPointsMultiLineForOverdue() {
    const data = [];
    const groupedData = this.groupBy(this.overdueLineChart, 'orgLongName');
    for (const orgLongName in groupedData) {
      if (groupedData.hasOwnProperty(orgLongName)) {
        const groupData = groupedData[orgLongName];
        const dataPoints = this.getDataPointsForGroupLine(groupData);
        console.log("dataPoints2=", JSON.stringify(dataPoints));
        if (this.showPercentage) {
          data.push({
            type: "line",
            name: orgLongName,
            indexLabel: "{y}%",
            percentFormatString: "#0.##",
            toolTipContent: "{y}%",
            showInLegend: "true",
            yValueFormatString: "#,###",
            dataPoints: dataPoints,
          });
        } else {
          data.push({
            type: "line",
            name: orgLongName,
            showInLegend: "true",
            yValueFormatString: "#,###",
            dataPoints: dataPoints,
          });
        }
      }
    }
    return data;
  }

  dataPointsMultiLineTotal() {
    const data = [];
    const groupedData = this.groupBy(this.totalLineChart, 'orgLongName');
    for (const orgLongName in groupedData) {
      if (groupedData.hasOwnProperty(orgLongName)) {
        const groupData = groupedData[orgLongName];
        const dataPoints = this.getDataPointsForGroupLineTotal(groupData);
        data.push({
          type: "line",
          name: orgLongName,
          showInLegend: "true",
          yValueFormatString: "#,###",
          dataPoints: dataPoints,
        });
      }
    }
    console.log("data==" + JSON.stringify(data));
    return data;
  }
  getDataPointsForGroupLineTotal(totalLineChart: any[]) {
    console.log("totalLineChart=", totalLineChart);
    const aggregatedData: { [key: string]: number } = {};
    const seqValues: { [key: string]: number } = {};
    totalLineChart.forEach((ac: { count: any; axisValue: any; seq: any }) => {
      const axisValue = ac.axisValue ? ac.axisValue.toString() : 'Unknown';
      const count = ac.count ? Number.parseInt(ac.count, 10) : 0;
      const seqvalue = ac.seq ? Number.parseInt(ac.seq, 10) : 0; // Adjust the extraction of seqvalue as needed
      if (aggregatedData.hasOwnProperty(axisValue)) {
        aggregatedData[axisValue] += count;
      } else {
        aggregatedData[axisValue] = count;
        seqValues[axisValue] = seqvalue; // Store the seqvalue for each axisValue
      }
    });
    const dataPoints = Object.keys(aggregatedData).map(axisValue => ({
      label: axisValue,
      y: aggregatedData[axisValue],
      x: seqValues[axisValue] // Include the seqvalue
    }));
    console.log('Data Points:', dataPoints);
    return dataPoints;
  }

  getDataPointsForGroupLine(totalLineChart: any[]) {
    console.log("totalLineChart=", totalLineChart);
    const aggregatedData: { [key: string]: number } = {};
    const seqValues: { [key: string]: number } = {};
    totalLineChart.forEach((ac: { count: any; axisValue: any; pcnt: any; seq: any }) => {
      const axisValue = ac.axisValue.toString();
      const seqvalue = ac.seq ? Number.parseInt(ac.seq, 10) : 0; // Adjust the extraction of seqvalue as needed

      if (this.showPercentage) {
        if (aggregatedData.hasOwnProperty(axisValue)) {
          aggregatedData[axisValue] += ac.pcnt;
        } else {
          aggregatedData[axisValue] = ac.pcnt;
          seqValues[axisValue] = seqvalue;
        }

      } else if (aggregatedData.hasOwnProperty(axisValue)) {
        aggregatedData[axisValue] += ac.count;
      } else {
        aggregatedData[axisValue] = ac.count;
        seqValues[axisValue] = seqvalue;  // Adjust the extraction of seqvalue as needed
      }
    });
    const dataPoints = Object.keys(aggregatedData).map(axisValue => ({
      label: axisValue,
      y: aggregatedData[axisValue],
      x: seqValues[axisValue] // Include the seqvalue
    }));
    console.log('Data Points:', dataPoints);
    return dataPoints;
  }
  groupBy(array: any[], key: string) {
    return array.reduce((acc, obj) => {
      const property = obj[key];
      acc[property] = acc[property] || [];
      acc[property].push(obj);
      return acc;
    }, {});
  }

  getGroupDetails(modules: any) {
    this.selectedModules = modules;

    if (this.selectedOrgValue.length < 1) {
      const field = document.getElementById('groupNameAlert') as HTMLInputElement;
      field.style.color = 'red';
    } else if (this.specificIntervalVal && this.fromDate && this.toDate && (this.toDate < this.fromDate)) {
      alert('To Date cannot be before From Date');
    } else if (this.specificIntervalVal && (this.fromDate == null || this.fromDate == "" || this.fromDate == undefined)) {
      const field = document.getElementById('fromDateAlert') as HTMLInputElement;
      field.style.color = 'red';
    } else if (this.specificIntervalVal && (this.toDate == null || this.toDate == "" || this.toDate == undefined)) {
      const field = document.getElementById('toDateAlert') as HTMLInputElement;
      field.style.color = 'red';
    } else {
      let selectedQmsGroup1 = "";
      let selectedQmsDept1 = "";

      if (this.selectedQmsGroup.length != 0) {
        for (let j = 0; j < this.selectedQmsGroup.length; j++) {
          selectedQmsGroup1 += "'" + this.selectedQmsGroup[j] + "'";
          selectedQmsGroup1 += j == this.selectedQmsGroup.length - 1 ? "" : ",";
        }
      }

      if (this.selectedQmsDept.length != 0) {
        for (let j = 0; j < this.selectedQmsDept.length; j++) {
          selectedQmsDept1 += "'" + this.selectedQmsDept[j] + "'";
          selectedQmsDept1 += j == this.selectedQmsDept.length - 1 ? "" : ",";
        }
      }
      let selectedOrgValue1 = "";
      if (this.selectedOrgValue.length != 0) {
        for (let j = 0; j < this.selectedOrgValue.length; j++) {
          selectedOrgValue1 += this.selectedOrgValue[j];
          selectedOrgValue1 += j == this.selectedOrgValue.length - 1 ? "" : ",";
        }
      }
      let data = {
        groupId: null,
        module: modules,
        dateRangeAt: this.specificIntervalVal ? 'CREATED' : null,
        fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
        toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
        intervals: this.selectedIntervalValue ? this.selectedIntervalValue : null,
        stageName: null,
        status: null,
        deptCode: null,
        annualRefNo: null,
        refno: null,
        taskId: selectedOrgValue1,
        groupIds: selectedQmsGroup1,
        deptIds: selectedQmsDept1,
        taskNo: this.selectedOrgValue[0] ? this.selectedOrgValue[0] : null,
      }
      this.isProcessing = true;
      forkJoin([
        this.appService.getDashboardGroupCountList(data),
        this.appService.getDashboardCountListForlineChart(data),
        this.appService.getDashboardCountListForlineChartOverduePercentage(data),
      ]).subscribe({
        next: ([
          dashboardCountGroupListVal,
          dashboardCountListForlineChart,
          dashboardCountListForlineChartOverdue,
        ]) => {
          this.dashboardGroupCountList = dashboardCountGroupListVal;

          this.excelGroupDashboardCountList = this.generateGroupSummary(
            this.dashboardGroupCountList
          );

          this.totalLineChart = dashboardCountListForlineChart;
          this.overdueLineChart = dashboardCountListForlineChartOverdue;

          this.uniqueOrgNamesForGroup = Array.from(
            new Set(
              this.dashboardGroupCountList.map(
                (data: { groupName: any }) => data.groupName
              )
            )
          );

          this.modulesForGroup = Array.from(
            new Set(
              this.dashboardGroupCountList.map(
                (data: { module: any }) => data.module
              )
            )
          );

          const chartDataForGroup = this.prepareChartDataForGroup();

          this.chartDataForGroupClick = chartDataForGroup;

          console.log("chartDataForGroup=", chartDataForGroup);

          this.configureChartForGroup(chartDataForGroup);

          this.chartOptionsForGroupTotal = {
            animationEnabled: true,
            exportEnabled: true,
            legend: {
              cursor: "pointer",
            },
            title: {
              text: "Group",
              fontSize: 20,
              fontFamily: "Poppins",
              horizontalAlign: "left",
              fontColor: "#0F3659",
              fontWeight: "bold",
              click: function (e: any) {
                console.log("Title clicked!");
              },
            },
            dataPointMaxWidth: 20,
            dataPointMinWidth: 20,
            axisY: {
              gridThickness: 1,
              gridColor: "#DEEBFE80",
              tickLength: 0,
              lineThickness: 0,
              labelFontSize: 12,
              labelFontColor: "#0F3659",
              labelFontFamily: "Poppins",
            },
            axisX: {
              tickLength: 0,
              startAngle: -45,
              lineThickness: 0,
              labelAngle: -45,
              interval: 1,
              labelFontSize: 12,
              labelFontColor: "#0F3659",
              labelFontFamily: "Poppins",
              labelFormatter: function (e: {
                label: any;
                value: string;
              }) {
                let labelValue = null;

                if (e.label != null) {
                  labelValue =
                    e.label.length > 10
                      ? e.label.substring(0, 9) + "..."
                      : e.label;
                }

                return labelValue;
              },
            },
            data: [
              {
                type: "column",
                color: "#00A6A9",
                indexLabel: "{y}",
                indexLabelFontColor: "#0F3659",
                indexLabelFontSize: 12,
                indexLabelFontFamily: "Poppins",
                dataPoints: chartDataForGroup,
                click: this.handleGroupChartClick.bind(this),
              },
            ],
          };

          this.showGroupGrid = true;
          this.isProcessing = false;

          setTimeout(() => {
            const chart = new CanvasJS.Chart(
              "chartContainer",
              this.chartOptionsForGroupTotal
            );

            chart.render();
          }, 100);
        },
        error: (error) => {
          console.error("Error in forkJoinObservable:", error);
        },
      });
    }
  }
  @ViewChild('captureDiv11') captureDiv11!: ElementRef;
  captureElementTMS(): void {
    const element = this.captureDiv11.nativeElement;
    html2canvas(element, {
      scrollX: -window.scrollX,
      scrollY: -window.scrollY,
      windowWidth: document.documentElement.offsetWidth,
      windowHeight: document.documentElement.offsetHeight,
    }).then(canvas => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
      pdf.save(this.selectedOption + '.pdf');
    });
  }
  @ViewChild('captureDiv') captureDiv!: ElementRef;
  captureElement(): void {
    const element = this.captureDiv.nativeElement;
    html2canvas(element, {
      scrollX: -window.scrollX,
      scrollY: -window.scrollY,
      windowWidth: document.documentElement.offsetWidth,
      windowHeight: document.documentElement.offsetHeight,
    }).then(canvas => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
      pdf.save(this.modulesForGroup + '-Groups.pdf');
    });
  }
  @ViewChild('captureDiv1') captureDiv1!: ElementRef;
  captureElement1(): void {
    const element = this.captureDiv1.nativeElement;
    html2canvas(element, {
      scrollX: -window.scrollX,
      scrollY: -window.scrollY,
      windowWidth: document.documentElement.offsetWidth,
      windowHeight: document.documentElement.offsetHeight,
    }).then(canvas => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
      pdf.save('Organization.pdf');
    });
  }

  @ViewChild('captureDivTOD') captureDivTOD!: ElementRef;
  captureElementTOD(): void {

    const chart1 = document.getElementById('chartContainer2');
    const chart2 = document.getElementById('chartContainer3');

    if (!chart1 || !chart2) {
      console.error('Charts not found in DOM');
      return;
    }

    // 🔥 wait for charts to render
    setTimeout(() => {

      Promise.all([
        html2canvas(chart1, {
          useCORS: true,
          allowTaint: true,
          scale: 2
        }),
        html2canvas(chart2, {
          useCORS: true,
          allowTaint: true,
          scale: 2
        })
      ]).then(([canvas1, canvas2]) => {

        const pdf = new jsPDF('p', 'mm', 'a4');

        const pageWidth = pdf.internal.pageSize.getWidth();

        // 🔹 First chart
        const img1 = canvas1.toDataURL('image/png');
        const img1Height = (canvas1.height * pageWidth) / canvas1.width;

        pdf.addImage(img1, 'PNG', 0, 10, pageWidth, img1Height);

        // 🔹 Second chart (next page)
        pdf.addPage();

        const img2 = canvas2.toDataURL('image/png');
        const img2Height = (canvas2.height * pageWidth) / canvas2.width;

        pdf.addImage(img2, 'PNG', 0, 10, pageWidth, img2Height);

        pdf.save('Total_Vs_Overdue.pdf');

      }).catch(err => {
        console.error('Error capturing charts:', err);
      });

    }, 1200); // 🔥 increase if charts load slow
  }


  cancelReportPopupFunction() {
    this.visibleReportPopup.close();
  }
  cancelReportPopupFunction1() {
    this.visibleReportPopup1.close();
  }
  cancelReportPopupFunctionForDmsChart() {
    this.visibleReportPopupForDmsChart.close();
  }
  //Excell & PDF
  popupDataTitle: any = {};
  cancelReportPopup() {
    this.visibleExcelPdfPopup.close();
    this.manuallyPicked = false;
    this.selectedColumns = "";
  }
  selectedColumns: any;
  columnList: any;
  htmlContent: any;
  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  getClobData(data: any, column: string, val: any, view: string) {
    console.log("prim", data);
    this.isProcessing = true;
    const formattedColumn = this.formatColumnName(column);
    this.htmlContent = val;
    this.editorComponent.openEditor(this.htmlContent, formattedColumn);
    this.isProcessing = false;
  }
  formatColumnName(column: string): string {
    return column
      .toLowerCase()
      .split('_')
      .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
  isForExcel: boolean = false;
  @ViewChild('excelPdfPopup', { static: true }) excelPdfPopup: TemplateRef<any>;
  excelPdfPopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  }
  @ViewChild('excelPdfPopupOrg', { static: true }) excelPdfPopupOrg: TemplateRef<any>;
  excelPdfPopupOrgConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  }
  @ViewChild('excelPdfPopupOrgMain', { static: true }) excelPdfPopupOrgMain: TemplateRef<any>;
  excelPdfPopupOrgMainConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  }
  @ViewChild('excelPdfPopupOrgInd', { static: true }) excelPdfPopupOrgInd: TemplateRef<any>;
  excelPdfPopupOrgIndConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  }
  visibleExcelPdfPopup: MatDialogRef<TemplateRef<any>>;
  reportObj: any = {};
  generateReport(value: any) {
    if (value == 'Pdf' && this.manuallyPicked && !this.selectedColumns.length) {
      this.showSnackBar('Please select the Columns', 'E');
    } else {
      let tname = "";
      let colList = "";
      let fieldList = "";
      this.appService.isProcessingRep = true;
      tname = "QMS_ALL_TASKS_FOR_DASHBOARD_VW";
      colList = "ORG_LONG_NAME,ORG_SHORT_NAME,MODULE,DEPARTMENT_HEAD_USER_NAME,GROUP_NAME,IS_GROUP_ACTIVE,TEMP_TASK_NO,TASK_ID,STATUS,TASK_TYPE,EXPECTED_TO_BE_STARTED_ON,EXPCETED_CLOSURE_ON,OVERDUE,CHART_STATUS,STAGE_NAME,SHORT_DESCRIPTION,DEPT_CODE,DEPT_NAME,REQUESTED_AT,CORE_BUSINESS_AREA_NAME,INITIATOR_NAME,INITIATOR_FULLNAME,OWNER_NAME,OWNER_FULLNAME,DESCRIPTION,QA_ACCEPTOR_FULLNAME,QA_FULLNAME,INVESTIGATOR_FULLNAME,CREATED_ON,STARTED_ON,COMPLETED_ON,REOPEN_OR_REVOKED_ON,FINAL_NO_GENERATED,IS_QANDA_REQD,EFFECTIVENESS_CHECK_REQD,INVESTIGATION_REQUIRED,FINAL_RISK_STATUS,STOP_REMINDERS,LAST_ACTION_FROM_STATUS,LAST_ACTION_ON";
      fieldList = "Organization Long Name,Organization Short Name,Module,Department Head User Name,Group Name,Is Group Active,Temp Task No,Task ID,Status,Task Type,Expected To Be Started On,Expected Closure On,Overdue,Chart Status,Stage Name,Short Description,Dept Code,Dept Name,Requested At,Core Business Area Name,Initiator Name,Initiator Fullname,Owner Name,Owner Fullname,Description,QA Acceptor / Schedule Approved By Fullname,QA Approver/Plan Approved By Fullname,Investigator Fullname,Created On,Started On,Completed On,Reopen or Revoked On,Final No Generated,Is Q and A Required,Effectiveness Check Required,Investigation Required,Final Risk Status,Stop Reminders,Last Action From Status,Last Action On";

      const data1: any = {

        tableOrViewName: tname,
        columnsList: colList,
        fieldLabelsList: fieldList,
        invisibleColumn: "",
        orderByClause: "",
        fieldSizeList: "",
        columnsListarray: [],
        fieldColumnarray: [],
        invisibleColumnarray: [],
        fieldSizeListArray: [],
        codelistGroup: null,
        manualEntryDataFields: null,
        chartStatus: null,
        reModule: "qms",
        logoId: 0,
        module: "QMS",
        isSaveRep: this.isSaveReport ? 'Y' : 'N',
        reportName: this.reportName ?? "Dashboard_Report",
        currentStatus: "NA",
        groupName: this.reportName + "",
      }
      let data2 = {
        groupId: null,
        module: this.selectedModules,
        dateRangeAt: this.specificIntervalVal ? 'CREATED' : null,
        fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
        toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
        intervals: this.selectedIntervalValue ? this.selectedIntervalValue : null,
        stageName: null,
        status: null,
        taskId: this.item1,
        taskNo: this.item == null ? null : this.item.toString(),
        wherVal: this.whereValsForExcel
      }
      this.reportObj = { ...data1, ...data2 };

      const timestamp = Date.now();
      const formattedDate = new Intl.DateTimeFormat('en-US', {
        day: '2-digit', month: 'short', year: 'numeric',
      }).format(new Date(timestamp)).replace(/[, ]/g, (match) => match === ',' ? '' : '_');
      let fileType = value == 'Excel' ? 'xlsx' : 'pdf';
      const fileName = `${this.clickedVal}_${formattedDate}.${fileType}`;
      if (value == 'Excel') {
        const pdfData = {
          ...this.reportObj, title: this.clickedVal, columns: [],
          "informationTab": {
            "Report Name": `${this.clickedVal}` + "  " + "Report",
            "Exported By": localStorage.getItem("loggedUserName")
          }
        }
        this.appService.downloadexcelForChart(pdfData, fileName);
      } else {
        const pdfData = {
          ...this.reportObj, title: `${this.clickedVal}`, columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.columnList.split(',').slice(0, 10).join(','), pdfPageSize: this.excelPdf.pdfPageSize
        }
        this.appService.downloadPdfForChart(pdfData, fileName);
      }
    }
  }
  openReportPopup(item: any) {
    if (this.onSelectedOptionForDMS == 'Inventory' || this.onSelectedOptionForDMS == 'Default' || this.selectedType == 'Action' || this.selectedType == 'Finding') {
      console.log("this.columnLists=", this.columnLists);
      this.excelPdf.dropDown = this.columnLists.fieldColumnarray.map((column: any) => (column.fieldColumnarray));
      console.log("this.excelPdf.dropDown=", this.columnLists);
    } else {
      this.excelPdf.dropDown = this.columnList.split(',');
    }
    this.pdfPageSizes = JSON.parse(sessionStorage.getItem('pdfPageSizes') ?? '{}');
    this.excelPdf.pdfPageSize = 'A4';
    this.isForExcel = item == 'Excel';
    this.popupDataTitle.title = item == 'Excel' ? 'Excel Report' : 'PDF Report';
    [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    this.pdfColumnSelection = false;
    this.reportName = `${this.clickedType}_${this.clickedVal}` + " Report";
    this.visibleExcelPdfPopup = this.dialog.open(this.excelPdfPopup, this.excelPdfPopupConfig);
    this.isSaveReport = false;
  }

  openReportPopupQMS(item: any) {
    this.excelPdf.dropDown = this.columnLists.fieldColumnarray.map((column: any) => (column.fieldColumnarray));
    this.pdfPageSizes = JSON.parse(sessionStorage.getItem('pdfPageSizes') ?? '{}');
    this.excelPdf.pdfPageSize = 'A4';
    this.isForExcel = item == 'Excel';
    this.popupDataTitle.title = item == 'Excel' ? 'Excel Report' : 'PDF Report';
    [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    this.pdfColumnSelection = false;
    this.reportName = `${this.clickedType}_${this.clickedVal}` + " Report";
    this.visibleExcelPdfPopup = this.dialog.open(this.excelPdfPopup, this.excelPdfPopupConfig);
    this.isSaveReport = false;
  }
  openReportPopupForDMSChart(item: any) {
    this.columnLists = "Axis Value,Intervals,Doc Container,Document Type Name,Document No,Document Name,Version,Status,Effective Date,Expiration Date,Associated Document ID,Associated Document From Version,Associated Document To Version,Revision History,CR Details,Document Description,Folder Name,Folder Path,Folder Status,All Parent Folder Status,Is Distributed Folder,Document Type Code,Is Associated Document Type,Belongs To Individual,Assignable At Trainings,Is Amendement Doc Type,Associated Doc To Follow Same Expiry,Belongs User Id,Checkout Flag,Checkedout On,Checkedout By User,checkedin On,Checkedin By User,Checkinout Comments,Is Latest Version,Is Latest Published Version,Is Blinded,Blinded By,Blinded On,Unblinded By,Unblinded On,Unblind Reason,Published On,Published By,Is Extension In Progress,Is Withdrawal In Progress,Is Amendment In Progress,No Of Completed Extension,No Of Completed Amendment,Reason For Status Change,Update Reason,Last Action On,Last Action By,Last Action Comments,Created On,Created By,Updated On,Updated By";
    this.excelPdf.dropDown = this.columnList.split(',');
    this.pdfPageSizes = JSON.parse(sessionStorage.getItem('pdfPageSizes') ?? '{}');
    this.excelPdf.pdfPageSize = 'A4';
    this.isForExcel = item == 'Excel';
    this.popupDataTitle.title = item == 'Excel' ? 'Excel Report' : 'PDF Report';
    [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    this.pdfColumnSelection = false;
    this.reportName = `${this.clickedType}_${this.clickedVal}` + " Report";
    this.visibleExcelPdfPopup = this.dialog.open(this.excelPdfPopup, this.excelPdfPopupConfig);
    console.log("this.excelPdf.dropDown=", this.columnLists);
    this.isSaveReport = false;

  }


  openReportPopupOrg() {
    this.popupDataTitle.title = 'Excel Report';
    this.visibleExcelPdfPopup = this.dialog.open(this.excelPdfPopupOrg, this.excelPdfPopupOrgConfig);
    this.isSaveReport = false;
  }
  openReportPopupOrgMain() {
    this.popupDataTitle.title = 'Excel Report';
    this.visibleExcelPdfPopup = this.dialog.open(this.excelPdfPopupOrgMain, this.excelPdfPopupOrgMainConfig);
    this.isSaveReport = false;
  }
  openReportPopupOrgInd() {
    this.popupDataTitle.title = 'Excel Report';
    this.visibleExcelPdfPopup = this.dialog.open(this.excelPdfPopupOrgInd, this.excelPdfPopupOrgIndConfig);
    this.isSaveReport = false;
  }
  //end excell & pdf
  applyFilter(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.dashboardTableListVal.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.dashboardTableListVal.filter((item: any) => {
        const columnValue = item[column];
        // Check if columnValue is a string before calling toLowerCase()
        if (val === 'd') {
          if (columnValue) {
            let formattedDate = this.datePipe.transform(columnValue, 'dd-MMM-yyyy');
            console.log("columnValue2=", formattedDate);
            // Convert number to string before checking for inclusion
            return formattedDate ? formattedDate.toString().toLowerCase().includes(filter) : false;
          } else {
            return false;
          }
        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          // Convert number to string before checking for inclusion
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          // Format date to string before checking for inclusion
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        // If it's not a string, return false to exclude it from filtering
        return false;
      });
    }
  }
  applyFilter1(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItemsSecond = this.getOneQmsUsersTrainingsRepVw.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItemsSecond = this.getOneQmsUsersTrainingsRepVw.filter((item: any) => {
        const columnValue = item[column];
        // Check if columnValue is a string before calling toLowerCase()
        if (val === 'd') {
          if (columnValue) {
            let formattedDate = this.datePipe.transform(columnValue, 'dd-MMM-yyyy');
            console.log("columnValue2=", formattedDate);
            // Convert number to string before checking for inclusion
            return formattedDate ? formattedDate.toString().toLowerCase().includes(filter) : false;
          } else {
            return false;
          }
        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          // Convert number to string before checking for inclusion
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          // Format date to string before checking for inclusion
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        // If it's not a string, return false to exclude it from filtering
        return false;
      });
    }
  }
  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.dashboardTableListVal.length, page, this.perPage, targetpage);
    if (this.dashboardTableListVal.length > 0) {
      this.pagedItems = this.dashboardTableListVal.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }
  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }
  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });
    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }
  item: any;
  item1: any;
  selectedModules: any;
  getGroupTableDetails(org: any, module: any, status: any, val: any) {

    this.item = "";
    this.item1 = "";
    this.selectedModules = module;
    this.whereValsForExcel = "";
    if (val == 'o' && org != '') {
      console.log("org")
      const itemObj = this.dashboardCountList.find((element: { orgLongName: any; }) => element.orgLongName === org);
      this.item = itemObj.orgId;
      this.item1 = "";
      if (status == "All") {
        this.whereValsForExcel = "";
      } else if (status == "Open") {
        this.whereValsForExcel = " AND CHART_STATUS='" + status + "'";
      } else if (status == "Overdue") {
        this.whereValsForExcel = " AND CHART_STATUS='Open' AND OVERDUE='Y'";
      } else if (status == "Closed") {
        this.whereValsForExcel = " AND CHART_STATUS='" + status + "'";
      } else if (status == "Deleted/Obsoleted") {
        this.whereValsForExcel = " AND CHART_STATUS='" + status + "'";
      }
      this.clickedVal = org + " - " + module + " - " + status;
    } else if (val == 'o' && org == '') {
      this.item = this.selectedOrgValue[0] ? this.selectedOrgValue[0] : null;
      this.item1 = "";
      if (status == "All") {
        this.whereValsForExcel = "";
      } else if (status == "Open") {
        this.whereValsForExcel = " AND CHART_STATUS='" + status + "'";
      } else if (status == "Overdue") {
        this.whereValsForExcel = " AND CHART_STATUS='Open' AND OVERDUE='Y'";
      } else if (status == "Closed") {
        this.whereValsForExcel = " AND CHART_STATUS='" + status + "'";
      } else if (status == "Deleted/Obsoleted") {
        this.whereValsForExcel = " AND CHART_STATUS='" + status + "'";
      }
      this.clickedVal = module + " - " + status;
    } else if (val == 'g') {
      console.log(val, "====val")
      const itemObj = this.dashboardGroupCountList.find((element: { groupName: any; }) => element.groupName === org);
      const groupIdVal = itemObj.groupId;
      let selectedOrgValue1 = "";
      if (this.selectedOrgValue.length > 0) {
        for (let j = 0; j < this.selectedOrgValue.length; j++) {
          selectedOrgValue1 += this.selectedOrgValue[j];
          selectedOrgValue1 += j == this.selectedOrgValue.length - 1 ? "" : ",";
        }


        this.item = null;
        this.item1 = selectedOrgValue1;
      } else {
        this.item = this.selectedOrgValue[0] ? this.selectedOrgValue[0] : null;
        this.item1 = null;
      }
      if (status == "All") {
        this.whereValsForExcel = " AND GROUP_ID=" + groupIdVal;
      } else if (status == "Open") {
        this.whereValsForExcel = " AND GROUP_ID=" + groupIdVal + " AND CHART_STATUS='" + status + "'";
      } else if (status == "Overdue") {
        this.whereValsForExcel = " AND GROUP_ID=" + groupIdVal + " AND CHART_STATUS='Open' AND OVERDUE='Y'";
      } else if (status == "Closed") {
        this.whereValsForExcel = " AND GROUP_ID=" + groupIdVal + " AND CHART_STATUS='" + status + "'";
      } else if (status == "Deleted/Obsoleted") {
        this.whereValsForExcel = " AND GROUP_ID=" + groupIdVal + " AND CHART_STATUS='" + status + "'";
      }
      this.clickedVal = org + " - " + module + " - " + status;
    }
    let selectedQmsGroup1 = "";
    let selectedQmsDept1 = "";
    if (this.selectedQmsGroup.length != 0) {
      for (let j = 0; j < this.selectedQmsGroup.length; j++) {
        selectedQmsGroup1 += "'" + this.selectedQmsGroup[j] + "'";
        selectedQmsGroup1 += j == this.selectedQmsGroup.length - 1 ? "" : ",";
      }
    }

    if (this.selectedQmsDept.length != 0) {
      for (let j = 0; j < this.selectedQmsDept.length; j++) {
        selectedQmsDept1 += "'" + this.selectedQmsDept[j] + "'";
        selectedQmsDept1 += j == this.selectedQmsDept.length - 1 ? "" : ",";
      }
    }
    if (selectedQmsGroup1) {
      this.whereValsForExcel = this.whereValsForExcel + " AND GROUP_NAME in(" + selectedQmsGroup1 + ")";
    }
    if (selectedQmsDept1) {
      this.whereValsForExcel = this.whereValsForExcel + " AND DEPT_CODE in(" + selectedQmsDept1 + ")";
    }
    this.clickedVal = `${module}-${this.selectedType}${status ? "-" + status : ""
      }`;
    let data = {
      groupId: null,
      module: module,
      dateRangeAt: this.specificIntervalVal ? 'CREATED' : null,
      fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
      toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
      intervals: this.selectedIntervalValue ? this.selectedIntervalValue : null,
      stageName: null,
      status: null,
      deptCode: null,
      annualRefNo: null,
      refno: null,
      taskId: this.item1,
      taskNo: this.item,
      groupIds: selectedQmsGroup1,
      deptIds: selectedQmsDept1,
      wherVal: this.whereValsForExcel
    }
    this.isProcessing = true;
    this.appService.getDashboardTableList(data).subscribe({
      next: (dashboardTableListVal) => {
        this.dashboardTableListVal = dashboardTableListVal;
        this.calculateTotalPages = this.collectionSize / this.perPage;
        this.pager.totalPages = undefined;
        this.collectionSize = this.dashboardTableListVal.length;
        this.totalPages = Math.ceil(
          this.dashboardTableListVal.length / this.itemsPerPage
        );

        this.setPage(1, 0);

        this.clickedVal =
          module + "-" + this.selectedType + "-" + status;

        console.log("this.clickedVal===", this.clickedVal);

        this.visibleReportPopup = this.dialog.open(
          this.reportPopup,
          this.reportPopupConfig
        );

        this.isProcessing = false;
      },
      error: (error) => {
        console.error("Error in getDashboardTableList:", error);
      },
    });
    this.columnList = "Organization Long Name,Organization Short Name,Module,Group Name,Is Group Active,Temp Task No,Task ID,Status,Task Type,Expected To Be Started On,Expected Closure On,Overdue,Chart Status,Stage Name,Short Description,Dept Code,Dept Name,Requested At,Core Business Area Name,Initiator Name,Initiator Fullname,Owner Name,Owner Fullname,Description,QA Acceptor / Schedule Approved By Fullname,QA Approver/Plan Approved By Fullname,Investigator Fullname,Created On,Started On,Completed On,Reopen or Revoked On,Final No Generated,Is Q and A Required,Effectiveness Check Required,Investigation Required,Final Risk Status,Stop Reminders,Last Action From Status,Last Action On";
  }
  onCheckboxChange(event: MatSlideToggleChange) {
    if (!event.checked) {
      [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    }
  }
  onSelect() {
    if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
    this.convertArrayToString(this.selectedColumns);
  }
  onDeSelect() {
    this.onSelect();
  }
  convertArrayToString(array: any) {
    this.selectedColumnsAsString = array.join(', ');
  }
  getDataPointsForGroup(actionList: any[]) {
    const aggregatedData: { [key: string]: number } = {};
    actionList.forEach((ac: { count: any; chartStatus: any; }) => {
      const status = ac.chartStatus.toString();
      if (aggregatedData.hasOwnProperty(status)) {
        aggregatedData[status] += ac.count;
      } else {
        aggregatedData[status] = ac.count;
      }
    });
    const dataPoints = Object.keys(aggregatedData).map(status => ({
      label: status,
      y: aggregatedData[status]
    }));
    console.log('Data Points:', dataPoints);
    return dataPoints;
  }
  onReportTypeSelect(event: any, item: any) {
    if (event.isUserInput) {
      console.log("item==", item);
      setTimeout(() => {
        if (item == "Trainings") {
          this.appService.getTmsGroupsVwDetails(this.selectedOrgValue[0]).subscribe((response: any) => {
            this.groupdataList = response;
            console.log(this.groupdataList);
            this.selectBoxeForGroupValue();
          });
          this.appService.getInstructorTrainer(this.selectedOrgValue[0]).subscribe((response: any) => {
            this.getTmsInstructorTrainerData = response;
            this.selectBoxeForTrainerValue();
          })
          this.appService.getCodeListsByGroupOrg("DEPARTMENT", this.selectedOrgValue[0]).subscribe((response: any) => {
            this.dropDownForDepartment = response;
            this.selectBoxForDepartment();
          })
          this.appService.getReportImagesBySelectedOrganization(this.selectedOrgValue[0]).subscribe((response1: any) => {
            this.oneQmsOrgImagesDetails = response1;
          })
          this.selectedOption = 'Organization';
          this.searchByReportCodeMain = 'Organization';
        } else if (item == "Quality") {
          this.selectedType = "Activity";
        } else if (item == "Documents") {
          this.reportTypeForDMSDropdown = [
            { valueExp: 'Inventory', displayExp: 'Inventory' },
            { valueExp: 'Master Index', displayExp: 'Master Index' },
            { valueExp: 'Default', displayExp: 'Default' }
          ];

          this.searchByDMSReportTypeMain = 'Default';
        }
        this.handleDropDownValidation('reportType', item)
      });
    }


    this.showGroupGrid = false;
    this.selectedGroup = null;
    this.getSelectedInstructorTrainingName = "";
    this.getSelectedTrainingId = null;
    this.searchByInstructorTrainer = [];
    this.searchByDepartmentCodeMain = [];
    this.searchByReportCodeMain = 'Organization';
    this.resetFunction1();
  }

  onTypeSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        if (item == "Finding") {
          this.moduleValueDropdown = [];
          let i = 0;
          for (const module of this.dropDownForModules) {
            console.log(module, "----")
            if (module == 'AU') {
              this.moduleValueDropdown.push({
                valueExp: module,
                displayExp: module
              });
              i++;
            }
          }
          this.selectedModule = "AU";
        } else if (item == "Action") {
          this.moduleValueDropdown = [];
          let i = 0;
          for (const module of this.dropDownForModules) {
            console.log(module, "----")
            if (module != 'AU') {
              this.moduleValueDropdown.push({
                valueExp: module,
                displayExp: module
              });
              i++;
            }
          } this.selectedModule = null;
        } else if (item == "Activity") {
          this.moduleValueDropdown = [];
          let i = 0;
          for (const module of this.dropDownForModules) {
            console.log(module, "----")
            this.moduleValueDropdown.push({
              valueExp: module,
              displayExp: module
            });
            i++;
          }
          this.selectedModule = null;
        } else {
          this.selectedModule = null;
        }
      });
      this.showGroupGrid = false;
    }
  }
  //TMS
  searchInstructorTrainingFunction() {
    console.log("data ====", this.multiUsersArray)
    this.multiUsersArray = [];
    this.getTmsInstructorTrainingDetailsTableData.forEach((training: any) => {
      if (training.trainingName) {
        training.searchTrainingChildCheckBoxs = false;
      }
    });
    this.showInstructorTrainingSearchGrid = false;
    this.showUserSearchInstructorTrainingGrid = false;
    this.searchByInstructorTrainingScheduleId = "";
    this.searchByInstructorTrainingName = "";
    this.searchByVersion = "";
    this.searchByTrainerName = "";
    this.searchByTrainingMode = "";
    this.searchByStatus = "";
    this.popupDataTitle.title = "Search Instructor Training";
    this.visibleSearchInstructorTrainingPopup = this.dialog.open(this.searchInstructorTraining, this.searchInstructorTrainingConfig);
  }
  searchInstructorTrainingGridDataFunction() {
    this.isProcessing = true;
    this.searchTmsTrainingsVwDetails = {
      trainingScheduleId: this.searchByInstructorTrainingScheduleId,
      trainingName: this.searchByInstructorTrainingName,
      version: this.searchByVersion,
      trainerName: this.searchByTrainerName,
      trainingMode: this.searchByTrainingMode,
      status: this.searchByStatus
    };
    this.appService.searchInstructorTrainingsByCondition(this.searchTmsTrainingsVwDetails).subscribe((response: any) => {
      this.getTmsInstructorTrainingDetailsTableData = response;
      this.showInstructorTrainingSearchGrid = true;
      this.isProcessing = false;
    })
  }
  resetSearchInstructorTrainingGridDataFunction() {
    this.isProcessing = true;
    this.searchByInstructorTrainingScheduleId = "";
    this.searchByInstructorTrainingName = "";
    this.searchByVersion = "";
    this.searchByTrainerName = "";
    this.searchByTrainingMode = "";
    this.searchByStatus = "";
    this.getTmsInstructorTrainingDetailsTableData = [];
    this.showUserSearchGrid = false;
    this.isProcessing = false;
  }
  selectAllInsTrainings(e: any) {
    if (e.target.checked) {
      this.multiUsersArray = [];
      this.getTmsInstructorTrainingDetailsTableData.forEach((training: any) => {
        if (training.trainingName) {
          training.searchTrainingChildCheckBoxs = true;
          this.multiUsersArray.push({ trainingId: training.trainingScheduleId, trainingName: training.trainingName });
        }
      });
    } else {
      this.multiUsersArray = [];
      this.getTmsInstructorTrainingDetailsTableData.forEach((training: any) => {
        if (training.trainingName) {
          training.searchTrainingChildCheckBoxs = false;
        }
      });
    }
    const anyChildChecked = this.getTmsInstructorTrainingDetailsTableData.some(
      (training: any) => training.searchTrainingChildCheckBoxs
    );
    e.target.checked = anyChildChecked;
  }
  searchInstructorTrainingChildCheckBoxChecked(e: any, listOfTrainingsVwDetails: any, idx: any) {
    if (e.target.checked) {
      listOfTrainingsVwDetails.searchTrainingChildCheckBoxs = true;
      if (!this.multiUsersArray.some((storedUser: any) => storedUser.trainingScheduleId === listOfTrainingsVwDetails.trainingScheduleId)) {
        this.multiUsersArray.push({ trainingId: listOfTrainingsVwDetails.trainingScheduleId, trainingName: listOfTrainingsVwDetails.trainingName });
      }
      this.getTmsInstructorTrainingDetailsTableData.every((allUsers: any) => { if (allUsers.searchTrainingChildCheckBoxs) { this.searchUserParentCheckBox = true; } return true; })
    } else {
      listOfTrainingsVwDetails.searchTrainingChildCheckBoxs = false;
      const removal = this.getTmsInstructorTrainingDetailsTableData.findIndex((removableUser: any) => removableUser.trainingScheduleId == listOfTrainingsVwDetails.trainingScheduleId);
      if (removal > -1) this.multiUsersArray.splice(removal, 1);
      if (this.getTmsInstructorTrainingDetailsTableData.some((allUsers: any) => !allUsers.searchTrainingChildCheckBoxs)) {
        this.searchUserParentCheckBox = false;
      }
    }
    if (e.target.checked) {
      this.searchByInstructorTrainingScheduleId = listOfTrainingsVwDetails.trainingScheduleId;
      this.getSelectedInstructorTrainingName = listOfTrainingsVwDetails.trainingName;
    } else {
      this.searchByInstructorTrainingScheduleId = null;
      this.getSelectedInstructorTrainingName = '';
    }
  }
  addInstructorTrainingNameFunction() {
    this.afterClickGenrate = false;
    this.getSelectedTrainingId = this.multiUsersArray.map((training: any) => training.trainingId).join(',');
    this.getSelectedInstructorTrainingName = this.multiUsersArray.map((training: any) => training.trainingName).join(',');
    console.log(this.getSelectedTrainingId + "----" + this.getSelectedInstructorTrainingName)
    this.searchVals = this.getSelectedTrainingId;
    this.noUserAlert = false;
    if (this.searchVals != "" && this.searchVals != null && this.searchVals != undefined) {
      this.visibleSearchInstructorTrainingPopup.close();
    } else {
      this.noUserAlert = true;
    }
  }
  cancelSearchInstructorTrainingFunction() {
    this.noUserAlert = false;
    this.searchByInstructorTrainingScheduleId = null;
    this.getSelectedInstructorTrainingName = '';
    this.visibleSearchInstructorTrainingPopup.close();
  }
  getUsersInstructorTraining() {
    if (this.showTrainerLevel) {
      let searchByInstructorTrainer1 = "";
      if (this.searchByInstructorTrainer.length > 0) {
        for (let j = 0; j < this.searchByInstructorTrainer.length; j++) {
          searchByInstructorTrainer1 += this.searchByInstructorTrainer[j];
          searchByInstructorTrainer1 += j == this.searchByInstructorTrainer.length - 1 ? "" : ",";
        }
        this.newRun("inT", searchByInstructorTrainer1)
      } else {
        this.newRun("inT", "01010")
      }
    } else if (this.getSelectedTrainingId) {
      this.newRun("in", this.getSelectedTrainingId)
    } else {
      this.newRun("in", "01010")
    }
  }
  newRun(type: any, val: any) {
    this.isProcessing = true;
    let i = 0;
    this.afterClickGenrate = false;
    this.totalVal = 0;
    this.attemptedVal = 0;
    this.yetToBeAttemptedVal = 0;
    this.completedAtAttemptedVal = 0;
    this.failedAtAttemptedChartVal = 0;
    this.scheduledAtAttemptedChartVal = 0;
    this.passPerValForAll = 0;
    this.inprogressVal = 0;
    this.passedVal = 0;
    this.failedVal = 0;
    this.scheduledVal = 0;
    this.lockedVal = 0;
    this.completedVal = 0;
    this.overdueVal = 0;
    this.pendingVal = 0;
    this.lockedOverdueVal = 0;
    this.chartList = [];
    let attaptedVal = "";
    attaptedVal = "NeedConsiderForReport";
    this.appService.getOneQmsUserTrainingsRepVwMainOrg(this.selectedOrgValue[0].toString(), 0, type, val, attaptedVal).subscribe((data: any) => {
      this.afterClickGenrate = true;
      this.getOneQmsUsersTrainingsRepVwDetails = data;
      this.calculateTotalPages = this.collectionSize / this.perPage;
      this.pager.totalPages = undefined;
      this.collectionSize = this.getOneQmsUsersTrainingsRepVwDetails.length;
      this.totalPages = Math.ceil(this.getOneQmsUsersTrainingsRepVwDetails.length / this.itemsPerPage);
      this.setPageMain(1, 0);
      console.log("this.getOneQmsUsersTrainingsRepVwDetails=", this.getOneQmsUsersTrainingsRepVwDetails);
      data.forEach((item: any, index: any) => {
        this.totalVal += item.total;
        this.attemptedVal += item.attempted;
        this.completedAtAttemptedVal += item.completedAtAttemptedChart;
        this.failedAtAttemptedChartVal += item.failedAtAttemptedChart;
        this.scheduledAtAttemptedChartVal += item.scheduledAtAttemptedChart;
        this.yetToBeAttemptedVal += item.yetToBeAttempted;
        this.passPerValForAll = (this.completedAtAttemptedVal / this.totalVal * 100).toFixed(1);
        this.pendingVal += item.pending;
        this.inprogressVal += item.inprogress;
        this.failedVal += item.failed;
        this.scheduledVal += item.scheduled;
        this.completedVal += item.completed;
        this.overdueVal += item.overdue;
        this.lockedVal += item.locked;
        this.passPerVal = (this.completedVal / this.totalVal * 100).toFixed(1);
      });
      console.log("data12345", this.completedAtAttemptedVal)
      if (this.notCompleted) {
        this.chartList.push(
          { lable: "Pending", value: this.pendingVal, color: "yellow" },
          { lable: "Attempted", value: this.attemptedVal, color: "DodgerBlue" },
          { lable: "Inprogress", value: this.inprogressVal, color: "green" },
          { lable: "Completed", value: this.completedVal, color: "green" },
          { lable: "Failed", value: this.failedVal, color: "red" },
          { lable: "Scheduled", value: this.scheduledVal, color: "gray" },
          { lable: "Overdue", value: this.overdueVal, color: "green" },
          { lable: "locked", value: this.lockedVal, color: "green" }
        );
      } else {
        this.chartList.push(
          { lable: "Attempted", value: this.attemptedVal, color: "DodgerBlue" },
          { lable: "Yet To Be Attempted", value: this.yetToBeAttemptedVal, color: "yellow" },
          { lable: "Scheduled At Attempted Chart", value: this.scheduledAtAttemptedChartVal, color: "DodgerBlue" },
          { lable: "Failed At Attempted Chart", value: this.failedAtAttemptedChartVal, color: "green" },
          { lable: "Completed At Attempted", value: this.completedAtAttemptedVal, color: "green" }
        );
      }
      this.chartOptionsForUser = {
        animationEnabled: true,
        exportEnabled: true,
        zoomEnabled: true,
        zoomType: "xy",
        toolbar: {
          itemBackgroundColor: "#d3d3d3",
          itemBackgroundColorOnHover: "#3e3e3e",
          buttonBorderColor: "#3e3e3e",
          icon: {
            zoom: {
              backgroundColor: "#007BFF", // Set the background color for the zoom icon
              borderColor: "#007BFF",     // Set the border color for the zoom icon
              borderWidth: 1             // Set the border width for the zoom icon
            }
          }
        },
        legend: {
          cursor: "pointer",
          fontFamily: "Poppins",
          fontColor: "#0F3659",
        },
        title: {
          text: "Status",
          fontSize: 20,
          fontFamily: "Poppins",
          horizontalAlign: "left",
          fontColor: "#0F3659",
          fontWeight: "bold",
          click: function (e: any) {
            console.log("Title clicked!");
          }
        },
        data: [{
          type: "doughnut",
          startAngle: -90,
          indexLabel: "{lable}:{value}",
          showInLegend: true,
          legendText: "{indexLabel}",
          yValueFormatString: "#,###.##''",
          dataPoints: this.getDataPointsForCharts(),
        }]
      }
      setTimeout(() => {
        let chart = new CanvasJS.Chart("chartContainerTMS", this.chartOptionsForUser);
        chart.render();
      }, 1000);
      this.isProcessing = false;
    })
  }
  newOrgRun(type: any, val: any, val1: any) {
    console.log(type + "====" + val + "====" + val1);
    this.isProcessing = true;
    let i = 0;
    this.afterClickGenrate = false;
    this.totalVal = 0;
    this.attemptedVal = 0;
    this.yetToBeAttemptedVal = 0;
    this.completedAtAttemptedVal = 0;
    this.failedAtAttemptedChartVal = 0;
    this.scheduledAtAttemptedChartVal = 0;
    this.passPerValForAll = 0;
    this.inprogressVal = 0;
    this.passedVal = 0;
    this.failedVal = 0;
    this.scheduledVal = 0;
    this.lockedVal = 0;
    this.completedVal = 0;
    this.overdueVal = 0;
    this.pendingVal = 0;
    this.lockedOverdueVal = 0;
    this.chartList = [];
    let attaptedVal = "";
    attaptedVal = "NeedConsiderForReport";

    if (val) {
      this.appService.getOneQmsOrgMain(type, val, attaptedVal).subscribe((data: any) => {
        this.afterClickGenrate = true;
        this.getOneQmsUsersTrainingsRepVwDetails = data;
        // console.log(this.dropDownForOrg, "====", this.getOneQmsUsersTrainingsRepVwDetails[0].orgId, "====", this.getOneQmsUsersTrainingsRepVwDetails.orgId)
        const itemObj = this.getOneQmsUsersTrainingsRepVwDetails.length > 0 ? this.dropDownForOrg.filter((d: { orgId: any; }) => d.orgId === this.getOneQmsUsersTrainingsRepVwDetails[0].orgId) : null;
        // console.log(itemObj[0].orgLongName, "====", itemObj)
        if (this.getOneQmsUsersTrainingsRepVwDetails.length > 0) {
          this.getOneQmsUsersTrainingsRepVwDetails[0].orgName = itemObj[0].orgLongName;
        }

        //  console.log(this.getOneQmsUsersTrainingsRepVwDetails, "====")
        this.calculateTotalPages = this.collectionSize / this.perPage;
        this.pager.totalPages = undefined;
        this.collectionSize = this.getOneQmsUsersTrainingsRepVwDetails.length;
        this.totalPages = Math.ceil(this.getOneQmsUsersTrainingsRepVwDetails.length / this.itemsPerPage);
        this.setPageMain(1, 0);
        console.log("this.getOneQmsUsersTrainingsRepVwDetails=", this.getOneQmsUsersTrainingsRepVwDetails)
        data.forEach((item: any, index: any) => {
          this.totalVal += item.total;
          this.attemptedVal += item.attempted;
          this.completedAtAttemptedVal += item.completedAtAttemptedChart;
          this.failedAtAttemptedChartVal += item.failedAtAttemptedChart;
          this.scheduledAtAttemptedChartVal += item.scheduledAtAttemptedChart;
          this.yetToBeAttemptedVal += item.yetToBeAttempted;
          this.passPerValForAll = (this.completedAtAttemptedVal / this.totalVal * 100).toFixed(1);
          this.pendingVal += item.pending;
          this.inprogressVal += item.inprogress;
          this.failedVal += item.failed;
          this.scheduledVal += item.scheduled;
          this.completedVal += item.completed;
          this.overdueVal += item.overdue;
          this.lockedVal += item.locked;
          this.passPerVal = (this.completedVal / this.totalVal * 100).toFixed(1);

        });
        console.log("data12345", this.completedAtAttemptedVal)
        if (this.notCompleted) {
          this.chartList.push(
            { lable: "Pending", value: this.pendingVal, color: "yellow" },
            { lable: "Attempted", value: this.attemptedVal, color: "DodgerBlue" },
            { lable: "Inprogress", value: this.inprogressVal, color: "green" },
            { lable: "Completed", value: this.completedVal, color: "green" },
            { lable: "Failed", value: this.failedVal, color: "red" },
            { lable: "Scheduled", value: this.scheduledVal, color: "gray" },
            { lable: "Overdue", value: this.overdueVal, color: "green" },
            { lable: "locked", value: this.lockedVal, color: "green" }
          );
        } else {
          this.chartList.push(
            { lable: "Attempted", value: this.attemptedVal, color: "DodgerBlue" },
            { lable: "Yet To Be Attempted", value: this.yetToBeAttemptedVal, color: "yellow" },
            { lable: "Scheduled At Attempted Chart", value: this.scheduledAtAttemptedChartVal, color: "DodgerBlue" },
            { lable: "Failed At Attempted Chart", value: this.failedAtAttemptedChartVal, color: "green" },
            { lable: "Completed At Attempted", value: this.completedAtAttemptedVal, color: "green" }
          );
        }

        this.chartOptionsForUser = {
          animationEnabled: true,
          exportEnabled: true,
          zoomEnabled: true,
          zoomType: "xy",
          toolbar: {
            itemBackgroundColor: "#d3d3d3",
            itemBackgroundColorOnHover: "#3e3e3e",
            buttonBorderColor: "#3e3e3e",
            icon: {
              zoom: {
                backgroundColor: "#007BFF", // Set the background color for the zoom icon
                borderColor: "#007BFF",     // Set the border color for the zoom icon
                borderWidth: 1             // Set the border width for the zoom icon
              }
            }
          },
          legend: {
            cursor: "pointer",
            fontFamily: "Poppins",
            fontColor: "#0F3659",
          },
          title: {
            text: "Status",
            fontSize: 20,
            fontFamily: "Poppins",
            horizontalAlign: "left",
            fontColor: "#0F3659",
            fontWeight: "bold",
            click: function (e: any) {
              console.log("Title clicked!");
            }
          },
          data: [{
            type: "doughnut",
            startAngle: -90,
            indexLabel: "{lable}:{value}",
            showInLegend: true,
            legendText: "{indexLabel}",
            yValueFormatString: "#,###.##''",
            dataPoints: this.getDataPointsForCharts(),
          }]
        }
        setTimeout(() => {
          let chart = new CanvasJS.Chart("chartContainerTMS", this.chartOptionsForUser);
          chart.render();
        }, 1000);
        this.isProcessing = false;
      })
    } else {

      let indexvval = 0;

      console.log(
        "this.selectedOrgValue=",
        this.selectedOrgValue
      );

      for (const selectedOrg of this.selectedOrgValue) {

        this.appService
          .getOneQmsOrgMain(
            type,
            selectedOrg,
            attaptedVal
          )
          .subscribe((data: any) => {

            this.afterClickGenrate = true;

            if (data.length > 0) {

              console.log(data[0].orgId);
              console.log(data[0]);

              this.getOneQmsUsersTrainingsRepVwDetails[
                indexvval
              ] = data[0];

              const itemObj = this.dropDownForOrg.find(
                (d: { orgId: any }) =>
                  d.orgId ===
                  this.getOneQmsUsersTrainingsRepVwDetails[indexvval].orgId
              );

              this.getOneQmsUsersTrainingsRepVwDetails[
                indexvval
              ].orgName = itemObj[0].orgLongName;

              indexvval++;

              data.forEach((item: any) => {

                this.totalVal += item.total;

                this.attemptedVal += item.attempted;

                this.completedAtAttemptedVal +=
                  item.completedAtAttemptedChart;

                this.failedAtAttemptedChartVal +=
                  item.failedAtAttemptedChart;

                this.scheduledAtAttemptedChartVal +=
                  item.scheduledAtAttemptedChart;

                this.yetToBeAttemptedVal +=
                  item.yetToBeAttempted;

                this.passPerValForAll =
                  (
                    this.completedAtAttemptedVal /
                    this.totalVal * 100
                  ).toFixed(1);

                this.pendingVal += item.pending;

                this.inprogressVal += item.inprogress;

                this.failedVal += item.failed;

                this.scheduledVal += item.scheduled;

                this.completedVal += item.completed;

                this.overdueVal += item.overdue;

                this.lockedVal += item.locked;

                this.passPerVal =
                  (
                    this.completedVal /
                    this.totalVal * 100
                  ).toFixed(1);

              });

              console.log(
                "data12345",
                this.completedAtAttemptedVal
              );

              if (this.notCompleted) {

                this.chartList.push(
                  {
                    lable: "Pending",
                    value: this.pendingVal,
                    color: "yellow"
                  },
                  {
                    lable: "Attempted",
                    value: this.attemptedVal,
                    color: "DodgerBlue"
                  },
                  {
                    lable: "Inprogress",
                    value: this.inprogressVal,
                    color: "green"
                  },
                  {
                    lable: "Completed",
                    value: this.completedVal,
                    color: "green"
                  },
                  {
                    lable: "Failed",
                    value: this.failedVal,
                    color: "red"
                  },
                  {
                    lable: "Scheduled",
                    value: this.scheduledVal,
                    color: "gray"
                  },
                  {
                    lable: "Overdue",
                    value: this.overdueVal,
                    color: "green"
                  },
                  {
                    lable: "locked",
                    value: this.lockedVal,
                    color: "green"
                  }
                );

              } else {

                this.chartList.push(
                  {
                    lable: "Attempted",
                    value: this.attemptedVal,
                    color: "DodgerBlue"
                  },
                  {
                    lable: "Yet To Be Attempted",
                    value: this.yetToBeAttemptedVal,
                    color: "yellow"
                  },
                  {
                    lable: "Scheduled At Attempted Chart",
                    value:
                      this.scheduledAtAttemptedChartVal,
                    color: "DodgerBlue"
                  },
                  {
                    lable: "Failed At Attempted Chart",
                    value:
                      this.failedAtAttemptedChartVal,
                    color: "green"
                  },
                  {
                    lable: "Completed At Attempted",
                    value:
                      this.completedAtAttemptedVal,
                    color: "green"
                  }
                );
              }
            }

            console.log(
              this.selectedOrgValue.indexOf(selectedOrg),
              "====",
              this.selectedOrgValue.length
            );

            if (
              this.selectedOrgValue.indexOf(selectedOrg) ===
              this.selectedOrgValue.length - 1
            ) {

              setTimeout(() => {

                console.log(
                  this.selectedOrgValue.indexOf(selectedOrg),
                  "====",
                  this.selectedOrgValue.length
                );

                this.calculateTotalPages =
                  this.collectionSize / this.perPage;

                this.pager.totalPages = undefined;

                this.collectionSize =
                  this.getOneQmsUsersTrainingsRepVwDetails.length;

                this.totalPages = Math.ceil(
                  this.getOneQmsUsersTrainingsRepVwDetails.length /
                  this.itemsPerPage
                );

                this.setPageMain(1, 0);

                this.chartOptionsForUser = {
                  animationEnabled: true,
                  exportEnabled: true,
                  zoomEnabled: true,
                  zoomType: "xy",

                  toolbar: {
                    itemBackgroundColor: "#d3d3d3",
                    itemBackgroundColorOnHover: "#3e3e3e",
                    buttonBorderColor: "#3e3e3e",

                    icon: {
                      zoom: {
                        backgroundColor: "#007BFF",
                        borderColor: "#007BFF",
                        borderWidth: 1
                      }
                    }
                  },

                  legend: {
                    cursor: "pointer",
                    fontFamily: "Poppins",
                    fontColor: "#0F3659",
                  },

                  title: {
                    text: "Status",
                    fontSize: 20,
                    fontFamily: "Poppins",
                    horizontalAlign: "left",
                    fontColor: "#0F3659",
                    fontWeight: "bold",

                    click: function (e: any) {
                      console.log("Title clicked!");
                    }
                  },

                  data: [{
                    type: "doughnut",
                    startAngle: -90,
                    indexLabel: "{lable}:{value}",
                    showInLegend: true,
                    legendText: "{indexLabel}",
                    yValueFormatString: "#,###.##''",

                    dataPoints:
                      this.getDataPointsForCharts(),
                  }]
                };

                const chart =
                  new CanvasJS.Chart(
                    "chartContainerTMS",
                    this.chartOptionsForUser
                  );

                chart.render();

                this.isProcessing = false;

              }, 1000);
            }
          });
      }
    }
  }
  chartOptionsForUser: any;
  createChart() {
    console.log(this.notCompleted);
    this.chartOptionsForUser = {
      animationEnabled: true,
      exportEnabled: true,
      zoomEnabled: true,
      zoomType: "xy",
      toolbar: {
        itemBackgroundColor: "#d3d3d3",
        itemBackgroundColorOnHover: "#3e3e3e",
        buttonBorderColor: "#3e3e3e",
        icon: {
          zoom: {
            backgroundColor: "#007BFF", // Set the background color for the zoom icon
            borderColor: "#007BFF",     // Set the border color for the zoom icon
            borderWidth: 1             // Set the border width for the zoom icon
          }
        }
      },
      legend: {
        cursor: "pointer",
        fontFamily: "Poppins",
        fontColor: "#0F3659",
      },
      title: {
        text: "Status",
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          console.log("Title clicked!");
        }
      },
      data: [{
        type: "doughnut",
        startAngle: -90,
        indexLabel: "{lable}:{value}",
        showInLegend: true,
        legendText: "{indexLabel}",
        yValueFormatString: "#,###.##''",
        dataPoints: this.getDataPointsForCharts(),
      }]
    }
    this.chartOptionsForDMSCount = {
      animationEnabled: true,
      exportEnabled: true,
      zoomEnabled: true,
      zoomType: "xy",
      legend: {
        cursor: "pointer",
        horizontalAlign: "left",
        fontSize: 12,
        fontFamily: "Poppins",
        fontColor: "#0F3659",
        fontWeight: "normal",
      },
      title: {
        text: `Document Count (${this.getTotalCountDmsCountChart()})`,
        fontSize: 18,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
      },
      axisX: {
        interval: 1,
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins"
      },
      axisY: {
        gridThickness: 1,
        gridColor: "#DEEBFE80",
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins"
      },
      toolTip: {
        shared: true
      },
      data: [{
        type: "line",
        name: "Document Count",
        showInLegend: true,
        yValueFormatString: "#,###",
        dataPoints: this.getDataPointsForActivityReport(),
        click: this.handleActivityReportChartClick.bind(this)
      }]

    };
    this.chartOptionsForStatus = {
      animationEnabled: true,
      exportEnabled: true,
      zoomEnabled: true,
      zoomType: "xy",
      toolbar: {
        itemBackgroundColor: "#d3d3d3",
        itemBackgroundColorOnHover: "#3e3e3e",
        buttonBorderColor: "#3e3e3e",
        icon: {
          zoom: {
            backgroundColor: "#007BFF", // Set the background color for the zoom icon
            borderColor: "#007BFF",     // Set the border color for the zoom icon
            borderWidth: 1             // Set the border width for the zoom icon
          }
        }
      },
      legend: {
        cursor: "pointer",
        fontFamily: "Poppins",
        fontColor: "#0F3659",
      },
      title: {
        text: `Status (${this.getTotalCountStatusCountChart()})`,
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          console.log("Title clicked!");
        }
      },
      data: [{
        type: "pie",
        indexLabel: "{status}:{count}",
        showInLegend: true,
        legendText: "{indexLabel}",
        yValueFormatString: "#,###.##''",
        dataPoints: this.getDataPointsForStatusCount(),
        click: this.handleStatusCountChartClick.bind(this) // Reference the click event handler for the entire pie chart
      }]
    };
    this.chartOptionsForDocType = {
      animationEnabled: true,
      exportEnabled: true,  // Enables the export button
      exportFileName: "document_type_chart",  // Name of the downloaded file
      legend: {
        cursor: "pointer",
      },
      title: {
        text: `Document Type (${this.getTotalCountDocTypeChart()})`,
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          console.log("Title clicked!");
        }
      },
      dataPointMaxWidth: this.typeNameList.length > 20 ? 10 : 38,
      dataPointMinWidth: this.typeNameList.length > 20 ? 10 : 38,
      scrollablePlotArea: {
        scrollEnabled: this.typeNameList.length > 20,
        unit: "pixel",
        // maxWidth: this.typeNameList.length * 50
        maxWidth: this.typeNameList.length * (this.typeNameList.length > 20 ? 25 : 50),
      },
      axisY: {
        gridThickness: 1,
        gridColor: "#DEEBFE80",
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins"
      },
      axisX: {
        tickLength: 0,
        lineThickness: 0,
        labelAngle: this.typeNameList.length > 25 ? -45 : 0,
        interval: 1,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: function (e: { label: any; value: string; }) {
          let label = null;
          if (e.label !== null) {
            label = e.label.length > 15 ? e.label.substring(0, 14) + '...' : e.label;
          }
          return label;
        }
      },
      data: [{
        type: "column",
        color: "#00A6A9",
        indexLabel: "{y}",
        indexLabelFontColor: "#0F3659",
        indexLabelFontSize: 12,
        indexLabelFontFamily: "Poppins",
        dataPoints: this.getDataPointsForDocType(),
        click: this.handleDocTypeChartClick.bind(this)
      }]
    };
    this.moveTop();
  }
  getDataPointsForCharts() {
    const dataPoints = this.chartList.map((gr: { value: any; lable: any; color: any }, index: any) => ({
      y: gr.value,
      indexLabel: `${gr.lable}:${gr.value}`,
      color: this.colorMethod(gr.lable, index)
    }));
    return dataPoints;
  }
  pagedItemsMain: any[];
  setPageMain(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.getOneQmsUsersTrainingsRepVwDetails.length, page, this.perPage, targetpage);
    console.log(this.getOneQmsUsersTrainingsRepVwDetails.length, "=len")
    if (this.getOneQmsUsersTrainingsRepVwDetails.length > 0) {
      this.pagedItemsMain = this.getOneQmsUsersTrainingsRepVwDetails.slice(this.pager.startIndex, this.pager.endIndex + 1);
      console.log(this.pagedItemsMain, "=pagedItemsMain");
    }
  }
  paginationCallMain(value: number) {
    this.perPage = value;
    this.setPageMain(this.pager.currentPage, 0);
  }
  trainingGroupTrainingFieldData: any = {};
  operationFlag: any;
  popupTitle: string | null = 'title';
  @ViewChild('searchTraining', { static: true }) searchTraining: TemplateRef<any>;
  visibleSearchTrainingPopup: MatDialogRef<TemplateRef<any>>;
  searchByTrainingName: any = null;
  searchByTrainingCode: any = null;
  searchByCategory: any = null;
  searchByLanguage: any = null;
  categoryValue: any;
  languageValue: any;
  searchTmsTrainingsVwDetails: any;
  getTmsTrainingDetailsTableData: any = [];
  searchTrainingConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };
  searchTrainingFunction() {
    this.multiUsersArray = [];
    this.showUserSearchGrid = false;
    this.searchByTrainingName = null;
    this.searchByTrainingCode = null;
    this.searchByCategory = null;
    this.searchByLanguage = null;
    this.popupDataTitle.title = "Search Training";
    this.visibleSearchTrainingPopup = this.dialog.open(this.searchTraining, this.searchTrainingConfig);
  }
  selectedLevelValue: any;
  selectedTemplateValue: any;
  getSelectedTrainingId: any;
  getSelectedTrainingName: string;
  getSelectedVersion: any;
  onGroupSelectnew(event: any, item: any) {
    console.log("item===", item)
    if (event.isUserInput) {
      setTimeout(() => {
        this.selectedGroupVal = item;
        this.handleDropDownValidation('groupNameAlert', this.selectedGroupVal);
      })
    }
  }
  showTrainerLevelFcn(e: any) {
    this.searchVals = null;
    if (e.target.checked) {
      this.showTrainerLevel = true;
    } else {
      this.showTrainerLevel = false;
    }
  }
  groupdataList: any = [];
  groupValueDropdown: any;
  selectBoxeForGroupValue() {
    this.groupValueDropdown = [];
    for (const group of this.groupdataList) {
      this.groupValueDropdown.push({
        valueExp: group.groupId,
        displayExp: group.groupName
      });
    }
  }
  getTmsInstructorTrainerData: any = [];
  getTmsInstructorTrainerDataList: any;
  selectBoxeForTrainerValue() {
    this.getTmsInstructorTrainerDataList = [];
    for (const group of this.getTmsInstructorTrainerData) {
      this.getTmsInstructorTrainerDataList.push({
        valueExp: group.trainerId,
        displayExp: group.trainerName
      });
    }
  }
  onReportTypeSelectnew(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('manageReportNameAlert', item)
      if (item) {
        console.log(item)
        this.pagedItems2 = [];
        this.afterClickGenrate = false;
        this.ClickedSearchVal = "";
        this.ClickedStatusVal = "";
        this.searchByDepartmentCodeMain = [];
        this.totalVal = 0;
        this.attemptedVal = 0;
        this.yetToBeAttemptedVal = 0;
        this.completedAtAttemptedVal = 0;
        this.failedAtAttemptedChartVal = 0;
        this.scheduledAtAttemptedChartVal = 0;
        this.inprogressVal = 0;
        this.passedVal = 0;
        this.failedVal = 0;
        this.scheduledVal = 0;
        this.lockedVal = 0;
        this.completedVal = 0;
        this.overdueVal = 0;
        this.pendingVal = 0;
        this.lockedOverdueVal = 0;
        this.tmsUserTrainingsRepVwDataForGrid = [];
        this.searchUserName = "";
        this.chosenToUserId = "";
        this.chosenToUserName = "";
        this.getSelectedTrainingName = "";
        this.childGridShow = false;
        this.notCompleted = false;
        this.teamUserLevel = false;
        this.departmentUserLevel = false;
        this.grouphTrainingLevel = false;
        this.instructorTrainingLevel = false;
        this.getOneQmsUsersTrainingsRepVwDetailsUserAndTraining = [];
        this.totalList = [];
        this.statusList = [];
        this.colorList = [];
        this.specificIntervalVal = true;
        this.selectedTrainingCategory = "";
        this.getSelectedInstructorTrainingName = "";
        this.searchByInstructorTrainer = [];
        this.searchByGroupId = [];
        this.pagedItems = [];
        this.getOneQmsUsersTrainingsRepVw = {};
        this.tmsUserTrainingsRepVwDataForGrid = {};
        this.selectedDepartment = "";
        this.selectedGroup = null;
        this.selectedOption = item.displayExp;
        this.resetFunctionTmsReportDropdown();
      }
    }
  }
  showDeleteAndObsolute() {
    console.log("showDeleteAndObsolute");
  }
  showNotCompleted() {
    console.log("1" + this.notCompleted)
    if (this.notCompleted) {
      this.notCompleted = false;
      this.notCompleted = false;
      console.log("2" + this.notCompleted)
    } else {
      this.notCompleted = true;
      this.notCompleted = true;
      console.log("3" + this.notCompleted)
    }
    this.chartList = [];
    if (this.notCompleted) {

      this.chartList.push(
        {
          lable: "Pending",
          value: this.pendingVal,
          color: "yellow"
        },
        {
          lable: "Attempted",
          value: this.attemptedVal,
          color: "DodgerBlue"
        },
        {
          lable: "Inprogress",
          value: this.inprogressVal,
          color: "green"
        },
        {
          lable: "Completed",
          value: this.completedVal,
          color: "green"
        },
        {
          lable: "Failed",
          value: this.failedVal,
          color: "red"
        },
        {
          lable: "Scheduled",
          value: this.scheduledVal,
          color: "gray"
        },
        {
          lable: "Overdue",
          value: this.overdueVal,
          color: "green"
        },
        {
          lable: "locked",
          value: this.lockedVal,
          color: "green"
        }
      );

    } else {

      this.chartList.push(
        {
          lable: "Attempted",
          value: this.attemptedVal,
          color: "DodgerBlue"
        },
        {
          lable: "Yet To Be Attempted",
          value: this.yetToBeAttemptedVal,
          color: "yellow"
        },
        {
          lable: "Scheduled At Attempted Chart",
          value: this.scheduledAtAttemptedChartVal,
          color: "DodgerBlue"
        },
        {
          lable: "Failed At Attempted Chart",
          value: this.failedAtAttemptedChartVal,
          color: "green"
        },
        {
          lable: "Completed At Attempted",
          value: this.completedAtAttemptedVal,
          color: "green"
        }
      );
    }

    this.chartOptionsForUser = {
      animationEnabled: true,
      exportEnabled: true,
      zoomEnabled: true,
      zoomType: "xy",
      toolbar: {
        itemBackgroundColor: "#d3d3d3",
        itemBackgroundColorOnHover: "#3e3e3e",
        buttonBorderColor: "#3e3e3e",
        icon: {
          zoom: {
            backgroundColor: "#007BFF", // Set the background color for the zoom icon
            borderColor: "#007BFF",     // Set the border color for the zoom icon
            borderWidth: 1             // Set the border width for the zoom icon
          }
        }
      },
      legend: {
        cursor: "pointer",
        fontFamily: "Poppins",
        fontColor: "#0F3659",
      },
      title: {
        text: "Status",
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          console.log("Title clicked!");
        }
      },
      data: [{
        type: "doughnut",
        startAngle: -90,
        indexLabel: "{lable}:{value}",
        showInLegend: true,
        legendText: "{indexLabel}",
        yValueFormatString: "#,###.##''",
        dataPoints: this.getDataPointsForCharts(),
      }]
    }
    setTimeout(() => {
      let chart = new CanvasJS.Chart("chartContainerTMS", this.chartOptionsForUser);
      chart.render();
    }, 1000);
  }
  //main grid download
  excelDownloadMaingridForMultiOrg() {
    let considerForReportFlag = "";
    let attaptedVal = "";
    let typeVal = "";
    let vals = "";
    this.appService.isProcessingRep = true;
    considerForReportFlag = "NeedConsiderForReport"
    if (this.notCompleted) {
      attaptedVal = "att"
    } else {
      attaptedVal = "notatt"
    }
    let tname = "";
    let colList = "";
    let fieldList = "";
    this.whereValsForExcel = "";
    tname = "TMS_USER_TRAININGS_REP_CNT_VW";
    if (this.selectedOption == 'Organization') {
      typeVal = "or";
      vals = '01010';
      if (this.notCompleted) {
        colList = "ORG_ID,NO_OF_USERS,NO_OF_INDIVIDUAL_TRAININGS,NO_OF_USER_TRAININGS,PENDING,COMPLETED,FAILED,SCHEDULED,INPROGRESS,OVERDUE,LOCKED,FAILED_ATTEMPTS,PASS";
        fieldList = "Organization Name,NO. Of Users,NO. Of Individual Trainings,Total,Pending,Completed,Failed,Scheduled,Inprogress,Overdue,Locked,Failed Attempts,Pass %";
      } else {
        colList = "ORG_ID,NO_OF_USERS,NO_OF_INDIVIDUAL_TRAININGS,NO_OF_USER_TRAININGS,YET_TO_BE_ATTEMPTED,ATTEMPTED,COMPLETED_AT_ATTEMPTED_CHART,FAILED_AT_ATTEMPTED_CHART,SCHEDULED_AT_ATTEMPTED_CHART,FAILED_ATTEMPTS,PASS";
        fieldList = "Organization Name,NO. Of Users,NO. Of Individual Trainings,Total,Yet To Be Attempted,Attempted,Completed,Failed,Scheduled,Failed Attempts,Pass %";
      }
    }
    let selectedOrgValue1 = "";
    if (this.selectedOrgValue.length != 0) {
      for (let j = 0; j < this.selectedOrgValue.length; j++) {
        selectedOrgValue1 += this.selectedOrgValue[j];
        selectedOrgValue1 += j == this.selectedOrgValue.length - 1 ? "" : ",";
      }
    }

    const data = {

      groupId: this.qmsservice.selectedGroup,
      type: typeVal,
      val: vals,
      attaptedVal: attaptedVal,
      considerForReportFlag: considerForReportFlag,
      taskId: selectedOrgValue1,
      taskNo: this.selectedOrgValue[0] ? this.selectedOrgValue[0].toString() : null
    }
    const data1: any = {
      tableOrViewName: tname,
      columnsList: colList,
      fieldLabelsList: fieldList,
      invisibleColumn: "",
      orderByClause: "",
      fieldSizeList: "",
      columnsListarray: [],
      fieldColumnarray: [],
      invisibleColumnarray: [],
      fieldSizeListArray: [],
      status: null,
      codelistGroup: null,
      manualEntryDataFields: null,
      groupId: null,
      chartStatus: null,
      wherVal: this.whereValsForExcel,
      reModule: "tms"
    }
    this.reportObj = { ...data1, ...data };
    debugger;
    const pdfData = {
      ...this.reportObj, title: this.selectedOption, columns: [],
      "informationTab": {
        "Report Name": this.selectedOption,
        "Exported By": localStorage.getItem("loggedUserName")
      }
    }
    this.appService.downloadexcelForMainGridTMSOrg(pdfData, this.selectedOption + ".xlsx");
  }
  excelDownloadMaingridOrgPage() {
    let considerForReportFlag = "";
    let attaptedVal = "";
    let typeVal = "";
    let vals = "";
    this.appService.isProcessingRep = true;
    if (this.message.showRetakeAndMarkasCompleted) {
      considerForReportFlag = "noNeedConsiderForReport"
    } else {
      considerForReportFlag = "NeedConsiderForReport"
    }
    if (this.notCompleted) {
      attaptedVal = "att"
    } else {
      attaptedVal = "notatt"
    }
    let tname = "";
    let colList = "";
    let fieldList = "";
    this.whereValsForExcel = "";
    tname = "TMS_USER_TRAININGS_REP_CNT_VW";
    if (this.selectedOption == 'Instructor Trainings') {
      if (this.showTrainerLevel) {
        let searchByInstructorTrainer1 = "";
        for (let j = 0; j < this.searchByInstructorTrainer.length; j++) {
          searchByInstructorTrainer1 += this.searchByInstructorTrainer[j];
          searchByInstructorTrainer1 += j == this.searchByInstructorTrainer.length - 1 ? "" : ",";
        }
        typeVal = "inT";
        vals = this.searchByInstructorTrainer.length > 0 ? searchByInstructorTrainer1 : '01010';
      } else {
        typeVal = "in";
        vals = this.getSelectedTrainingId ? this.getSelectedTrainingId : '01010';
      }
      if (this.notCompleted) {
        colList = "TRAINING_NAME,VERSION,TOTAL,PENDING,COMPLETED,FAILED,SCHEDULED,INPROGRESS,OVERDUE,LOCKED,FAILED_ATTEMPTS,PASS";
        fieldList = "Training Name,Version,Total,Pending,Completed,Failed,Scheduled,Inprogress,Overdue,Locked,Failed Attempts,Pass %";
      } else {
        colList = "TRAINING_NAME,VERSION,TOTAL,YET_TO_BE_ATTEMPTED,ATTEMPTED,COMPLETED_AT_ATTEMPTED_CHART,FAILED_AT_ATTEMPTED_CHART,SCHEDULED_AT_ATTEMPTED_CHART,FAILED_ATTEMPTS,PASS";
        fieldList = "Training Name,Version,Total,Yet To Be Attempted,Attempted,Completed,Failed,Scheduled,Failed Attempts,Pass %";
      }
    } else if (this.selectedOption == 'Department') {
      typeVal = "de";
      let selectedDep1 = "";
      if (this.searchByDepartmentCodeMain.length != 0) {
        for (let j = 0; j < this.searchByDepartmentCodeMain.length; j++) {
          selectedDep1 += this.searchByDepartmentCodeMain[j];
          selectedDep1 += j == this.searchByDepartmentCodeMain.length - 1 ? "" : ",";
        }
      }
      const parts: string[] = selectedDep1.split(',');
      const formattedParts: string[] = parts.map(part => `'${part}'`);
      const result: string = formattedParts.join(',');
      console.log("de result=", result)
      vals = this.searchByDepartmentCodeMain.length ? result : '01010';
      if (this.notCompleted) {
        colList = "DEPARTMENT_CODE,TOTAL,PENDING,COMPLETED,FAILED,SCHEDULED,INPROGRESS,OVERDUE,LOCKED,FAILED_ATTEMPTS,PASS";
        fieldList = "Department,Total,Pending,Completed,Failed,Scheduled,Inprogress,Overdue,Locked,Failed Attempts,Pass %";
      } else {
        colList = "DEPARTMENT_CODE,TOTAL,YET_TO_BE_ATTEMPTED,ATTEMPTED,COMPLETED_AT_ATTEMPTED_CHART,FAILED_AT_ATTEMPTED_CHART,SCHEDULED_AT_ATTEMPTED_CHART,FAILED_ATTEMPTS,PASS";
        fieldList = "Department,Total,Yet To Be Attempted,Attempted,Completed,Failed,Scheduled,Failed Attempts,Pass %";
      }
    } else if (this.selectedOption == 'Training Groups') {
      typeVal = "tg";
      vals = this.selectedGroup ? this.selectedGroup.toString() : '01010';
      if (this.notCompleted) {
        colList = "USER_NAME,TOTAL,PENDING,COMPLETED,FAILED,SCHEDULED,INPROGRESS,OVERDUE,LOCKED,FAILED_ATTEMPTS,PASS";
        fieldList = "User Name,Total,Pending,Completed,Failed,Scheduled,Inprogress,Overdue,Locked,Failed Attempts,Pass %";
      } else {
        colList = "USER_NAME,TOTAL,YET_TO_BE_ATTEMPTED,ATTEMPTED,COMPLETED_AT_ATTEMPTED_CHART,FAILED_AT_ATTEMPTED_CHART,SCHEDULED_AT_ATTEMPTED_CHART,FAILED_ATTEMPTS,PASS";
        fieldList = "User Name,Total,Yet To Be Attempted,Attempted,Completed,Failed,Scheduled,Failed Attempts,Pass %";
      }
    }
    this.whereValsForExcel = "";
    const data = {
      orgId: this.selectedOrgValue[0].toString(),
      groupId: this.qmsservice.selectedGroup,
      type: typeVal,
      val: vals,
      attaptedVal: attaptedVal,
      considerForReportFlag: considerForReportFlag
    }
    const data1: any = {
      tableOrViewName: tname,
      columnsList: colList,
      fieldLabelsList: fieldList,
      invisibleColumn: "",
      orderByClause: "",
      fieldSizeList: "",
      columnsListarray: [],
      fieldColumnarray: [],
      invisibleColumnarray: [],
      fieldSizeListArray: [],
      status: null,
      codelistGroup: null,
      manualEntryDataFields: null,
      groupId: this.qmsservice.selectedActivityGroupId,
      chartStatus: null,
      wherVal: this.whereValsForExcel,
      reModule: "tms"
    }
    this.reportObj = { ...data1, ...data };
    debugger;
    const pdfData = {
      ...this.reportObj, title: this.selectedOption, columns: [],
      "informationTab": {
        "Report Name": this.selectedOption,
        "Exported By": localStorage.getItem("loggedUserName")
      }
    }
    this.appService.downloadexcelForMainGrid(pdfData, this.selectedOption + ".xlsx");
  }
  excelDownloadMaingridOrg(types: any) {
    let considerForReportFlag = "";
    let attaptedVal = "";
    let typeVal = "";
    let vals = "";
    this.appService.isProcessingRep = true;
    considerForReportFlag = "NeedConsiderForReport";
    attaptedVal = "notatt";
    let tname = "";
    let colList = "";
    let fieldList = "";
    this.whereValsForExcel = "";
    tname = "TMS_USER_TRAININGS_REP_CNT_VW";
    if (types == 'user') {
      typeVal = "user";
      vals = '01010';
      colList = "USR_FULLNAME,TOTAL,YET_TO_BE_ATTEMPTED,ATTEMPTED,COMPLETED_AT_ATTEMPTED_CHART,FAILED_AT_ATTEMPTED_CHART,SCHEDULED_AT_ATTEMPTED_CHART,FAILED_ATTEMPTS,PASS";
      fieldList = "User Fullname,Total,Yet To Be Attempted,Attempted,Completed,Failed,Scheduled,Failed Attempts,Pass %";
    } else if (types == 'training') {
      typeVal = "tr";
      vals = '01010';
      colList = "TRAINING_NAME,VERSION,TOTAL,YET_TO_BE_ATTEMPTED,ATTEMPTED,COMPLETED_AT_ATTEMPTED_CHART,FAILED_AT_ATTEMPTED_CHART,SCHEDULED_AT_ATTEMPTED_CHART,FAILED_ATTEMPTS,PASS";
      fieldList = "Training Name,Version,Total,Yet To Be Attempted,Attempted,Completed,Failed,Scheduled,Failed Attempts,Pass %";
    }
    this.whereValsForExcel = "";
    const data = {
      orgId: this.tempOrgIdForUserTrainingExcel.toString(),
      groupId: null,
      type: typeVal,
      val: vals,
      attaptedVal: attaptedVal,
      considerForReportFlag: considerForReportFlag
    }
    const data1: any = {
      tableOrViewName: tname,
      columnsList: colList,
      fieldLabelsList: fieldList,
      invisibleColumn: "",
      orderByClause: "",
      fieldSizeList: "",
      columnsListarray: [],
      fieldColumnarray: [],
      invisibleColumnarray: [],
      fieldSizeListArray: [],
      status: null,
      codelistGroup: null,
      manualEntryDataFields: null,
      groupId: this.qmsservice.selectedActivityGroupId,
      chartStatus: null,
      wherVal: this.whereValsForExcel,
      reModule: "tms"
    }
    this.reportObj = { ...data1, ...data };
    debugger;
    const pdfData = {
      ...this.reportObj, title: this.selectedOption, columns: [],
      "informationTab": {
        "Report Name": this.selectedOption,
        "orgName": this.pagedItems3rd?.[0]?.orgName ?? null,
        "Exported By": localStorage.getItem("loggedUserName")
      }
    }
    this.appService.downloadexcelForMainGrid(pdfData, this.selectedOption + ".xlsx");

  }

  overAllGetDetails(status: any) {
    this.pagedItemsSecond = [];
    this.getOneQmsUsersTrainingsRepVw = {};
    this.selectedStatus = "";
    console.log("status=", status);
    let whereVal = "";
    if (this.selectedOption == 'Training Groups') {
      console.log("this.selectedOption=", this.selectedOption)
      this.selectedStatus = this.statusVal(status);
      whereVal = " AND GRP.GROUP_ID =" + this.selectedGroup;
      if (status != "All") {
        if (status == "OVERDUE") {
          status = "(OVERDUE=1 OR LOCKED_OVERDUE";
          whereVal = whereVal + " AND TRN." + status + "=1)";
        } else if (status == "LOCKED") {
          status = "(LOCKED=1 OR PERMENANTLY_LOCKED";
          whereVal = whereVal + " AND TRN." + status + "=1)";
        } else {
          whereVal = whereVal + " AND TRN." + status + "=1";
        }
      }
      this.detailsGridGetCall("group", "s", whereVal);
    } else if (this.selectedOption == 'Department') {
      console.log(this.searchByDepartmentCodeMain, "====")
      if (this.searchByDepartmentCodeMain.length > 0) {
        let selectedDep1 = "";
        if (this.searchByDepartmentCodeMain.length != 0) {
          for (let j = 0; j < this.searchByDepartmentCodeMain.length; j++) {
            selectedDep1 += this.searchByDepartmentCodeMain[j].valueExp;
            selectedDep1 += j == this.searchByDepartmentCodeMain.length - 1 ? "" : ",";
          }
        }
        const parts: string[] = selectedDep1.split(',');
        // Map each part to add single quotes around it
        const formattedParts: string[] = parts.map(part => `'${part}'`);
        // Join the formatted parts back into a string
        const result: string = formattedParts.join(',');
        this.selectedStatus = this.statusVal(status);
        whereVal = " AND DEPARTMENT_CODE IN (" + result + ")"
        if (status != "All") {
          if (status == "OVERDUE") {
            status = "(OVERDUE=1 OR LOCKED_OVERDUE";
            whereVal = whereVal + " AND " + status + "=1)";
          } else if (status == "LOCKED") {
            status = "(LOCKED=1 OR PERMENANTLY_LOCKED";
            whereVal = whereVal + " AND " + status + "=1)";
          } else {
            whereVal = whereVal + " AND " + status + "=1";
          }
        }
        this.detailsGridGetCall("user", "s", whereVal);
      } else {
        this.selectedStatus = this.statusVal(status);
        if (status == "All") {

          whereVal = "ORDER BY GROUP_NAME ASC";
        } else {
          if (status == "OVERDUE") {
            status = "(OVERDUE=1 OR LOCKED_OVERDUE";
            whereVal = whereVal + " AND " + status + "=1)";
          } else if (status == "LOCKED") {
            status = "(LOCKED=1 OR PERMENANTLY_LOCKED";
            whereVal = whereVal + " AND " + status + "=1)";
          } else {
            whereVal = whereVal + " AND " + status + "=1";
          }
        }
        this.detailsGridGetCall("user", "s", whereVal);
      }
    } else if (this.selectedOption == 'Instructor Trainings') {
      if (this.showTrainerLevel) {
        let searchByInstructorTrainer1 = "";
        if (this.searchByInstructorTrainer.length > 0) {
          for (let j = 0; j < this.searchByInstructorTrainer.length; j++) {
            searchByInstructorTrainer1 += this.searchByInstructorTrainer[j];
            searchByInstructorTrainer1 += j == this.searchByInstructorTrainer.length - 1 ? "" : ",";
          }
          this.selectedStatus = this.statusVal(status);
          whereVal = " AND TRAINER_ID IN (" + searchByInstructorTrainer1 + ")";
          if (status != "All") {
            if (status == "OVERDUE") {
              status = "(OVERDUE=1 OR LOCKED_OVERDUE";
              whereVal = whereVal + " AND " + status + "=1)";
            } else if (status == "LOCKED") {
              status = "(LOCKED=1 OR PERMENANTLY_LOCKED";
              whereVal = whereVal + " AND " + status + "=1)";
            } else {
              whereVal = whereVal + " AND " + status + "=1";
            }
          }
          this.detailsGridGetCall("inT", "s", whereVal);
        } else {
          this.selectedStatus = this.statusVal(status);
          if (status == "All") {
            whereVal = whereVal + "ORDER BY TRAINING_NAME ASC";
          } else {
            if (status == "OVERDUE") {
              status = "(OVERDUE=1 OR LOCKED_OVERDUE";
              whereVal = whereVal + " AND " + status + "=1)";
            } else if (status == "LOCKED") {
              status = "(LOCKED=1 OR PERMENANTLY_LOCKED";
              whereVal = whereVal + " AND " + status + "=1)";
            } else {
              whereVal = whereVal + " AND " + status + "=1";
            }
          }
          this.detailsGridGetCall("inT", "s", whereVal);
        }
      } else if (this.getSelectedTrainingId) {

        this.selectedStatus = this.statusVal(status);
        whereVal = " AND TRAINING_SCHEDULE_ID IN (" + this.getSelectedTrainingId + ")";
        if (status != "All") {
          if (status == "OVERDUE") {
            status = "(OVERDUE=1 OR LOCKED_OVERDUE";
            whereVal = whereVal + " AND " + status + "=1)";
          } else if (status == "LOCKED") {
            status = "(LOCKED=1 OR PERMENANTLY_LOCKED";
            whereVal = whereVal + " AND " + status + "=1)";
          } else {
            whereVal = whereVal + " AND " + status + "=1";
          }
        }
        this.detailsGridGetCall("inT", "s", whereVal);
      } else {
        this.selectedStatus = this.statusVal(status);
        if (status != "All") {
          if (status == "OVERDUE") {
            status = "(OVERDUE=1 OR LOCKED_OVERDUE";
            whereVal = whereVal + " AND " + status + "=1)";
          } else if (status == "LOCKED") {
            status = "(LOCKED=1 OR PERMENANTLY_LOCKED";
            whereVal = whereVal + " AND " + status + "=1)";
          } else {
            whereVal = whereVal + " AND " + status + "=1";
          }
        } else {
          whereVal = whereVal + "ORDER BY TRAINING_NAME ASC";
        }
        this.detailsGridGetCall("inT", "s", whereVal);
      }


    }
  }


  getDetails(obj: any, status: any) {
    this.pagedItemsSecond = [];
    this.getOneQmsUsersTrainingsRepVw = {};
    this.selectedStatus = "";
    console.log(obj);
    let whereVal = "";
    if (this.selectedOption == 'Training Groups') {
      this.selectedStatus = this.getOneQmsUsersTrainingsRepVwDetails[obj].groupName + " - " + this.getOneQmsUsersTrainingsRepVwDetails[obj].userName + " - " + this.statusVal(status);
      whereVal = " AND GRP.GROUP_ID=" + this.getOneQmsUsersTrainingsRepVwDetails[obj].groupId + "";
      whereVal += " AND TRN.USER_ID=" + this.getOneQmsUsersTrainingsRepVwDetails[obj].userId + "";
      if (status != "All") {
        if (status == "OVERDUE") {
          status = "(OVERDUE=1 OR LOCKED_OVERDUE";
          whereVal = whereVal + " AND TRN." + status + "=1)";
        } else if (status == "LOCKED") {
          status = "(LOCKED=1 OR PERMENANTLY_LOCKED";
          whereVal = whereVal + " AND TRN." + status + "=1)";
        } else {
          whereVal = whereVal + " AND TRN." + status + "=1";
        }
      }
      this.detailsGridGetCall("group", "s", whereVal);
    } else if (this.selectedOption == 'Department') {
      this.selectedStatus = this.getOneQmsUsersTrainingsRepVwDetails[obj].departmentCode + "-" + this.statusVal(status);
      whereVal = " AND DEPARTMENT_CODE='" + this.getOneQmsUsersTrainingsRepVwDetails[obj].departmentCode + "'";
      if (status != "All") {
        if (status == "OVERDUE") {
          status = "(OVERDUE=1 OR LOCKED_OVERDUE";
          whereVal = whereVal + " AND " + status + "=1)";
        } else if (status == "LOCKED") {
          status = "(LOCKED=1 OR PERMENANTLY_LOCKED";
          whereVal = whereVal + " AND " + status + "=1)";
        } else {
          whereVal = whereVal + " AND " + status + "=1";
        }
      }
      this.detailsGridGetCall("user", "s", whereVal);
    } else if (this.selectedOption == 'Instructor Trainings') {
      if (this.showTrainerLevel) {
        let searchByInstructorTrainer1 = "";
        if (this.searchByInstructorTrainer.length > 0) {
          for (let j = 0; j < this.searchByInstructorTrainer.length; j++) {
            console.log("searchByInstructorTrainer1=", searchByInstructorTrainer1);
            searchByInstructorTrainer1 += this.searchByInstructorTrainer[j];
            searchByInstructorTrainer1 += j == this.searchByInstructorTrainer.length - 1 ? "" : ",";
          }

          this.selectedStatus = this.getOneQmsUsersTrainingsRepVwDetails[obj].trainingName + "-" + this.statusVal(status);
          console.log("searchByInstructorTrainer1=", searchByInstructorTrainer1)
          whereVal = " AND TRAINER_ID IN (" + searchByInstructorTrainer1 + ")";
          whereVal = whereVal + " AND TRAINING_NAME='" + this.getOneQmsUsersTrainingsRepVwDetails[obj].trainingName + "'";
          if (status != "All") {
            if (status == "OVERDUE") {
              status = "(OVERDUE=1 OR LOCKED_OVERDUE";
              whereVal = whereVal + " AND " + status + "=1)";
            } else if (status == "LOCKED") {
              status = "(LOCKED=1 OR PERMENANTLY_LOCKED";
              whereVal = whereVal + " AND " + status + "=1)";
            } else {
              whereVal = whereVal + " AND " + status + "=1";
            }
          }
          console.log("whereVal=", whereVal)
          this.detailsGridGetCall("inT", "s", whereVal);
        } else {
          this.selectedStatus = this.getOneQmsUsersTrainingsRepVwDetails[obj].trainingName + "-" + this.statusVal(status);
          whereVal = " AND TRAINING_NAME='" + this.getOneQmsUsersTrainingsRepVwDetails[obj].trainingName + "'";
          if (status != "All") {
            if (status == "OVERDUE") {
              status = "(OVERDUE=1 OR LOCKED_OVERDUE";
              whereVal = whereVal + " AND " + status + "=1)";
            } else if (status == "LOCKED") {
              status = "(LOCKED=1 OR PERMENANTLY_LOCKED";
              whereVal = whereVal + " AND " + status + "=1)";
            } else {
              whereVal = whereVal + " AND " + status + "=1";
            }
          }
          this.detailsGridGetCall("inT", "s", whereVal);
        }
      } else if (this.getSelectedTrainingId) {
        this.selectedStatus = this.getOneQmsUsersTrainingsRepVwDetails[obj].trainingName + "-" + this.statusVal(status);

        whereVal = " AND TRAINING_SCHEDULE_ID IN (" + this.getSelectedTrainingId + ")";
        whereVal = whereVal + " AND TRAINING_NAME='" + this.getOneQmsUsersTrainingsRepVwDetails[obj].trainingName + "'";
        if (status != "All") {
          if (status == "OVERDUE") {
            status = "(OVERDUE=1 OR LOCKED_OVERDUE";
            whereVal = whereVal + " AND " + status + "=1)";
          } else if (status == "LOCKED") {
            status = "(LOCKED=1 OR PERMENANTLY_LOCKED";
            whereVal = whereVal + " AND " + status + "=1)";
          } else {
            whereVal = whereVal + " AND " + status + "=1";
          }
        }
        this.detailsGridGetCall("inT", "s", whereVal);
      } else {
        this.selectedStatus = this.getOneQmsUsersTrainingsRepVwDetails[obj].trainingName + "-" + this.statusVal(status);
        whereVal = " AND TRAINING_NAME='" + this.getOneQmsUsersTrainingsRepVwDetails[obj].trainingName + "'";
        if (status != "All") {
          if (status == "OVERDUE") {
            status = "(OVERDUE=1 OR LOCKED_OVERDUE";
            whereVal = whereVal + " AND " + status + "=1)";
          } else if (status == "LOCKED") {
            status = "(LOCKED=1 OR PERMENANTLY_LOCKED";
            whereVal = whereVal + " AND " + status + "=1)";
          } else {
            whereVal = whereVal + " AND " + status + "=1";
          }
        }
        this.detailsGridGetCall("inT", "s", whereVal);
      }

    }

  }

  getDetailsOrgTraining(listOfUsersData: any, status: any, type: any) {
    this.pagedItemsSecond = [];
    this.getOneQmsUsersTrainingsRepVw = {};
    this.selectedStatus = "";
    let whereVal = "";
    if (type == 'users') {
      this.selectedStatus = listOfUsersData.usrFullname + "-" + this.statusVal(status);
      whereVal = " AND USER_ID=" + listOfUsersData.userId + "";
      if (status != "All") {
        if (status == "OVERDUE") {
          status = "(OVERDUE=1 OR LOCKED_OVERDUE";
          whereVal = whereVal + " AND " + status + "=1)";
        } else if (status == "LOCKED") {
          status = "(LOCKED=1 OR PERMENANTLY_LOCKED";
          whereVal = whereVal + " AND " + status + "=1)";
        } else {
          whereVal = whereVal + " AND " + status + "=1";
        }
      }
      this.detailsGridGetCallOrgTrainingUsers("user", "s", whereVal, listOfUsersData);
    } else if (type == 'training') {
      this.selectedStatus = listOfUsersData.trainingName + "-" + this.statusVal(status);
      whereVal = " AND TRAINING_ID=" + listOfUsersData.trainingId;
      if (status != "All") {
        if (status == "OVERDUE") {
          status = "(OVERDUE=1 OR LOCKED_OVERDUE";
          whereVal = whereVal + " AND " + status + "=1)";
        } else if (status == "LOCKED") {
          status = "(LOCKED=1 OR PERMENANTLY_LOCKED";
          whereVal = whereVal + " AND " + status + "=1)";
        } else {
          whereVal = whereVal + " AND " + status + "=1";
        }
      }
      this.detailsGridGetCallOrgTrainingUsers("training", "s", whereVal, listOfUsersData);
    }
  }
  whereValsForExcelTemp: any;
  detailsGridGetCallOrgTrainingUsers(type: any, val: any, whereVal: any, obj: any) {
    this.whereValsForExcelTemp = "";
    this.columnList = "User Name,Training Name,Version,Training Code,Training Type,Group Name,Trainer Name,Status,Reason For Not Considered At Report,Is User Active,Designation Code,Department Code,Manager Username,User Training Status,Scheduled Training Status,Expiry Date,Due Date,Training Assigned On,Intimation Sent On,Started On,Completed On,Reminder Sent On,Escalation Sent On,Locked On,Failed Lock RM Approved On,Overdue Lock QA Approved On,Overdue Lock RM Approved On,Start Date,End Date,Comments,Evidence Document ID,Failed Attempts,Final Score";
    this.whereValsForExcelTemp = whereVal;
    let vals = "";
    vals = "NeedConsiderForReport";
    this.isProcessing = true;
    let tempOrgId = null;
    if (type == 'user') {
      tempOrgId = this.userlevelClickedOrgId;
    } else {
      tempOrgId = obj.orgId;
    }
    this.appService.getOneQmsUserTrainingsRepVwDetailsForOrg(tempOrgId, type, vals, whereVal, "No").subscribe((data: any) => {
      this.getOneQmsUsersTrainingsRepVw = data;
      this.calculateTotalPagesSecond = this.collectionSizeSecond / this.perPageSecond;
      this.pagerSecond.totalPages = undefined;
      this.collectionSizeSecond = this.getOneQmsUsersTrainingsRepVw.length;
      this.totalPagesSecond = Math.ceil(this.getOneQmsUsersTrainingsRepVw.length / this.itemsPerPageSecond);
      this.setPageSecond(1, 0);
      this.isProcessing = false;
    })
  }
  detailsGridGetCall(type: any, val: any, whereVal: any) {
    this.whereValsForExcelTemp = "";
    this.columnList = "User Name,Training Name,Version,Training Code,Training Type,Group Name,Trainer Name,Status,Reason For Not Considered At Report,Is User Active,Designation Code,Department Code,Manager Username,User Training Status,Scheduled Training Status,Expiry Date,Due Date,Training Assigned On,Intimation Sent On,Started On,Completed On,Reminder Sent On,Escalation Sent On,Locked On,Failed Lock RM Approved On,Overdue Lock QA Approved On,Overdue Lock RM Approved On,Start Date,End Date,Comments,Evidence Document ID,Failed Attempts,Final Score";
    this.whereValsForExcelTemp = whereVal;
    let vals = "";
    vals = "NeedConsiderForReport";
    this.isProcessing = true;
    this.appService.getOneQmsUserTrainingsRepVwDetails(this.selectedOrgValue[0], type, vals, whereVal, "No").subscribe((data: any) => {
      this.getOneQmsUsersTrainingsRepVw = data;
      this.calculateTotalPagesSecond = this.collectionSizeSecond / this.perPageSecond;
      this.pagerSecond.totalPages = undefined;
      this.collectionSizeSecond = this.getOneQmsUsersTrainingsRepVw.length;
      this.totalPagesSecond = Math.ceil(this.getOneQmsUsersTrainingsRepVw.length / this.itemsPerPageSecond);
      this.setPageSecond(1, 0);
      this.isProcessing = false;
    })
  }
  showOnlyNotConsiderRtp(e: any) {
    if (e.checked) {
      this.showOnlyConsider = true;
      let column = 'consideredForReport';
      this.pagedItemsSecond = this.getOneQmsUsersTrainingsRepVw.filter((item: any) => {
        const columnValue = item[column];
        return columnValue.toLowerCase().includes('n');
      });
      this.calculateTotalPagesSecond = this.collectionSizeSecond / this.perPageSecond;
      this.pagerSecond.totalPages = undefined;
      this.collectionSizeSecond = this.pagedItemsSecond.length;
      this.totalPagesSecond = Math.ceil(this.pagedItemsSecond.length / this.itemsPerPageSecond);
      this.setPageSecond1(1, 0);
      console.log(this.pagedItemsSecond)
    } else {
      this.showOnlyConsider = false;
      this.calculateTotalPagesSecond = this.collectionSizeSecond / this.perPageSecond;
      this.pagerSecond.totalPages = undefined;
      this.collectionSizeSecond = this.getOneQmsUsersTrainingsRepVw.length;
      this.totalPagesSecond = Math.ceil(this.getOneQmsUsersTrainingsRepVw.length / this.itemsPerPageSecond);
      this.setPageSecond(1, 0);
    }
  }
  setPageSecond1(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPagesSecond) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pagerSecond = this.paginationService.getPager(this.pagedItemsSecond.length, page, this.perPageSecond, targetpage);
    if (this.pagedItemsSecond.length > 0) {
      this.pagedItemsSecond = this.pagedItemsSecond.slice(this.pagerSecond.startIndex, this.pagerSecond.endIndex + 1);
    }
  }
  selectAllChecked: boolean = false;
  selectAllRows() {
    for (const user of this.getOneQmsUsersTrainingsRepVw) {
      user.isSelected = this.selectAllChecked;
    }
  }
  childCheckboxChanged() {
    this.selectAllChecked = this.getOneQmsUsersTrainingsRepVw.every((user: any) => user.isSelected);
  }
  paginationCallSecond(value: number) {
    this.perPageSecond = value;
    this.setPageSecond(this.pagerSecond.currentPage, 0);
  }
  setPageSecond(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPagesSecond) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pagerSecond = this.paginationService.getPager(this.getOneQmsUsersTrainingsRepVw.length, page, this.perPageSecond, targetpage);
    if (this.getOneQmsUsersTrainingsRepVw.length > 0) {
      this.pagedItemsSecond = this.getOneQmsUsersTrainingsRepVw.slice(this.pagerSecond.startIndex, this.pagerSecond.endIndex + 1);
    }
  }
  setPage3rd(page: number, targetpage: number) {
    if (page < 1 || page > this.pager3rd.totalPages3rd) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager3rd = this.paginationService.getPager(this.getOneQmsUsersTrainingsRepVwTrainingCountByOr.length, page, this.perPage3rd, targetpage);
    if (this.getOneQmsUsersTrainingsRepVwTrainingCountByOr.length > 0) {
      this.pagedItems3rd = this.getOneQmsUsersTrainingsRepVwTrainingCountByOr.slice(this.pager3rd.startIndex, this.pager3rd.endIndex + 1);
    }
  }

  paginationCall4th(value: number) {
    this.perPage4th = value;
    this.setPage4th(this.pager4th.currentPage, 0);
  }
  setPage4th(page: number, targetpage: number) {
    if (page < 1 || page > this.pager4th.totalPages4th) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager4th = this.paginationService.getPager(this.getOneQmsUsersTrainingsRepVwUserCountByor.length, page, this.perPage4th, targetpage);
    if (this.getOneQmsUsersTrainingsRepVwUserCountByor.length > 0) {
      this.pagedItems4th = this.getOneQmsUsersTrainingsRepVwUserCountByor.slice(this.pager4th.startIndex, this.pager4th.endIndex + 1);
    }
  }
  paginationCall3rd(value: number) {
    this.perPage3rd = value;
    this.setPage3rd(this.pager3rd.currentPage, 0);
  }
  //audit trails
  auditTrail: any = {};
  @ViewChild(StaticAuditTrailComponent) staticAuditTrailComponent!: StaticAuditTrailComponent;
  openAuditTrail(certificate: any) {
    this.message.tableOrView_Name = "TMS_USER_TRAININGS_REP_AU_VW";
    this.message.columnList_DB = "CREATED_TS,END_TS,ACTION_FLAG,LOCKED_ON,NO_OF_OVERDUE_UNLOCK,NO_OF_FAILED_UNLOCK,NO_OF_TIMES_COMPLETED,SCHEDULED_TRAINING_STATUS,TRAINER_NAME,SCHEDULED_TRAINING_ASSESSMENT,START_DATE,END_DATE,VERSION,TRAINING_NAME,TRAINING_CODE,EXPIRY_DATE,USER_TRAINING_STATUS,STARTED_ON,COMPLETED_ON,CATEGORY_CODE,TYPE,TOTAL_DURATION,LANGUAGE,IS_LATEST_VERSION,IS_LATEST_PUBLISHED_VERSION,GROUP_NAME,IS_GROUP_ACTIVE,TRAINING_LEVEL,DUE_N_DAY_FROM_ASSIGNED,REMIND_N_DAY_BEFORE_DUE,REMIND_EVERY_N_DAYS,ESCALATE,ESCALATE_EVERY_N_DAYS,REPEAT_TRAINING,REPEAT_INTERVAL,REPEAT_INTERVAL_UNIT,ALLOWED_FAILED_ATTEMPTS,ALLOWED_FAILED_ATTEMPTS_AFTER_UNLOCK,MAX_ALLOWED_FAILED_ATTEMPTS,ALLOW_TO_REVIEW_RESULTS,SHOW_ANSWERS_AT_REVIEW,OVERDUE_RM_APPROVAL_REQD,OVERDUE_QA_APPROVAL_REQD,LIST_OF_QA_USERS,DUE_N_DAY_FROM_OVERDUE_UNLOCK,RETAKE_AFTER_N_MIN_ON_FAILED_ATTEMPT,TRAINING_ASSIGNED_ON,TRAINING_ASSIGNED_BY_USER,IS_TRAINING_AT_GROUP_ACTIVE,IS_USER_AT_GROUP_ACTIVE,USER_NAME,USR_FULLNAME,DESIGNATION_CODE,DEPARTMENT_CODE,MANAGER_USERNAME,MANAGER_FULLNAME,IS_USER_ACTIVE,EMAIL_ADDRESS,INTIMATION_SCHEDULED,INTIMATION_SENT_ON,REMINDER_SENT_ON,ESCALATION_SENT_ON,MARKED_AS_COMPLETED_BY_USER,COMMENTS,FINAL_SCORE,FAILED_ATTEMPTS,FAILED_ATTEMPTS_AFTER_UNLOCK,FAILED_ATTEMPT_REACHED,MAX_FAILED_ATTEMPT_REACHED,RELAUNCH_REASON,ESIGNATURE_DONE,FAILED_LOCK_RM_APPROVED_ON,OVERDUE_LOCK_RM_APPROVED_ON,OVERDUE_LOCK_QA_APPROVED_ON,FAILED_ON";
    this.message.columnList_UI = "Timestamp Created,Timestamp Ended,Action Flag,Locked On,No. of Overdue Unlocks,No. of Failed Unlocks,No. of Times Completed,Scheduled Training Status,Trainer Name,Scheduled Training Assessment,Start Date,End Date,Version,Training Name,Training Code,Expiry Date,User Training Status,Started On,Completed On,Category Code,Type,Total Duration,Language,Is Latest Version,Is Latest Published Version,Group Name,Is Group Active,Training Level,Due N Days from Assigned,Remind N Days Before Due,Remind Every N Days,Escalate,Escalate Every N Days,Repeat Training,Repeat Interval,Repeat Interval Unit,Allowed Failed Attempts,Allowed Failed Attempts After Unlock,Max Allowed Failed Attempts,Allow to Review Results,Show Answers at Review,Overdue RM Approval Required,Overdue QA Approval Required,List of QA Users,Due N Days from Overdue Unlock,Retake After N Minutes on Failed Attempt,Training Assigned On,Training Assigned By,Is Training at Group Active,Is User at Group Active,User Name,User Fullname,Designation Code,Department Code,Manager Username,Manager Fullname,Is User Active,Email Address,Intimation Scheduled,Intimation Sent On,Reminder Sent On,Escalation Sent On,Marked As Completed By User,Comments,Final Score,Failed Attempts,Failed Attempts After Unlock,Failed Attempt Reached,Max Failed Attempt Reached,Relaunch Reason,ESignature Done,Failed Lock RM Approved On,Overdue Lock RM Approved On,Overdue Lock QA Approved On,Failed On";
    this.message.whereClause_AU = " AND USER_TRAINING_ID=" + certificate.userTrainingId;
    this.message.columnList_Report = "Timestamp Created,Timestamp Ended,Action Flag,Locked On,No. of Overdue Unlocks,No. of Failed Unlocks,No. of Times Completed,Scheduled Training Status,Trainer Name,Scheduled Training Assessment,Start Date,End Date,Version,Training Name,Training Code,Expiry Date,User Training Status,Started On,Completed On,Category Code,Type,Total Duration,Language,Is Latest Version,Is Latest Published Version,Group Name,Is Group Active,Training Level,Due N Days from Assigned,Remind N Days Before Due,Remind Every N Days,Escalate,Escalate Every N Days,Repeat Training,Repeat Interval,Repeat Interval Unit,Allowed Failed Attempts,Allowed Failed Attempts After Unlock,Max Allowed Failed Attempts,Allow to Review Results,Show Answers at Review,Overdue RM Approval Required,Overdue QA Approval Required,List of QA Users,Due N Days from Overdue Unlock,Retake After N Minutes on Failed Attempt,Training Assigned On,Training Assigned By,Is Training at Group Active,Is User at Group Active,User Name,User Fullname,Designation Code,Department Code,Manager Username,Manager Fullname,Is User Active,Email Address,Intimation Scheduled,Intimation Sent On,Reminder Sent On,Escalation Sent On,Marked As Completed By User,Comments,Final Score,Failed Attempts,Failed Attempts After Unlock,Failed Attempt Reached,Max Failed Attempt Reached,Relaunch Reason,ESignature Done,Failed Lock RM Approved On,Overdue Lock RM Approved On,Overdue Lock QA Approved On,Failed On";
    this.message.whereClause_Report = " WHERE USER_TRAINING_ID=" + certificate.userTrainingId;
    this.message.report_And_Popup_Name = "Training Report Audit Trail";
    console.log("certificate", certificate);
    this.staticAuditTrailComponent.triggerTrail(certificate);
  }
  //evi start
  eviDownload(value: any) {
    this.isProcessing = true;
    this.appService.eviDocuments(value.evidenceDocId);
    this.isProcessing = false;
  }
  //cer start
  visibleCertificationPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('certificationPopup', { static: true }) certificationPopup: TemplateRef<any>;
  certificationPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '100px' },
  };
  isDefaultTemplate: boolean = false;
  isWithScoreTemplate: boolean = false;
  certificateTemplate: any = {};
  certificateData: any;
  oneQmsOrgImagesDetails: any = {};
  oneQmsPrive: any = {};
  oneQmsPrive1: any = {};
  orgData: any = {};
  isEsignRequired: boolean = false;
  reasonForSign: any;
  userDetails: any = {};
  trainingData: any = {};
  cerDownload(value: any) {
    this.userDetails = {};
    this.trainingData = {};
    this.certificateTemplate = null;
    this.certificateData = null;
    this.isDefaultTemplate = false;
    this.isWithScoreTemplate = false;
    this.reasonForSign = null;
    this.orgData = {};
    let data = {
      orgId: value.orgId,
    }
    this.appService.getOneQmsOrganization(data).subscribe((data: any) => {
      this.orgData = data;
    })
    this.isProcessing = true;
    this.appService.getUserTrainingsByTrainingId(value.userTrainingId).subscribe((data: any) => {
      this.isProcessing = false;
      this.trainingData = data[0];
      this.appService.getUserDetailsForTrainingDashboard().subscribe((data: any) => {
        this.userDetails = data[0];
      })
      if (this.trainingData.finalScore) {
        console.log("this.trainingData1=", this.trainingData);
        this.isProcessing = true;
        this.appService.getTrainingCertificateTemplates().subscribe({
          next: (data: any) => {
            this.isProcessing = false;
            for (const item of data) {
              if (item.isDefaultWithscoreTemplate === "Y") {
                this.certificateTemplate = item;
                break;
              }
            }
            if (this.certificateTemplate) {
              if (this.certificateTemplate.template == undefined || this.certificateTemplate.template == null) {
                this.isDefaultTemplate = false;
              } else {
                this.isDefaultTemplate = true;
                this.buildCertificateData(this.certificateTemplate.template, value);
              }
            } else {
              this.isDefaultTemplate = false;
            }
            this.visibleCertificationPopup = this.dialog.open(this.certificationPopup, this.certificationPopupConfig);
          }, error: (error) => {
            this.isProcessing = false;
            this.visibleCertificationPopup = this.dialog.open(this.certificationPopup, this.certificationPopupConfig);
            throw error;
          }
        });
        this.isWithScoreTemplate = true;
      } else {
        console.log("this.trainingData2=", this.trainingData);
        this.isProcessing = true;
        this.appService.getTrainingCertificateTemplates().subscribe({
          next: (data: any) => {
            this.isProcessing = false;
            for (const item of data) {
              if (item.isDefaultWithoutscoreTemplate === "Y") {
                this.certificateTemplate = item;
                break;
              }
            }
            if (this.certificateTemplate) {
              if (this.certificateTemplate.template == undefined || this.certificateTemplate.template == null) {
                this.isDefaultTemplate = false;
              } else {
                this.isDefaultTemplate = true;
                this.buildCertificateData(this.certificateTemplate.template, value);
              }
            } else {
              this.isDefaultTemplate = false;
            }
            this.visibleCertificationPopup = this.dialog.open(this.certificationPopup, this.certificationPopupConfig);
          }, error: (error) => {
            this.isProcessing = false;
            this.visibleCertificationPopup = this.dialog.open(this.certificationPopup, this.certificationPopupConfig);
            throw error;
          }
        });
        this.isWithScoreTemplate = false;
      }

    })
    console.log("value=", value);
    this.isDefaultTemplate = false;
    this.isWithScoreTemplate = false;
  }
  buildCertificateData(data: any, value: any) {
    if (data.includes("&lt;PERCENTAGE&gt;")) {
      data = data.split("&lt;PERCENTAGE&gt;").join(this.trainingData.finalScore);
    }
    if (data.includes("&lt;ORG_NAME&gt;")) {
      data = data.split("&lt;ORG_NAME&gt;").join(this.orgData.orgLongName ?? "");
    }
    if (data.includes("&lt;ORG_LOGO&gt;")) {
      if (this.oneQmsOrgImagesDetails != undefined && this.oneQmsOrgImagesDetails != null) {
        data = data.split("&lt;ORG_LOGO&gt;").join(this.oneQmsOrgImagesDetails.logoImage);
      } else {
        data = data.split("&lt;ORG_LOGO&gt;").join("");
      }
    }
    if (data.includes("&lt;TRAINING_NAME&gt;")) {
      data = data.split("&lt;TRAINING_NAME&gt;").join(this.trainingData.trainingName);
    }
    if (data.includes("&lt;TRAINING_TYPE&gt;")) {
      data = data.split("&lt;TRAINING_TYPE&gt;").join(this.trainingData.type);
    }
    if (data.includes("&lt;COMPLETED_ON&gt;")) {
      let date = this.convertTZ(new Date(this.trainingData.completedOn), localStorage.getItem("timezone") ? localStorage.getItem("timezone") : "GMT")
      data = data.split("&lt;COMPLETED_ON&gt;").join(date);
    }
    if (data.includes("&lt;USER_FIRST_NAME&gt;")) {
      data = data.split("&lt;USER_FIRST_NAME&gt;").join(this.userDetails.firstName);
    }
    if (data.includes("&lt;USER_LAST_NAME&gt;")) {
      data = data.split("&lt;USER_LAST_NAME&gt;").join(this.userDetails.lastName);
    }
    if (data.includes("&lt;REASON_FOR_SIGN&gt;")) {
      data = data.split("&lt;REASON_FOR_SIGN&gt;").join(this.reasonForSign ?? "");
    }
    if (data.includes("&lt;USER_DESIGNATION&gt;")) {
      data = data.split("&lt;USER_DESIGNATION&gt;").join(this.userDetails.designation ?? "");
    }
    this.certificateData = this.sanitizer
      .bypassSecurityTrustHtml(data);
  }
  public downloadAsPdf(): void {
    let data: any;
    if (this.isDefaultTemplate) {
      data = document.getElementById('dataToExportFromTemp');  //Id of the table
    } else {
      data = document.getElementById('dataToExport');  //Id of the table
    }
    html2canvas(data).then(canvas => {
      // Few necessary setting options
      let imgWidth = 208;
      let imgHeight = canvas.height * imgWidth / canvas.width;
      const contentDataURL = canvas.toDataURL('image/png')
      let pdf = new jspdf('p', 'mm', 'a4'); // A4 size page of PDF
      let position = 0;
      pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight)
      pdf = this.addWaterMark(pdf);
      pdf.save('Certificate.pdf'); // Generated PDF
    });
  }

  addWaterMark(doc: any) {
    let timezone;
    if (localStorage.getItem("timezone") && localStorage.getItem("timezone") != null && localStorage.getItem("timezone") != "null") {
      console.log("timezone==", localStorage.getItem("timezone"));
      timezone = localStorage.getItem("timezone");
    } else {
      console.log("timezone=", "GMT");
      timezone = "GMT";
    }
    let totalPages = doc.internal.getNumberOfPages();
    let watermark = "Printed by: " + localStorage.getItem("loggedUserName") + " | Printed on: " + this.convertTZ(new Date(), timezone) + "(" + timezone + ")";
    const fontSize = 12;
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setFontSize(fontSize);
      doc.setTextColor(150);
      doc.text(5, doc.internal.pageSize.height - 5, watermark);
    }
    return doc;
  }
  convertDateAndTime(date: Date) {
    const monthNames = ["Jan", "Feb", "Mar", "Apr",
      "May", "Jun", "Jul", "Aug",
      "Sep", "Oct", "Nov", "Dec"];
    const day = date.getDate();
    const monthIndex = date.getMonth();
    const monthName = monthNames[monthIndex];
    const year = date.getFullYear();
    return `${day}-${monthName}-${year} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`
  }


  convertDate(date: any) {
    const monthNames = ["Jan", "Feb", "Mar", "Apr",
      "May", "Jun", "Jul", "Aug",
      "Sep", "Oct", "Nov", "Dec"];
    const day = date.getDate();
    const monthIndex = date.getMonth();
    const monthName = monthNames[monthIndex];
    const year = date.getFullYear();
    return `${day}-${monthName}-${year}`
  }
  // end cer

  selectBoxForDepartment() {
    this.departmentListDropdown = [];
    this.departmentListDropdown = this.dropDownForDepartment.map((item: dropDownInterface) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    }));
    console.log("this.departmentListDropdown=", this.departmentListDropdown);
  }
  selectBoxForDepartmentMain() {
    this.departmentListDropdown = [];
    this.departmentListDropdown = this.dropDownForDepartment.map((item: dropDownInterface) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    }));
  }
  openReportPopupTMS(item: any) {
    this.excelPdf.dropDown = this.columnList.split(',');
    this.pdfPageSizes = JSON.parse(sessionStorage.getItem('pdfPageSizes') ?? '{}');
    this.excelPdf.pdfPageSize = 'A4';
    this.isForExcel = item == 'Excel';
    this.popupDataTitle.title = item == 'Excel' ? 'Excel Report' : 'PDF Report';
    [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    this.pdfSelection = false;
    this.reportName = `${this.clickedType}_${this.clickedVal}` + " Report";
    this.visibleExcelPdfPopup = this.dialog.open(this.excelPdfPopup, this.excelPdfPopupConfig);
    this.isSaveReport = false;
  }
  @ViewChild('pdf') pdf: MatSelect;
  pdfSelection = false;
  generateReportTMS(value: any) {
    let orgiid;
    if (value == 'Pdf' && this.manuallyPicked && !this.selectedColumns.length) {
      this.showSnackBar('Please select the Columns', 'E');
    } else {
      this.appService.isProcessingRep = true;
      let tname = "";
      let colList = "";
      let fieldList = "";
      let mod = "";
      this.whereValsForExcel = "";
      if (this.selectedOption == 'Training Groups') {
        tname = "TMS_USER_TRAININGS_REP_CNT_VW";
        colList = "USR_FULLNAME,TRAINING_NAME,VERSION,TRAINING_CODE,TRAINING_TYPE,GROUP_NAME,TRAINER_NAME,STATUS,REASON_FOR_NOT_CONSIDERED_AT_REPORT,IS_USER_ACTIVE,DESIGNATION_CODE,DEPARTMENT_CODE,MANAGER_USERNAME,USER_TRAINING_STATUS,SCHEDULED_TRAINING_STATUS,EXPIRY_DATE,DUE_DATE,TRAINING_ASSIGNED_ON,USER_TRAINING_ASSIGNED_ON,INTIMATION_SENT_ON,STARTED_ON,COMPLETED_ON,REMINDER_SENT_ON,ESCALATION_SENT_ON,LOCKED_ON,FAILED_LOCK_RM_APPROVED_ON,OVERDUE_LOCK_QA_APPROVED_ON,OVERDUE_LOCK_RM_APPROVED_ON,START_DATE,END_DATE,COMMENTS,FAILED_ATTEMPTS,FINAL_SCORE";
        fieldList = "User Name,Training Name,Version,Training Code,Training Type,Group Name,Trainer Name,Status,Reason For Not Considered At Report,Is User Active,Designation Code,Department Code,Manager Username,User Training Status,Scheduled Training Status,Expiry Date,Due Date,Training Assigned On,User Training Assigned On,Intimation Sent On,Started On,Completed On,Reminder Sent On,Escalation Sent On,Locked On,Failed Lock RM Approved On,Overdue Lock QA Approved On,Overdue Lock RM Approved On,Start Date,End Date,Comments,Failed Attempts,Final Score";
        this.whereValsForExcel = this.whereValsForExcelTemp;
        if (this.selectedOption == 'Organization') {
          orgiid = this.tempOrgIdForUserTrainingExcel.toString()
        } else {
          orgiid = this.selectedOrgValue[0].toString()
        }
        mod = "tmsGr";
      } else {
        tname = "TMS_USER_TRAININGS_REP_CNT_VW";
        colList = "USR_FULLNAME,TRAINING_NAME,VERSION,TRAINING_CODE,TRAINING_TYPE,GROUP_NAME,TRAINER_NAME,STATUS,REASON_FOR_NOT_CONSIDERED_AT_REPORT,IS_USER_ACTIVE,DESIGNATION_CODE,DEPARTMENT_CODE,MANAGER_USERNAME,USER_TRAINING_STATUS,SCHEDULED_TRAINING_STATUS,EXPIRY_DATE,DUE_DATE,TRAINING_ASSIGNED_ON,USER_TRAINING_ASSIGNED_ON,INTIMATION_SENT_ON,STARTED_ON,COMPLETED_ON,REMINDER_SENT_ON,ESCALATION_SENT_ON,LOCKED_ON,FAILED_LOCK_RM_APPROVED_ON,OVERDUE_LOCK_QA_APPROVED_ON,OVERDUE_LOCK_RM_APPROVED_ON,START_DATE,END_DATE,COMMENTS,FAILED_ATTEMPTS,FINAL_SCORE";
        fieldList = "User Name,Training Name,Version,Training Code,Training Type,Group Name,Trainer Name,Status,Reason For Not Considered At Report,Is User Active,Designation Code,Department Code,Manager Username,User Training Status,Scheduled Training Status,Expiry Date,Due Date,Training Assigned On,User Training Assigned On,Intimation Sent On,Started On,Completed On,Reminder Sent On,Escalation Sent On,Locked On,Failed Lock RM Approved On,Overdue Lock QA Approved On,Overdue Lock RM Approved On,Start Date,End Date,Comments,Failed Attempts,Final Score";
        let conForReport = "";
        if (!(this.selectedOption === 'Instructor Trainings' || this.message.showRetakeAndMarkasCompleted)) {
          conForReport = " AND CONSIDERED_FOR_REPORT='Y'";
        }
        if (this.selectedOption == 'Organization') {
          orgiid = this.tempOrgIdForUserTrainingExcel.toString()
        } else {
          orgiid = this.selectedOrgValue[0].toString()
        }
        if (this.whereValsForExcelTemp == "noStatus") {
          this.whereValsForExcel = " WHERE ORG_ID=" + orgiid + conForReport;

        } else {
          this.whereValsForExcel = " WHERE ORG_ID=" + orgiid + conForReport + this.whereValsForExcelTemp;

        }
        mod = "tms";
      }


      console.log(value, "--------------------");
      const data = {
        groupId: this.qmsservice.selectedGroup
      }

      const data1: any = {
        orgId: orgiid,

        tableOrViewName: tname,
        columnsList: colList,
        fieldLabelsList: fieldList,
        invisibleColumn: "",
        orderByClause: "",
        fieldSizeList: "",
        columnsListarray: [],
        fieldColumnarray: [],
        invisibleColumnarray: [],
        fieldSizeListArray: [],
        status: null,
        codelistGroup: null,
        manualEntryDataFields: null,
        groupId: this.qmsservice.selectedActivityGroupId,
        chartStatus: null,
        wherVal: this.whereValsForExcel,
        reModule: mod,
        mainDash: "Tms",
        logoId: 0,
        module: "TRN",
        isSaveRep: this.isSaveReport ? 'Y' : 'N',
        reportName: this.reportName ?? "Dashboard_Report",
        currentStatus: "NA",
        groupName: this.reportName + "",
      }
      this.reportObj = { ...data1, ...data };
      debugger;
      if (value == 'Excel') {
        const pdfData = {
          ...this.reportObj, title: this.selectedOption, columns: [],
          "informationTab": {
            "Report Name": this.selectedOption,
            "Exported By": localStorage.getItem("loggedUserName")
          }
        }
        this.appService.downloadexcelForChart(pdfData, "Report.xlsx");
      } else {
        const pdfData = {
          ...this.reportObj, title: this.selectedOption + "_Report", columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.columnList.split(',').slice(0, 10).join(','), pdfPageSize: this.excelPdf.pdfPageSize
        }
        this.appService.downloadPdfForChart(pdfData, this.selectedOption + "_Report.pdf");
      }
    }
  }

  getDetailsOrg(listOfUsersData: any) {
    this.selectedStatus = "Total";
    this.getOneQmsUsersTrainingsRepVw = false;
    this.getOneQmsUsersTrainingsRepVwUserCountByor = [];
    this.getOneQmsUsersTrainingsRepVwTrainingCountByOr = [];
    this.tempOrgIdForUserTrainingExcel = listOfUsersData.orgId;
    this.detailsGridGetCallOrgTrainingUsers('users', 's', "noStatus", listOfUsersData);
  }
  userlevelClickedOrgId: any;
  getDetailsOrgUsers(listOfUsersData: any) {
    this.getOneQmsUsersTrainingsRepVw = false;
    this.getOneQmsUsersTrainingsRepVwUserCountByor = [];
    this.getOneQmsUsersTrainingsRepVwTrainingCountByOr = [];
    this.whereValsForExcelTempOrg = "";
    this.columnList = "User Name,Training Name,Version,Training Code,Training Type,Group Name,Trainer Name,Status,Reason For Not Considered At Report,Is User Active,Designation Code,Department Code,Manager Username,User Training Status,Scheduled Training Status,Expiry Date,Due Date,Training Assigned On,Intimation Sent On,Started On,Completed On,Reminder Sent On,Escalation Sent On,Locked On,Failed Lock RM Approved On,Overdue Lock QA Approved On,Overdue Lock RM Approved On,Start Date,End Date,Comments,Evidence Document ID,Failed Attempts,Final Score";
    let vals = "";
    vals = "NeedConsiderForReport";
    this.isProcessing = true;
    this.userlevelClickedOrgId = listOfUsersData.orgId;
    this.tempOrgIdForUserTrainingExcel = listOfUsersData.orgId;
    this.appService.getOneQmsUserTrainingsRepVwUsersCountByOrg('or', vals, listOfUsersData.orgId).subscribe((data: any) => {
      this.getOneQmsUsersTrainingsRepVwUserCountByor = data;
      this.calculateTotalPages4th = this.collectionSize4th / this.perPage4th;
      this.pager4th.totalPages = undefined;
      this.collectionSize4th = this.getOneQmsUsersTrainingsRepVwUserCountByor.length;
      this.totalPages4th = Math.ceil(this.getOneQmsUsersTrainingsRepVwUserCountByor.length / this.itemsPerPage4th);
      this.setPage4th(1, 0);
      this.isProcessing = false;
    })
  }
  whereValsForExcelTempOrg: any;
  tempOrgIdForUserTrainingExcel: any;
  getDetailsOrgTrainings(listOfUsersData: any) {
    this.getOneQmsUsersTrainingsRepVw = false;
    this.getOneQmsUsersTrainingsRepVwUserCountByor = [];
    this.getOneQmsUsersTrainingsRepVwTrainingCountByOr = [];
    this.whereValsForExcelTempOrg = "";
    this.columnList = "User Name,Training Name,Version,Training Code,Training Type,Group Name,Trainer Name,Status,Reason For Not Considered At Report,Is User Active,Designation Code,Department Code,Manager Username,User Training Status,Scheduled Training Status,Expiry Date,Due Date,Training Assigned On,Intimation Sent On,Started On,Completed On,Reminder Sent On,Escalation Sent On,Locked On,Failed Lock RM Approved On,Overdue Lock QA Approved On,Overdue Lock RM Approved On,Start Date,End Date,Comments,Evidence Document ID,Failed Attempts,Final Score";
    this.tempOrgIdForUserTrainingExcel = listOfUsersData.orgId;
    let vals = "";
    vals = "NeedConsiderForReport";
    this.isProcessing = true;
    this.appService.getOneQmsUserTrainingsRepVwTrainingCountByOrg('or', vals, listOfUsersData.orgId).subscribe((data: any) => {
      this.getOneQmsUsersTrainingsRepVwTrainingCountByOr = data;
      let ii = 0;
      data.forEach((item: any, index: any) => {
        console.log("====", this.getOneQmsUsersTrainingsRepVwTrainingCountByOr[ii].orgId)
        const itemObj = this.dropDownForOrg.filter((d: { orgId: any; }) => d.orgId === this.getOneQmsUsersTrainingsRepVwTrainingCountByOr[ii].orgId);
        console.log("====", itemObj)
        this.getOneQmsUsersTrainingsRepVwTrainingCountByOr[ii].orgName = itemObj[0].orgLongName;
        ii++;
      });
      this.calculateTotalPages3rd = this.collectionSize3rd / this.perPage3rd;
      this.pager3rd.totalPages = undefined;
      this.collectionSize3rd = this.getOneQmsUsersTrainingsRepVwTrainingCountByOr.length;
      this.totalPages3rd = Math.ceil(this.getOneQmsUsersTrainingsRepVwTrainingCountByOr.length / this.itemsPerPage3rd);
      this.setPage3rd(1, 0);
      this.isProcessing = false;
    })
  }
  //tms end

  //dms start
  // Declare a flag to toggle the visibility of the additional field
  // Declare a flag to toggle the visibility of the additional field


  onDMSReportTypeSelectnew(event: any, item: any) {
    this.searchByDMSReportTypeMain = 'Default';
    if (event.isUserInput) {
      this.selectedDocumentType = null;
      this.pagedItemsDMS1 = [];
      this.tmsUserTrainingsRepVwDataForGrid = [];
      // Reset folder path and folderName
      this.selectedFolderPath = null;
      this.dmsGroupFoldersFieldData = {
        folderName: '',
        folderPath: ''
      };

      // Reset alert colors
      const manageDMSReportNameAlert = document.getElementById('manageDMSReportNameAlert') as HTMLElement;
      const folderMasterAlert = document.getElementById('folderMasterAlert') as HTMLElement;

      if (manageDMSReportNameAlert) {
        manageDMSReportNameAlert.style.color = '';
      }
      if (folderMasterAlert) {
        folderMasterAlert.style.color = '';
      }
      if (item.displayExp === 'Default') {
        this.showCharts = true;
        this.showDateRange = true;
      } else {
        this.showCharts = false;
        this.showDateRange = false;
      }
      this.onSelectedOptionForDMS = item.displayExp;
      console.log("this.onSelectedOptionForDMS=", this.onSelectedOptionForDMS);
      this.handleDropDownValidation('manageDMSReportNameAlert', item);
      if (this.selectedReportType === 'Documents' && this.onSelectedOptionForDMS === 'Master Index') {
        if (!this.dmsGroupFoldersFieldData.folderName) {
          if (folderMasterAlert) {
            folderMasterAlert.style.color = 'red';
          }
        }
      }
    }
  }
  selectBoxForDateRange() {
    this.dateRangeValueDropdown = [];
    this.dateRangeValueDropdown = this.dropDownForDateRange.map((item: { codelistCode: any; codelistName: any; }) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    }));
  }


  groupSearchText: string = '';
  groupSearchText1: string = '';
  groupSearchText2: string = '';
  groupSearchText3: string = '';
  groupSearchText4: string = '';
  getDmsFoldersVwDetails: any = [];
  ondocumentTypeSelectnew(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.documentTypeSelection = this.selectedDocumentType.length > 0;
      })
    }
  }
  showPhysicalFolderLevel(e: any) {
    if (e.target.checked) {
      this.physicalFolderLevel = true;
    } else {
      this.physicalFolderLevel = false;
    }
  }
  showDstributedFolderLevel(e: any) {
    if (e.target.checked) {
      this.distributedFolderLevel = true;
    } else {
      this.distributedFolderLevel = false;
    }
  }
  searchDocumentFunction() {
    this.popupDataTitle.title = "Search Folders";
    this.appService.setOrgVal(this.selectedOrgValueForDMS);
    this.visibleSearchFoldersPopup = this.dialog.open(this.searchFoldersPopup, this.searchFoldersPopupConfig);
  }
  showIncludeAmendmentsFlg(e: any) {
    if (e.target.checked) {
      this.includeAmendmentsFlg = true;
    } else {
      this.includeAmendmentsFlg = false;
    }
  }
  showAssociatedDocFlg(e: any) {
    if (e.target.checked) {
      this.associatedDocFlg = true;
    } else {
      this.associatedDocFlg = false;
    }
  }
  showIndividualFlg(e: any) {
    if (e.target.checked) {
      this.individualDocFlg = true;
    } else {
      this.individualDocFlg = false;
    }
  }
  cancelSeachFoldersFunction() {
    if (this.operationFlag == 'ADD') {
      this.popupDataTitle.title = this.popupDataTitle.title == "Search Folders" ? "Create DMS Group Folder" : "";
    } else {
      this.popupDataTitle.title = this.popupDataTitle.title == "Search Folders" ? "Update DMS Group Folder" : "";
    }
    this.visibleSearchFoldersPopup.close();
  }
  model = {
    documentData: {},
  };
  selectedFolderForCreateDoc: any = {};
  changeInFolderStructureChild(data: any) {
    this.model = data;
    this.selectedFolderForCreateDoc = this.model.documentData;
  }
  addFolderFunction() {
    if (this.selectedFolderForCreateDoc) {
      this.dmsGroupFoldersFieldData.folderPath = this.selectedFolderForCreateDoc.path;
      this.dmsGroupFoldersFieldData.folderName = this.selectedFolderForCreateDoc.path;
      this.onSelectedOptionForDMS == 'Master Index' && this.selectedReportType == 'Documents' && this.onNgModelChange(this.dmsGroupFoldersFieldData.folderName, 'folderMasterAlert')
      if (this.operationFlag == 'ADD') {
        this.popupDataTitle.title = this.popupDataTitle.title == "Search Folders" ? "Create DMS Group Folder" : "";
      } else {
        this.popupDataTitle.title = this.popupDataTitle.title == "Search Folders" ? "Update DMS Group Folder" : "";
      }
      this.visibleSearchFoldersPopup.close();
    } else {
      console.error("No folder selected for create document.");
    }
  }
  getcallMethod() {
    this.isProcessing = true;
    if (this.selectedDocumentType != null && this.selectedDocumentType.length > 0) {
      this.selectedDocumentTypeName = "";
      const codesArray: string[] = this.selectedDocumentType.join(',').split(",");
      this.selectedDocumentTypeName = codesArray.map(code => `'${code.trim()}'`).join(",");
    } else {
      this.selectedDocumentTypeName = null;
    }
    if (this.selectedFolderPath == "Repository") {
      this.selectedFolderPath = null;
    }
    this.tmsUserTrainingsRepVwDataForGrid = [];
    const data = {
      orgId: this.selectedOrgValue[0],
      gridName: this.dynamicGridName,
      groupId: null,
      mainOrg: "Yes"
    }
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {

        response.orderByClause ??= "";
        this.makeStickyColumns = response.fixedFieldCnt;
        this.columnList = "Doc Container,Document Type Name,Document Type Code,Document No,Document Name,Version,Status,Effective Date,Expiration Date,Published On,Published By User,Revision History,Cr Details,Document Description,Is Associated Document Type,Associated Document No,Associated Document From Version,Associated Document To Version,Associated Doc To Follow Same Expiry,Belongs To Individual,Belongs To User,Is Amendement Doc Type,Assignable At Trainings,Folder Name,Folder Status,Folder Path,All Parent Folder Status,Is Distributed Folder,Checkout Flag,Checkedout On,Checkedout By User,Checkinout Comments,Is Latest Version,Is Latest Published Version,Is Blinded,Blinded By User,Blinded On,Unblinded By User,Unblinded On,Unblind Reason,Is Extension In Progress,Is Withdrawal In Progress,Is Amendment In Progress,No Of Completed Extension,No Of Completed Amendment,Last Action On,Last Action Comments,Last Action By User,Created On,Created By,Updated On,Updated By";
        const data1: any = {
          orgId: this.selectedOrgValue[0].toString(),
          gridName: this.dynamicGridViewName,
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          selectedUserId: null,
          selectedFolderPath: this.selectedFolderPath,
          selectedDocumentTypeName: this.selectedDocumentTypeName,
          selectedDocContainer: this.selectedDocContainer,
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || "",
          mainOrg: "Yes"
        }

        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.isProcessing = false;
            this.tmsUserTrainingsRepVwDataForGrid = response1;
            this.showNoRecordFoundInventry = this.tmsUserTrainingsRepVwDataForGrid.length === 0;
            console.log('Data populated:', this.tmsUserTrainingsRepVwDataForGrid);
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            let rendereddata: any;
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const fieldSize of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(fieldSize + 'px');
            }
            for (let y = this.columnLists.columnsListarray.length - 1; y >= 0; y--) {
              for (const invisibleColumn of this.columnLists.invisibleColumnarray) {
                if (this.columnLists.columnsListarray[y] === invisibleColumn) {
                  this.columnLists.columnsListarray.splice(y, 1);
                  this.columnLists.fieldColumnarray.splice(y, 1);
                  this.columnLists.fieldSizeListArray.splice(y, 1);
                  break; // Exit the inner loop once a match is found
                }
              }
            }

            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const dataType of this.dataTypeList) {
                  if (dataType.columnName === this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = dataType.fieldType;
                  }
                }
              }
              for (const training of this.tmsUserTrainingsRepVwDataForGrid) {
                for (const dataType of this.dataTypeList) {
                  if (dataType.fieldType === 'CHECKBOX') {
                    training[dataType.columnName] = training[dataType.columnName] === "Y";
                  }
                }
              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.setPageDMS1(1, 0);
            });
            this.message.gridList = this.tmsUserTrainingsRepVwDataForGrid;
            this.collectionSize = this.tmsUserTrainingsRepVwDataForGrid.length;
            this.totalPages = Math.ceil(this.tmsUserTrainingsRepVwDataForGrid.length / this.itemsPerPage);
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  setPageDMS1(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.tmsUserTrainingsRepVwDataForGrid.length, page, this.perPage, targetpage);
    this.pagedItemsDMS1 = [];
    if (this.tmsUserTrainingsRepVwDataForGrid.length > 0) {
      this.pagedItemsDMS1 = this.tmsUserTrainingsRepVwDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }
  paginationCallDMS1(value: number) {
    this.perPage = value;
    this.setPageDMS1(this.pager.currentPage, 0);
  }
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      list.childCheckBoxs = true;
    } else {
      list.childCheckBoxs = false;
    }
  }
  getClobData1(list: any, colunName: any) {
    this.isProcessing = true;
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: colunName
    }
    this.htmlContent = "";
    this.appService.getClobToViewAudit(docObj).subscribe({
      next: (Response: any) => {
        console.log(Response.result);
        this.htmlContent = Response.result;
        this.editorComponent.openEditor(this.htmlContent, colunName);
      }, error: (error) => {
        console.log(error);
      }
    })
    this.isProcessing = false;
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      if (header.innerText.trim() === 'Doc Container' || header.innerText.trim() === 'DOC_CONTAINER') {
        index1++;
        return;
      }
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })
    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 2;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    elements2.forEach((column: any, key: any) => {
      const columnField = this.columnLists.columnsListarray1[key];
      if (columnField.columnsListarray1 === 'DOC_CONTAINER' || columnField.columnsListarray1 === 'Doc Container') {
        column.style.position = 'relative';
        return;
      }
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          column.style.background = 'white';
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }
  onClick(event: any) {

    this.snackbarRef?.dismiss();
    let templateName = event.target.innerText;
    const filteredQmsQuestionnaireTemplateData = this.tmsUserTrainingsRepVwDataForGrid.filter(
      (x: any) => x.TEMPLATE_NAME === templateName
    );

    if (filteredQmsQuestionnaireTemplateData.length > 0) {
      this.message.templateIdFromQmsQuestionnaireTemplate = filteredQmsQuestionnaireTemplateData[0].TEMPLATE_ID;
    }
    this.router.navigate(['dashboard/qmsQuestionnaireTemplateQuestion']);
  }
  onDocTypeChanges() {
    setTimeout(() => {
      this.newdocumentTypeSelection = this.documentTypeDropdown.length == this.selectedDocumentType.length
      this.handleDropDownValidation('initial-complaint-category-validation', this.selectedDocumentType)
    });
  }
  toggleAllSelection2(value: any) {
    if (value == 'newDocumentType') {
      if (this.newdocumentTypeSelection) this.newDocumentType.options.forEach((item: MatOption) => item.select());
      else {
        this.newDocumentType.options.forEach((item: MatOption) => item.deselect())
        this.selectedDocumentType = [];
      }
      setTimeout(() => {
        this.handleDropDownValidation('initial-complaint-category-validation', this.selectedDocumentType)
      });
    } else if (value == 'pdf') {
      if (this.pdfSelection) this.pdf.options.forEach((item: MatOption) => item.select());
      else {
        this.pdf.options.forEach((item: MatOption) => item.deselect())
        this.selectedColumns = [];

      }
      setTimeout(() => {
        this.handleDropDownValidation('execl-pdf', this.selectedColumns)
        this.convertArrayToString(this.selectedColumns);
      });

    } else if (value == 'columns') {
      if (this.isAllColumns) this.columns.options.forEach((item: MatOption) => item.select());
      else {
        this.columns.options.forEach((item: MatOption) => item.deselect())
        this.selectedColumns = [];
      }
      setTimeout(() => {
        if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
        this.convertArrayToString(this.selectedColumns);
      });
    }
  }

  applyFilter4(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems1 = this.tableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems1 = this.tableReportDataList.filter((item: any) => {
        const columnValue = item[column];
        // Check if columnValue is a string before calling toLowerCase()
        if (val === 'd') {
          if (columnValue) {
            let formattedDate = this.datePipe.transform(columnValue, this.appService.organizationDetails?.dateFormat ? 'DD-MMM-YYYY' : this.appService.organizationDetails?.dateFormat);
            console.log("columnValue2=", formattedDate);
            // Convert number to string before checking for inclusion
            return formattedDate ? formattedDate.toString().toLowerCase().includes(filter) : false;
          } else {
            return false;
          }

        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          // Convert number to string before checking for inclusion
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          // Format date to string before checking for inclusion
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        // If it's not a string, return false to exclude it from filtering
        return false;
      });
    }
  }
  setPageDMS2(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.tableReportDataList.length, page, this.perPage, targetpage);
    if (this.tableReportDataList.length > 0) {
      this.pagedItems1 = this.tableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }
  paginationCallDMS2(value: number) {
    this.perPage = value;
    this.setPageDMS2(this.pager.currentPage, 0);
  }
  data: any = {};
  data1: any = {};
  data2: any = {};

  generateReportDMS(value: any) {
    if (value == 'Pdf' && this.manuallyPicked && !this.selectedColumns.length) {
      this.showSnackBar('Please select the Columns', 'E');
    } else {
      this.appService.isProcessingRep = true;
      this.data = {};
      this.data1 = {};
      this.data2 = {};
      let tname = "";
      let colList = "";
      let fieldList = "";
      if (this.onSelectedOptionForDMS == 'Inventory') {
        this.whereValsForExcel = " WHERE ORG_ID=" + this.selectedOrgValue[0];
        if (this.selectedFolderPath && this.selectedFolderPath != undefined) {
          this.whereValsForExcel += " AND FOLDER_PATH='" + this.selectedFolderPath + "'";
        }
        if (this.selectedDocumentType != null && this.selectedDocumentType.length > 0) {
          this.selectedDocumentTypeName = "";
          const codesArray: string[] = this.selectedDocumentType.join(',').split(",");

          // Clear previous values if needed
          this.selectedDocumentTypeName = '';

          for (const code of codesArray) {
            this.selectedDocumentTypeName += `'${code.trim()}',`;
          }

          // Remove the trailing comma, if necessary
          if (this.selectedDocumentTypeName) {
            this.selectedDocumentTypeName = this.selectedDocumentTypeName.slice(0, -1);
          }
        } else {
          this.selectedDocumentTypeName = null;
        }
        if (this.selectedDocumentTypeName && this.selectedDocumentTypeName != undefined) {
          this.whereValsForExcel += " AND DOCUMENT_TYPE_CODE IN (" + this.selectedDocumentTypeName + ")";
        }
        if (this.selectedDocContainer && this.selectedDocContainer != undefined) {
          this.whereValsForExcel += " AND DOC_CONTAINER='" + this.selectedDocContainer + "'";
        }
        console.log("===", this.whereValsForExcel);
        this.data = {
          orgId: this.selectedOrgValue[0].toString(),
          gridName: this.dynamicGridName,
          groupId: null
        }
        this.appService.getDynamicGridHeaders(this.data).subscribe((response: any) => {

          response.orderByClause ??= "";
          this.data1 = {
            gridName: this.dynamicGridViewName,
            tableOrViewName: response.tableOrViewName ?? "",
            columnsList: response.columnsList ?? "",
            fieldLabelsList: response.fieldLabelsList ?? "",
            invisibleColumn: response.invisibleColumn ?? "",
            orderByClause: response.orderByClause ?? "",
            fieldSizeList: response.fieldSizeList ?? "",
            columnsListarray: [],
            fieldColumnarray: [],
            invisibleColumnarray: [],
            fieldSizeListArray: [],
            selectedUserId: null,
            selectedFolderPath: null,
            selectedDocumentTypeName: this.selectedDocumentTypeName,
            selectedDocContainer: this.selectedDocContainer,
            manualEntryDataFields: `EFFECTIVE_DATE,EXPIRATION_DATE${response.manualEntryDataFields ? ',' + response.manualEntryDataFields : ''}`,
            wherVal: this.whereValsForExcel,
            reModule: "dmsorg",
            mainDash: "DMS",
            logoId: 0,
            isSaveRep: this.isSaveReport ? 'Y' : 'N',
            reportName: this.reportName ?? "Dashboard_Report",
            currentStatus: "NA",
            groupName: this.reportName + "",
          }
          this.data2 = {
            groupId: null,
            module: "DOCS"
          }
          this.reportObj = { ...this.data1, ...this.data, ...this.data2 };
          debugger;
          if (value == 'Excel') {
            const pdfData = {
              ...this.reportObj, title: "Inventory", columns: [],
              "informationTab": {
                "Report Name": "Inventory",
                "Exported By": localStorage.getItem("loggedUserName")
              }
            }
            this.appService.downloadexcelForChart(pdfData, "Inventory.xlsx");
          } else {
            const pdfData = {
              ...this.reportObj, title: "Inventory", columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray).slice(0, 10).join(','), pdfPageSize: this.excelPdf.pdfPageSize
            }
            this.appService.downloadPdfForChart(pdfData, "Inventory.pdf");
          }
        });
      } else if (this.onSelectedOptionForDMS == 'Master Index') {
        tname = "DMS_DOCUMENT_INDEX_VW";
        colList = "DOCUMENT_TYPE_NAME,DOCUMENT_NO,DOCUMENT_NAME,VERSION,EFFECTIVE_DATE,EXPIRATION_DATE";
        fieldList = "Document Type Name,Document No,Document Name,Version,Effective Date,Expiration Date";
        this.data = {
          orgId: this.selectedOrgValue[0].toString(),

          groupId: null
        }
        this.data1 = {
          tableOrViewName: tname,
          columnsList: colList,
          fieldLabelsList: fieldList,
          invisibleColumn: "",
          orderByClause: "",
          fieldSizeList: "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          status: "",
          codelistGroup: null,
          manualEntryDataFields: "EFFECTIVE_DATE,EXPIRATION_DATE",
          groupId: null,
          chartStatus: null,
          reModule: "dmsorg",
          mainDash: "DMS",
          logoId: 0,
          isSaveRep: this.isSaveReport ? 'Y' : 'N',
          reportName: this.reportName ?? "Dashboard_Report",
          currentStatus: "NA",
          groupName: this.reportName + "",
        }
        this.data2 = {
          groupId: null,
          module: "DOCS",
          wherVal: this.whereValsForExcel
        }
        this.reportObj = { ...this.data1, ...this.data, ...this.data2 };
        debugger;
        if (value == 'Excel') {
          const pdfData = {
            ...this.reportObj, title: "Master-Index", columns: [],
            "informationTab": {
              "Report Name": "Master-Index",
              "Exported By": localStorage.getItem("loggedUserName")
            }
          }
          this.appService.downloadexcelForChart(pdfData, "Master-Index.xlsx");
        } else {
          const pdfData = {
            ...this.reportObj, title: "Master-Index", columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.columnList.split(',').slice(0, 10).join(','), pdfPageSize: this.excelPdf.pdfPageSize
          }
          this.appService.downloadPdfForChart(pdfData, "Master-Index.pdf");
        }
      } else if (this.onSelectedOptionForDMS == 'Default') {
        this.dynamicGridName = "INTERVALS_MAIN_REP";
        this.dynamicGridViewName = "DMS_INTERVALS_MAIN_REP_VW";
        console.log("===", this.whereValsForExcel);
        this.data = {
          orgId: this.selectedOrgValue[0].toString(),
          gridName: this.dynamicGridName,
          groupId: null
        }
        this.appService.getDynamicGridHeaders(this.data).subscribe((response: any) => {

          response.orderByClause ??= "";
          this.data1 = {
            gridName: this.dynamicGridViewName,
            tableOrViewName: response.tableOrViewName ?? "",
            columnsList: response.columnsList ?? "",
            fieldLabelsList: response.fieldLabelsList ?? "",
            invisibleColumn: response.invisibleColumn ?? "",
            orderByClause: response.orderByClause ?? "",
            fieldSizeList: response.fieldSizeList ?? "",
            columnsListarray: [],
            fieldColumnarray: [],
            invisibleColumnarray: [],
            fieldSizeListArray: [],
            selectedUserId: null,
            selectedFolderPath: null,
            selectedDocumentTypeName: this.selectedDocumentTypeName,
            selectedDocContainer: this.selectedDocContainer,
            manualEntryDataFields: `EFFECTIVE_DATE,EXPIRATION_DATE${response.manualEntryDataFields ? ',' + response.manualEntryDataFields : ''}`,
            wherVal: this.whereValsForExcel,
            reModule: "dmsorg",
            mainDash: "DMS",
            groupId: null,
            chartStatus: null,
            logoId: 0,
            isSaveRep: this.isSaveReport ? 'Y' : 'N',
            reportName: this.reportName ?? "Dashboard_Report",
            currentStatus: "NA",
            groupName: this.reportName + "",
            orgId: this.selectedOrgValue[0].toString(),

            dateRangeAt: this.selectedDateRangeValue,
            fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
            toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
            intervals: this.selectedIntervalValue
          }
          this.data2 = {
            groupId: null,
            module: "DOCS"
          }
          this.reportObj = { ...this.data1, ...this.data, ...this.data2 };
          debugger;
          let fileType = value == 'Excel' ? 'xlsx' : 'pdf';
          const timestamp = Date.now();
          const formattedDate = new Intl.DateTimeFormat('en-US', {
            day: '2-digit', month: 'short', year: 'numeric',
          }).format(new Date(timestamp)).replace(/[, ]/g, (match) => match === ',' ? '' : '_');

          const fileName = `${this.clickedType}_${this.clickedVal}_${formattedDate}.${fileType}`;
          if (value == 'Excel') {
            const pdfData = {
              ...this.reportObj, title: "Report", columns: [],
              "informationTab": {
                "Report Name": `${this.clickedType}_${this.clickedVal}` + "  " + "Report",
                "Exported By": localStorage.getItem("loggedUserName")
              }
            }
            this.appService.downloadexcelForChart(pdfData, fileName);
          } else {
            const pdfData = {
              ...this.reportObj, title: "fileName", columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray).slice(0, 10).join(','), pdfPageSize: this.excelPdf.pdfPageSize
            }
            this.appService.downloadPdfForChart(pdfData, "Default.pdf");
          }
        });
      }
    }
  }
  //setting reorder start
  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.appService.setOrgVal(this.selectedOrgValueForDMS);
    this.gridReorderComponent.reordercall(this.dynamicGridName, this.dynamicGridViewName, null, 0)
  }

  openReorderActionFindings() {
    this.appService.setOrgVal(this.selectedOrgValueForDMS);
    this.gridReorderComponent.reordercall(this.dynamicGridName, this.dynamicGridViewName, null, 0)
  }
  onChildValueEmitted() {
    this.genReport();
  };
  //reorder end
  //dms end
  ngOnInit() {
    this.activityOrActionList = ['Activity', 'Action', 'Finding'];
    this.selectedType = "Activity";
    this.selectedFolderPath = "Repository";
    this.dmsGroupFoldersFieldData.folderPath = "Repository";
    this.dmsGroupFoldersFieldData.folderName = "Repository";
    forkJoin([
      this.appService.getCodeListsByGroup('DMS_REPORT_DATE_RANGE'),
      this.appService.getCodeListsByGroup('REPORT_INTERVAL'),
      this.appService.getMainDashboardOrgList(),
      this.appService.getCodeListsByGroup("DEPARTMENT"),
    ]).subscribe(([typdropDownForDateRangeData, typdropDownForIntervalData, orgList, dropDownForDepartmentCode]) => {
      this.dropDownForDateRange = typdropDownForDateRangeData;
      this.selectBoxForDateRange();
      this.dropDownForInterval = typdropDownForIntervalData;
      this.selectBoxForInterval();
      this.dropDownForOrg = orgList;
      this.selectBoxForOrg();
      this.selectedDateRangeValue = 'CREATED';
      this.selectedIntervalValue = 'MONTH';
      this.isProcessing = false;
      this.dropDownForDepartment = dropDownForDepartmentCode;
      console.log("this.departmentListDropdown=", this.dropDownForDepartment);
      this.selectBoxForDepartment();
      console.log("this.departmentListDropdown=", this.dropDownForDepartment);
      this.appService.getTmsGroupsVwDetails().subscribe((response: any) => {
        this.groupdataList = response;
        console.log(this.groupdataList)
        this.selectBoxeForGroupValue();
      });
      this.appService.getAllOrgReportImages().subscribe((response1: any) => {
        this.oneQmsOrgImagesDetails = response1;
      })
      this.appService.getInstructorTrainer().subscribe((response: any) => {
        this.getTmsInstructorTrainerData = response;
        this.selectBoxeForTrainerValue();
      })

    });
  }


  statusVal(val: any) {
    if (val == "All") {
      return "Total";
    } else if (val == "OVERDUE") {
      return "Overdue";
    } else if (val == "LOCKED") {
      return "Locked";
    } else if (val == "COMPLETED_AT_ATTEMPTED_CHART" || val == "COMPLETED") {
      return "Completed";
    } else if (val == "YET_TO_BE_ATTEMPTED") {
      return "Yet To Be Attempted";
    } else if (val == "ATTEMPTED") {
      return "Attempted";
    } else if (val == "FAILED_AT_ATTEMPTED_CHART" || val == "FAILED") {
      return "Failed";
    } else if (val == "SCHEDULED_AT_ATTEMPTED_CHART" || val == "SCHEDULED") {
      return "Scheduled";
    } else if (val == "PENDING") {
      return "Pending";
    } else if (val == "INPROGRESS") {
      return "Inprogress";
    } else {
      return val;
    }

  }
  convertTZ(date: any, timezone: any) {
    if (localStorage.getItem("timezone") && localStorage.getItem("timezone") != null && localStorage.getItem("timezone") != "null") {
      console.log("timezone==", localStorage.getItem("timezone"));
      timezone = localStorage.getItem("timezone");
    } else {
      console.log("timezone=", "GMT");
      timezone = "GMT";
    }
    let dt = new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", { timeZone: timezone }));
    let month_names = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    let date2 = dt.getFullYear() + "-" + month_names[dt.getMonth()] + "-" + dt.getDate();
    let date1 = moment(date2).format(this.appService.organizationDetails?.htmlDateFormat == null ? 'DD-MMM-YYYY' : this.appService.organizationDetails?.htmlDateFormat.toUpperCase());
    let hours = dt.getHours();
    let minutes: any = dt.getMinutes();
    let ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours ||= 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    let strTime = hours + ':' + minutes + ' ' + ampm;

    return date1 + " " + strTime;


  }

  cancelCer() {
    this.visibleCertificationPopup.close();

  }
  onQmsGroupSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.qmsGroupSelection = this.qmsGroupValueDropdown.length == this.selectedQmsGroup.length;



      })
    }
  }

  onQmsDeptSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.qmsDeptSelection = this.qmsDeptValueDropdown.length == this.selectedQmsDept.length;
      })
    }
  }


  generateChartData(val: any): any[] {
    if (!val || !val.length) {
      return [];
    }
    // 🔹 Calculate Summary
    const summary = val.reduce((acc: any, item: any) => {

      const status = item.chartStatus?.trim();
      const count = Number(item.count) || 0;

      // 🚫 Exclude Deleted/Obsoleted
      if (status === 'Deleted/Obsoleted' || status === 'Deleted/Obsoleted/Deferred') return acc;

      acc.total += count;

      if (status === 'Open') acc.open += count;
      if (status === 'Closed') acc.closed += count;
      if (item.overdue === 'Y') acc.overdue += count;

      return acc;

    }, {
      total: 0,
      open: 0,
      closed: 0,
      overdue: 0
    });

    // 🔹 Return chart format
    return [
      { label: 'Total', y: summary.total },
      { label: 'Open', y: summary.open },
      { label: 'Closed', y: summary.closed },
      { label: 'Overdue', y: summary.overdue }
    ];
  }

  generateChartDataDue(val: any): any[] {
    if (!val?.length) {
      return [];
    }
    // 🔹 Calculate Summary
    const summary = val.reduce((acc: any, item: any) => {

      const status = item.chartStatus?.trim();
      const count = Number(item.count) || 0;

      // 🚫 Exclude Deleted/Obsoleted
      if (status === 'Deleted/Obsoleted' || status === 'Deleted/Obsoleted/Deferred') return acc;


      if (status === 'Open' && item.overdue === 'N') acc.openDue += count;
      if (status === 'Open' && item.overdue === 'Y') acc.openOverdue += count;
      if (status === 'Closed' && item.closedOverdue === 'N') acc.closedDue += count;
      if (status === 'Closed' && item.closedOverdue === 'Y') acc.closedOverdue += count;

      return acc;

    }, {
      openDue: 0,
      openOverdue: 0,
      closedDue: 0,
      closedOverdue: 0
    });

    // 🔹 Return chart format
    return [
      { label: 'Open', y: summary.openDue },
      { label: 'Open Overdue', y: summary.openOverdue },
      { label: 'Closed', y: summary.closedDue },
      { label: 'Closed Overdue', y: summary.closedOverdue }
    ];
  }

  generateChartDataFindingsDue(val: any): any[] {
    if (!val?.length) {
      return [];
    }
    // 🔹 Calculate Summary
    const summary = val.reduce((acc: any, item: any) => {

      const status = item.chartStatus?.trim();
      const count = Number(item.count) || 0;

      // 🚫 Exclude Deleted/Obsoleted
      if (status === 'Deleted/Obsoleted' || status === 'Deleted/Obsoleted/Deferred') return acc;
      if (status === 'Open' && item.overdueRespondDueDate === 'Y') acc.overdueRespondDueDate += count;
      if (status === 'Open' && item.overdueExpectedClosureDate === 'Y') acc.overdueExpectedClosureDate += count;
      if (status === 'Closed' && item.closedOverdueRespondDuedate === 'Y') acc.closedOverdueRespondDuedate += count;
      if (status === 'Closed' && item.closedOverdueExpectedClosureDate === 'Y') acc.closedOverdueExpectedClosureDate += count;
      return acc;
    }, {

      overdueRespondDueDate: 0,
      overdueExpectedClosureDate: 0,
      closedOverdueRespondDuedate: 0,
      closedOverdueExpectedClosureDate: 0
    });

    // 🔹 Return chart format
    return [


      { label: 'Open Overdue Response Duedate', y: summary.overdueRespondDueDate },
      { label: 'Open Overdue Expected Closure Date', y: summary.overdueExpectedClosureDate },
      { label: 'Closed Overdue Response Duedate', y: summary.closedOverdueRespondDuedate },
      { label: 'Closed Overdue Expected Closure Date', y: summary.closedOverdueExpectedClosureDate }
    ];
  }
  generateChartDataFindings(val: any): any[] {
    if (!val || !val.length) {
      return [];
    }
    // 🔹 Calculate Summary
    const summary = val.reduce((acc: any, item: any) => {

      const status = item.chartStatus?.trim();
      const count = Number(item.count) || 0;

      // 🚫 Exclude Deleted/Obsoleted
      if (status === 'Deleted/Obsoleted' || status === 'Deleted/Obsoleted/Deferred') return acc;

      acc.total += count;

      if (status === 'Open') acc.open += count;
      if (status === 'Closed') acc.closed += count;
      if (item.responseVerificationPending === 'Y') acc.responseVerificationPending += count;
      if (item.implementationVerificationPending === 'Y') acc.implementationVerificationPending += count;
      if (item.responseCompletedOrFinalized === 'Y') acc.responseCompletedOrFinalized += count;
      if (item.implementationVerificationCompleted === 'Y') acc.implementationVerificationCompleted += count;
      console.log("acc===", acc);
      return acc;

    }, {
      total: 0,
      open: 0,
      closed: 0,
      responseVerificationPending: 0,
      responseCompletedOrFinalized: 0,
      implementationVerificationPending: 0,
      implementationVerificationCompleted: 0
    });

    // 🔹 Return chart format
    return [
      { label: 'Total', y: summary.total },
      { label: 'Open', y: summary.open },
      { label: 'Closed', y: summary.closed },
      { label: 'Response Pending', y: summary.responseVerificationPending },
      { label: 'Response Completed or Finalized', y: summary.responseCompletedOrFinalized },
      { label: 'Implementation Pending', y: summary.implementationVerificationPending },
      { label: 'Implementation Completed', y: summary.implementationVerificationCompleted }
    ];
  }
  //module charts

  chartOptionsForStatusCR: any;
  chartOptionsForStatusCAPA: any;
  chartOptionsForStatusDV: any;
  chartOptionsForStatusIN: any;
  chartOptionsForStatusQI: any;
  chartOptionsForStatusCC: any;
  chartOptionsForStatusAU: any;
  chartOptionsForStatusOOS: any;

  chartOptionsForStatusCRDue: any;
  chartOptionsForStatusCAPADue: any;
  chartOptionsForStatusDVDue: any;
  chartOptionsForStatusINDue: any;
  chartOptionsForStatusQIDue: any;
  chartOptionsForStatusCCDue: any;
  chartOptionsForStatusAUDue: any;
  chartOptionsForStatusOOSDue: any;
  moduleCharts() {
    this.chartOptionsForStatusCR = {
      animationEnabled: true,
      exportEnabled: true,
      legend: {
        cursor: "pointer",
      },
      title: {
        text: "CR Status",
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          console.log("Title clicked!");
        }
      },
      dataPointMaxWidth: this.dashboardCountListCR.length > 15 ? 20 : 38,
      dataPointMinWidth: this.dashboardCountListCR.length > 15 ? 20 : 38,
      axisY: {
        gridThickness: this.dashboardCountListCR.length === 1 ? 0 : 1,
        gridColor: "#DEEBFE",
        tickLength: this.dashboardCountListCR.length === 1 ? 0 : 5,
        lineThickness: 0,
        labelFontSize: this.dashboardCountListCR.length === 1 ? 0 : 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE",
        interval: this.getDaYAxisInterval(this.dashboardCountListCR),
        labelFormatter: (e: any) => {
          return this.dashboardCountListCR.length === 1 ? "" : e.value;
        }
      },
      axisX: this.dashboardCountListCR.length === 1 ? {
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any; }) => e.label,
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      } : {
        tickLength: 5,
        lineThickness: 1,
        labelAngle: this.dashboardCountListCR.length > 15 ? -45 : 0,
        interval: 1,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any }) => {
          let formattedLabel = null;
          if (e.label != null) {
            if (e.label.length > 10) {
              formattedLabel = e.label.substring(0, 9) + '...';
            } else {
              formattedLabel = e.label;
            }
          }
          return formattedLabel;
        }, lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      },
      data: [{
        type: "column", // Use "horizontalBar" for horizontal bar chart
        dataPoints: this.dashboardCountListCR,
        // color: "#BA7393",
        indexLabel: "{y}",
        indexLabelFontColor: "#0F3659",
        indexLabelFontSize: 12,
        indexLabelFontFamily: "Poppins",
        click: this.handleModuleChartClickCR.bind(this)
      }]
    };

    this.chartOptionsForStatusCAPA = {
      animationEnabled: true,
      exportEnabled: true,
      legend: {
        cursor: "pointer",
      },
      title: {
        text: "CAPA Status",
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          console.log("Title clicked!");
        }
      },
      dataPointMaxWidth: this.dashboardCountListCAPA.length > 15 ? 20 : 38,
      dataPointMinWidth: this.dashboardCountListCAPA.length > 15 ? 20 : 38,
      axisY: {
        gridThickness: this.dashboardCountListCAPA.length === 1 ? 0 : 1,
        gridColor: "#DEEBFE",
        tickLength: this.dashboardCountListCAPA.length === 1 ? 0 : 5,
        lineThickness: 0,
        labelFontSize: this.dashboardCountListCAPA.length === 1 ? 0 : 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE",
        interval: this.getDaYAxisInterval(this.dashboardCountListCAPA),
        labelFormatter: (e: any) => {
          return this.dashboardCountListCAPA.length === 1 ? "" : e.value;
        }
      },
      axisX: this.dashboardCountListCAPA.length === 1 ? {
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any; }) => e.label,
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      } : {
        tickLength: 5,
        lineThickness: 1,
        labelAngle: this.dashboardCountListCAPA.length > 15 ? -45 : 0,
        interval: 1,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any }) => {
          let formattedLabel = null;
          if (e.label != null) {
            if (e.label.length > 10) {
              formattedLabel = e.label.substring(0, 9) + '...';
            } else {
              formattedLabel = e.label;
            }
          }
          return formattedLabel;
        }, lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      },
      data: [{
        type: "column", // Use "horizontalBar" for horizontal bar chart
        dataPoints: this.dashboardCountListCAPA,
        // color: "#BA7393",
        indexLabel: "{y}",
        indexLabelFontColor: "#0F3659",
        indexLabelFontSize: 12,
        indexLabelFontFamily: "Poppins",
        click: this.handleModuleChartClickCAPA.bind(this)
      }]
    };


    this.chartOptionsForStatusDV = {
      animationEnabled: true,
      exportEnabled: true,
      legend: {
        cursor: "pointer",
      },
      title: {
        text: "DV Status",
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          console.log("Title clicked!");
        }
      },
      dataPointMaxWidth: this.dashboardCountListDV.length > 15 ? 20 : 38,
      dataPointMinWidth: this.dashboardCountListDV.length > 15 ? 20 : 38,
      axisY: {
        gridThickness: this.dashboardCountListDV.length === 1 ? 0 : 1,
        gridColor: "#DEEBFE",
        tickLength: this.dashboardCountListDV.length === 1 ? 0 : 5,
        lineThickness: 0,
        labelFontSize: this.dashboardCountListDV.length === 1 ? 0 : 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE",
        interval: this.getDaYAxisInterval(this.dashboardCountListDV),
        labelFormatter: (e: any) => {
          return this.dashboardCountListDV.length === 1 ? "" : e.value;
        }
      },
      axisX: this.dashboardCountListDV.length === 1 ? {
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any; }) => e.label,
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      } : {
        tickLength: 5,
        lineThickness: 1,
        labelAngle: this.dashboardCountListDV.length > 15 ? -45 : 0,
        interval: 1,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any }) => {
          let formattedLabel = null;
          if (e.label != null) {
            if (e.label.length > 10) {
              formattedLabel = e.label.substring(0, 9) + '...';
            } else {
              formattedLabel = e.label;
            }
          }
          return formattedLabel;
        }, lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      },
      data: [{
        type: "column", // Use "horizontalBar" for horizontal bar chart
        dataPoints: this.dashboardCountListDV,
        //color: "#BA7393",
        indexLabel: "{y}",
        indexLabelFontColor: "#0F3659",
        indexLabelFontSize: 12,
        indexLabelFontFamily: "Poppins",
        click: this.handleModuleChartClickDV.bind(this)
      }]
    };

    this.chartOptionsForStatusIN = {
      animationEnabled: true,
      exportEnabled: true,
      legend: {
        cursor: "pointer",
      },
      title: {
        text: "IN Status",
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          console.log("Title clicked!");
        }
      },
      dataPointMaxWidth: this.dashboardCountListIN.length > 15 ? 20 : 38,
      dataPointMinWidth: this.dashboardCountListIN.length > 15 ? 20 : 38,
      axisY: {
        gridThickness: this.dashboardCountListIN.length === 1 ? 0 : 1,
        gridColor: "#DEEBFE",
        tickLength: this.dashboardCountListIN.length === 1 ? 0 : 5,
        lineThickness: 0,
        labelFontSize: this.dashboardCountListIN.length === 1 ? 0 : 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE",
        interval: this.getDaYAxisInterval(this.dashboardCountListIN),
        labelFormatter: (e: any) => {
          return this.dashboardCountListIN.length === 1 ? "" : e.value;
        }
      },
      axisX: this.dashboardCountListIN.length === 1 ? {
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any; }) => e.label,
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      } : {
        tickLength: 5,
        lineThickness: 1,
        labelAngle: this.dashboardCountListIN.length > 15 ? -45 : 0,
        interval: 1,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any }) => {
          let formattedLabel = null;
          if (e.label != null) {
            if (e.label.length > 10) {
              formattedLabel = e.label.substring(0, 9) + '...';
            } else {
              formattedLabel = e.label;
            }
          }
          return formattedLabel;
        }, lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      },
      data: [{
        type: "column", // Use "horizontalBar" for horizontal bar chart
        dataPoints: this.dashboardCountListIN,
        // color: "#BA7393",
        indexLabel: "{y}",
        indexLabelFontColor: "#0F3659",
        indexLabelFontSize: 12,
        indexLabelFontFamily: "Poppins",
        click: this.handleModuleChartClickIN.bind(this)
      }]
    };



    this.chartOptionsForStatusQI = {
      animationEnabled: true,
      exportEnabled: true,
      legend: {
        cursor: "pointer",
      },
      title: {
        text: "QI Status",
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          console.log("Title clicked!");
        }
      },
      dataPointMaxWidth: this.dashboardCountListQI.length > 15 ? 20 : 38,
      dataPointMinWidth: this.dashboardCountListQI.length > 15 ? 20 : 38,
      axisY: {
        gridThickness: this.dashboardCountListQI.length === 1 ? 0 : 1,
        gridColor: "#DEEBFE",
        tickLength: this.dashboardCountListQI.length === 1 ? 0 : 5,
        lineThickness: 0,
        labelFontSize: this.dashboardCountListQI.length === 1 ? 0 : 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE",
        interval: this.getDaYAxisInterval(this.dashboardCountListQI),
        labelFormatter: (e: any) => {
          return this.dashboardCountListQI.length === 1 ? "" : e.value;
        }
      },
      axisX: this.dashboardCountListQI.length === 1 ? {
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any; }) => e.label,
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      } : {
        tickLength: 5,
        lineThickness: 1,
        labelAngle: this.dashboardCountListQI.length > 15 ? -45 : 0,
        interval: 1,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any }) => {
          let formattedLabel = null;
          if (e.label != null) {
            if (e.label.length > 10) {
              formattedLabel = e.label.substring(0, 9) + '...';
            } else {
              formattedLabel = e.label;
            }
          }
          return formattedLabel;
        }, lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      },
      data: [{
        type: "column", // Use "horizontalBar" for horizontal bar chart
        dataPoints: this.dashboardCountListQI,
        // color: "#BA7393",
        indexLabel: "{y}",
        indexLabelFontColor: "#0F3659",
        indexLabelFontSize: 12,
        indexLabelFontFamily: "Poppins",
        click: this.handleModuleChartClickQI.bind(this)
      }]
    };


    this.chartOptionsForStatusCC = {
      animationEnabled: true,
      exportEnabled: true,
      legend: {
        cursor: "pointer",
      },
      title: {
        text: "CC Status",
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          console.log("Title clicked!");
        }
      },
      dataPointMaxWidth: this.dashboardCountListCC.length > 15 ? 20 : 38,
      dataPointMinWidth: this.dashboardCountListCC.length > 15 ? 20 : 38,
      axisY: {
        gridThickness: this.dashboardCountListCC.length === 1 ? 0 : 1,
        gridColor: "#DEEBFE",
        tickLength: this.dashboardCountListCC.length === 1 ? 0 : 5,
        lineThickness: 0,
        labelFontSize: this.dashboardCountListCC.length === 1 ? 0 : 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE",
        interval: this.getDaYAxisInterval(this.dashboardCountListCC),
        labelFormatter: (e: any) => {
          return this.dashboardCountListCC.length === 1 ? "" : e.value;
        }
      },
      axisX: this.dashboardCountListCC.length === 1 ? {
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any; }) => e.label,
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      } : {
        tickLength: 5,
        lineThickness: 1,
        labelAngle: this.dashboardCountListCC.length > 15 ? -45 : 0,
        interval: 1,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any }) => {
          let formattedLabel = null;
          if (e.label != null) {
            if (e.label.length > 10) {
              formattedLabel = e.label.substring(0, 9) + '...';
            } else {
              formattedLabel = e.label;
            }
          }
          return formattedLabel;
        }, lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      },
      data: [{
        type: "column", // Use "horizontalBar" for horizontal bar chart
        dataPoints: this.dashboardCountListCC,
        //color: "#BA7393",
        indexLabel: "{y}",
        indexLabelFontColor: "#0F3659",
        indexLabelFontSize: 12,
        indexLabelFontFamily: "Poppins",
        click: this.handleModuleChartClickCC.bind(this)
      }]
    };


    this.chartOptionsForStatusAU = {
      animationEnabled: true,
      exportEnabled: true,
      legend: {
        cursor: "pointer",
      },
      title: {
        text: "AU Status",
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          console.log("Title clicked!");
        }
      },
      dataPointMaxWidth: this.dashboardCountListAU.length > 15 ? 20 : 38,
      dataPointMinWidth: this.dashboardCountListAU.length > 15 ? 20 : 38,
      axisY: {
        gridThickness: this.dashboardCountListAU.length === 1 ? 0 : 1,
        gridColor: "#DEEBFE",
        tickLength: this.dashboardCountListAU.length === 1 ? 0 : 5,
        lineThickness: 0,
        labelFontSize: this.dashboardCountListAU.length === 1 ? 0 : 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE",
        interval: this.getDaYAxisInterval(this.dashboardCountListAU),
        labelFormatter: (e: any) => {
          return this.dashboardCountListAU.length === 1 ? "" : e.value;
        }
      },
      axisX: this.dashboardCountListAU.length === 1 ? {
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any; }) => e.label,
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      } : {
        tickLength: 5,
        lineThickness: 1,
        labelAngle: this.dashboardCountListAU.length > 15 ? -45 : 0,
        interval: 1,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any }) => {
          let formattedLabel = null;
          if (e.label != null) {
            if (e.label.length > 10) {
              formattedLabel = e.label.substring(0, 9) + '...';
            } else {
              formattedLabel = e.label;
            }
          }
          return formattedLabel;
        }, lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      },
      data: [{
        type: "column", // Use "horizontalBar" for horizontal bar chart
        dataPoints: this.dashboardCountListAU,
        // color: "#BA7393",
        indexLabel: "{y}",
        indexLabelFontColor: "#0F3659",
        indexLabelFontSize: 12,
        indexLabelFontFamily: "Poppins",
        click: this.handleModuleChartClickAU.bind(this)
      }]
    };

    this.chartOptionsForStatusOOS = {
      animationEnabled: true,
      exportEnabled: true,
      legend: {
        cursor: "pointer",
      },
      title: {
        text: "OOS Status",
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          console.log("Title clicked!");
        }
      },
      dataPointMaxWidth: this.dashboardCountListOOS.length > 15 ? 20 : 38,
      dataPointMinWidth: this.dashboardCountListOOS.length > 15 ? 20 : 38,
      axisY: {
        gridThickness: this.dashboardCountListOOS.length === 1 ? 0 : 1,
        gridColor: "#DEEBFE",
        tickLength: this.dashboardCountListOOS.length === 1 ? 0 : 5,
        lineThickness: 0,
        labelFontSize: this.dashboardCountListOOS.length === 1 ? 0 : 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE",
        interval: this.getDaYAxisInterval(this.dashboardCountListOOS),
        labelFormatter: (e: any) => {
          return this.dashboardCountListOOS.length === 1 ? "" : e.value;
        }
      },
      axisX: this.dashboardCountListOOS.length === 1 ? {
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any; }) => e.label,
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      } : {
        tickLength: 5,
        lineThickness: 1,
        labelAngle: this.dashboardCountListOOS.length > 15 ? -45 : 0,
        interval: 1,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any }) => {
          let formattedLabel = null;
          if (e.label != null) {
            if (e.label.length > 10) {
              formattedLabel = e.label.substring(0, 9) + '...';
            } else {
              formattedLabel = e.label;
            }
          }
          return formattedLabel;
        }, lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      },
      data: [{
        type: "column", // Use "horizontalBar" for horizontal bar chart
        dataPoints: this.dashboardCountListOOS,
        indexLabel: "{y}",
        indexLabelFontColor: "#0F3659",
        indexLabelFontSize: 12,
        indexLabelFontFamily: "Poppins",
        click: this.handleModuleChartClickOOS.bind(this)
      }]
    };


    this.chartOptionsForStatusCRDue = {
      animationEnabled: true,
      exportEnabled: true,
      legend: {
        cursor: "pointer",
      },
      title: {
        text: "CR Due Status",
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          console.log("Title clicked!");
        }
      },
      dataPointMaxWidth: this.dashboardCountListCRDue.length > 15 ? 20 : 38,
      dataPointMinWidth: this.dashboardCountListCRDue.length > 15 ? 20 : 38,
      axisY: {
        gridThickness: this.dashboardCountListCRDue.length === 1 ? 0 : 1,
        gridColor: "#DEEBFE",
        tickLength: this.dashboardCountListCRDue.length === 1 ? 0 : 5,
        lineThickness: 0,
        labelFontSize: this.dashboardCountListCRDue.length === 1 ? 0 : 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE",
        interval: this.getDaYAxisInterval(this.dashboardCountListCRDue),
        labelFormatter: (e: any) => {
          return this.dashboardCountListCRDue.length === 1 ? "" : e.value;
        }
      },
      axisX: this.dashboardCountListCRDue.length === 1 ? {
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any; }) => e.label,
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      } : {
        tickLength: 5,
        lineThickness: 1,
        labelAngle: this.dashboardCountListCRDue.length > 15 ? -45 : 0,
        interval: 1,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any }) => {
          let formattedLabel = null;
          if (e.label != null) {
            if (e.label.length > 10) {
              formattedLabel = e.label.substring(0, 9) + '...';
            } else {
              formattedLabel = e.label;
            }
          }
          return formattedLabel;
        }, lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      },
      data: [{
        type: "column", // Use "horizontalBar" for horizontal bar chart
        dataPoints: this.dashboardCountListCRDue,
        // color: "#BA7393",
        indexLabel: "{y}",
        indexLabelFontColor: "#0F3659",
        indexLabelFontSize: 12,
        indexLabelFontFamily: "Poppins",
        click: this.handleModuleChartClickCRDue.bind(this)
      }]
    };

    this.chartOptionsForStatusCAPADue = {
      animationEnabled: true,
      exportEnabled: true,
      legend: {
        cursor: "pointer",
      },
      title: {
        text: "CAPA Due Status",
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          console.log("Title clicked!");
        }
      },
      dataPointMaxWidth: this.dashboardCountListCAPADue.length > 15 ? 20 : 38,
      dataPointMinWidth: this.dashboardCountListCAPADue.length > 15 ? 20 : 38,
      axisY: {
        gridThickness: this.dashboardCountListCAPADue.length === 1 ? 0 : 1,
        gridColor: "#DEEBFE",
        tickLength: this.dashboardCountListCAPADue.length === 1 ? 0 : 5,
        lineThickness: 0,
        labelFontSize: this.dashboardCountListCAPADue.length === 1 ? 0 : 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE",
        interval: this.getDaYAxisInterval(this.dashboardCountListCAPADue),
        labelFormatter: (e: any) => {
          return this.dashboardCountListCAPADue.length === 1 ? "" : e.value;
        }
      },
      axisX: this.dashboardCountListCAPADue.length === 1 ? {
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any; }) => e.label,
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      } : {
        tickLength: 5,
        lineThickness: 1,
        labelAngle: this.dashboardCountListCAPADue.length > 15 ? -45 : 0,
        interval: 1,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any }) => {
          let formattedLabel = null;
          if (e.label != null) {
            if (e.label.length > 10) {
              formattedLabel = e.label.substring(0, 9) + '...';
            } else {
              formattedLabel = e.label;
            }
          }
          return formattedLabel;
        }, lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      },
      data: [{
        type: "column", // Use "horizontalBar" for horizontal bar chart
        dataPoints: this.dashboardCountListCAPADue,
        // color: "#BA7393",
        indexLabel: "{y}",
        indexLabelFontColor: "#0F3659",
        indexLabelFontSize: 12,
        indexLabelFontFamily: "Poppins",
        click: this.handleModuleChartClickCAPADue.bind(this)
      }]
    };


    this.chartOptionsForStatusDVDue = {
      animationEnabled: true,
      exportEnabled: true,
      legend: {
        cursor: "pointer",
      },
      title: {
        text: "DV Due Status",
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          console.log("Title clicked!");
        }
      },
      dataPointMaxWidth: this.dashboardCountListDVDue.length > 15 ? 20 : 38,
      dataPointMinWidth: this.dashboardCountListDVDue.length > 15 ? 20 : 38,
      axisY: {
        gridThickness: this.dashboardCountListDVDue.length === 1 ? 0 : 1,
        gridColor: "#DEEBFE",
        tickLength: this.dashboardCountListDVDue.length === 1 ? 0 : 5,
        lineThickness: 0,
        labelFontSize: this.dashboardCountListDVDue.length === 1 ? 0 : 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE",
        interval: this.getDaYAxisInterval(this.dashboardCountListDVDue),
        labelFormatter: (e: any) => {
          return this.dashboardCountListDVDue.length === 1 ? "" : e.value;
        }
      },
      axisX: this.dashboardCountListDVDue.length === 1 ? {
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any; }) => e.label,
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      } : {
        tickLength: 5,
        lineThickness: 1,
        labelAngle: this.dashboardCountListDVDue.length > 15 ? -45 : 0,
        interval: 1,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any }) => {
          let formattedLabel = null;
          if (e.label != null) {
            if (e.label.length > 10) {
              formattedLabel = e.label.substring(0, 9) + '...';
            } else {
              formattedLabel = e.label;
            }
          }
          return formattedLabel;
        }, lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      },
      data: [{
        type: "column", // Use "horizontalBar" for horizontal bar chart
        dataPoints: this.dashboardCountListDVDue,
        //color: "#BA7393",
        indexLabel: "{y}",
        indexLabelFontColor: "#0F3659",
        indexLabelFontSize: 12,
        indexLabelFontFamily: "Poppins",
        click: this.handleModuleChartClickDVDue.bind(this)
      }]
    };

    this.chartOptionsForStatusINDue = {
      animationEnabled: true,
      exportEnabled: true,
      legend: {
        cursor: "pointer",
      },
      title: {
        text: "IN Due Status",
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          console.log("Title clicked!");
        }
      },
      dataPointMaxWidth: this.dashboardCountListINDue.length > 15 ? 20 : 38,
      dataPointMinWidth: this.dashboardCountListINDue.length > 15 ? 20 : 38,
      axisY: {
        gridThickness: this.dashboardCountListINDue.length === 1 ? 0 : 1,
        gridColor: "#DEEBFE",
        tickLength: this.dashboardCountListINDue.length === 1 ? 0 : 5,
        lineThickness: 0,
        labelFontSize: this.dashboardCountListINDue.length === 1 ? 0 : 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE",
        interval: this.getDaYAxisInterval(this.dashboardCountListINDue),
        labelFormatter: (e: any) => {
          return this.dashboardCountListINDue.length === 1 ? "" : e.value;
        }
      },
      axisX: this.dashboardCountListINDue.length === 1 ? {
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any; }) => e.label,
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      } : {
        tickLength: 5,
        lineThickness: 1,
        labelAngle: this.dashboardCountListINDue.length > 15 ? -45 : 0,
        interval: 1,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any }) => {
          let formattedLabel = null;
          if (e.label != null) {
            if (e.label.length > 10) {
              formattedLabel = e.label.substring(0, 9) + '...';
            } else {
              formattedLabel = e.label;
            }
          }
          return formattedLabel;
        }, lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      },
      data: [{
        type: "column", // Use "horizontalBar" for horizontal bar chart
        dataPoints: this.dashboardCountListINDue,
        // color: "#BA7393",
        indexLabel: "{y}",
        indexLabelFontColor: "#0F3659",
        indexLabelFontSize: 12,
        indexLabelFontFamily: "Poppins",
        click: this.handleModuleChartClickINDue.bind(this)
      }]
    };



    this.chartOptionsForStatusQIDue = {
      animationEnabled: true,
      exportEnabled: true,
      legend: {
        cursor: "pointer",
      },
      title: {
        text: "QI Due Status",
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          console.log("Title clicked!");
        }
      },
      dataPointMaxWidth: this.dashboardCountListQIDue.length > 15 ? 20 : 38,
      dataPointMinWidth: this.dashboardCountListQIDue.length > 15 ? 20 : 38,
      axisY: {
        gridThickness: this.dashboardCountListQIDue.length === 1 ? 0 : 1,
        gridColor: "#DEEBFE",
        tickLength: this.dashboardCountListQIDue.length === 1 ? 0 : 5,
        lineThickness: 0,
        labelFontSize: this.dashboardCountListQIDue.length === 1 ? 0 : 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE",
        interval: this.getDaYAxisInterval(this.dashboardCountListQIDue),
        labelFormatter: (e: any) => {
          return this.dashboardCountListQIDue.length === 1 ? "" : e.value;
        }
      },
      axisX: this.dashboardCountListQIDue.length === 1 ? {
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any; }) => e.label,
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      } : {
        tickLength: 5,
        lineThickness: 1,
        labelAngle: this.dashboardCountListQIDue.length > 15 ? -45 : 0,
        interval: 1,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any }) => {
          let formattedLabel = null;
          if (e.label != null) {
            if (e.label.length > 10) {
              formattedLabel = e.label.substring(0, 9) + '...';
            } else {
              formattedLabel = e.label;
            }
          }
          return formattedLabel;
        }, lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      },
      data: [{
        type: "column", // Use "horizontalBar" for horizontal bar chart
        dataPoints: this.dashboardCountListQIDue,
        // color: "#BA7393",
        indexLabel: "{y}",
        indexLabelFontColor: "#0F3659",
        indexLabelFontSize: 12,
        indexLabelFontFamily: "Poppins",
        click: this.handleModuleChartClickQIDue.bind(this)
      }]
    };


    this.chartOptionsForStatusCCDue = {
      animationEnabled: true,
      exportEnabled: true,
      legend: {
        cursor: "pointer",
      },
      title: {
        text: "CC Due Status",
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          console.log("Title clicked!");
        }
      },
      dataPointMaxWidth: this.dashboardCountListCCDue.length > 15 ? 20 : 38,
      dataPointMinWidth: this.dashboardCountListCCDue.length > 15 ? 20 : 38,
      axisY: {
        gridThickness: this.dashboardCountListCCDue.length === 1 ? 0 : 1,
        gridColor: "#DEEBFE",
        tickLength: this.dashboardCountListCCDue.length === 1 ? 0 : 5,
        lineThickness: 0,
        labelFontSize: this.dashboardCountListCCDue.length === 1 ? 0 : 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE",
        interval: this.getDaYAxisInterval(this.dashboardCountListCCDue),
        labelFormatter: (e: any) => {
          return this.dashboardCountListCCDue.length === 1 ? "" : e.value;
        }
      },
      axisX: this.dashboardCountListCCDue.length === 1 ? {
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any; }) => e.label,
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      } : {
        tickLength: 5,
        lineThickness: 1,
        labelAngle: this.dashboardCountListCCDue.length > 15 ? -45 : 0,
        interval: 1,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any }) => {
          let formattedLabel = null;
          if (e.label != null) {
            if (e.label.length > 10) {
              formattedLabel = e.label.substring(0, 9) + '...';
            } else {
              formattedLabel = e.label;
            }
          }
          return formattedLabel;
        }, lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      },
      data: [{
        type: "column", // Use "horizontalBar" for horizontal bar chart
        dataPoints: this.dashboardCountListCCDue,
        //color: "#BA7393",
        indexLabel: "{y}",
        indexLabelFontColor: "#0F3659",
        indexLabelFontSize: 12,
        indexLabelFontFamily: "Poppins",
        click: this.handleModuleChartClickCCDue.bind(this)
      }]
    };


    this.chartOptionsForStatusAUDue = {
      animationEnabled: true,
      exportEnabled: true,
      legend: {
        cursor: "pointer",
      },
      title: {
        text: "AU Due Status",
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          console.log("Title clicked!");
        }
      },
      dataPointMaxWidth: this.dashboardCountListAUDue.length > 15 ? 20 : 38,
      dataPointMinWidth: this.dashboardCountListAUDue.length > 15 ? 20 : 38,
      axisY: {
        gridThickness: this.dashboardCountListAUDue.length === 1 ? 0 : 1,
        gridColor: "#DEEBFE",
        tickLength: this.dashboardCountListAUDue.length === 1 ? 0 : 5,
        lineThickness: 0,
        labelFontSize: this.dashboardCountListAUDue.length === 1 ? 0 : 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE",
        interval: this.getDaYAxisInterval(this.dashboardCountListAUDue),
        labelFormatter: (e: any) => {
          return this.dashboardCountListAUDue.length === 1 ? "" : e.value;
        }
      },
      axisX: this.dashboardCountListAUDue.length === 1 ? {
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any; }) => e.label,
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      } : {
        tickLength: 5,
        lineThickness: 1,
        labelAngle: this.dashboardCountListAUDue.length > 15 ? -45 : 0,
        interval: 1,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any }) => {
          let formattedLabel = null;
          if (e.label != null) {
            if (e.label.length > 10) {
              formattedLabel = e.label.substring(0, 9) + '...';
            } else {
              formattedLabel = e.label;
            }
          }
          return formattedLabel;
        }, lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      },
      data: [{
        type: "column", // Use "horizontalBar" for horizontal bar chart
        dataPoints: this.dashboardCountListAUDue,
        // color: "#BA7393",
        indexLabel: "{y}",
        indexLabelFontColor: "#0F3659",
        indexLabelFontSize: 12,
        indexLabelFontFamily: "Poppins",
        click: this.handleModuleChartClickAUDue.bind(this)
      }]
    };

    this.chartOptionsForStatusOOSDue = {
      animationEnabled: true,
      exportEnabled: true,
      legend: {
        cursor: "pointer",
      },
      title: {
        text: "OOS Due Status",
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          console.log("Title clicked!");
        }
      },
      dataPointMaxWidth: this.dashboardCountListOOSDue.length > 15 ? 20 : 38,
      dataPointMinWidth: this.dashboardCountListOOSDue.length > 15 ? 20 : 38,
      axisY: {
        gridThickness: this.dashboardCountListOOSDue.length === 1 ? 0 : 1,
        gridColor: "#DEEBFE",
        tickLength: this.dashboardCountListOOSDue.length === 1 ? 0 : 5,
        lineThickness: 0,
        labelFontSize: this.dashboardCountListOOSDue.length === 1 ? 0 : 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE",
        interval: this.getDaYAxisInterval(this.dashboardCountListOOSDue),
        labelFormatter: (e: any) => {
          return this.dashboardCountListOOSDue.length === 1 ? "" : e.value;
        }
      },
      axisX: this.dashboardCountListOOSDue.length === 1 ? {
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any; }) => e.label,
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      } : {
        tickLength: 5,
        lineThickness: 1,
        labelAngle: this.dashboardCountListOOSDue.length > 15 ? -45 : 0,
        interval: 1,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any }) => {
          let formattedLabel = null;
          if (e.label != null) {
            if (e.label.length > 10) {
              formattedLabel = e.label.substring(0, 9) + '...';
            } else {
              formattedLabel = e.label;
            }
          }
          return formattedLabel;
        }, lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      },
      data: [{
        type: "column", // Use "horizontalBar" for horizontal bar chart
        dataPoints: this.dashboardCountListOOSDue,
        indexLabel: "{y}",
        indexLabelFontColor: "#0F3659",
        indexLabelFontSize: 12,
        indexLabelFontFamily: "Poppins",
        click: this.handleModuleChartClickOOSDue.bind(this)
      }]
    };
  }


  //module charts

  chartOptionsForStatusCRAction: any;
  chartOptionsForStatusCAPAAction: any;
  chartOptionsForStatusDVAction: any;
  chartOptionsForStatusINAction: any;
  chartOptionsForStatusQIAction: any;
  chartOptionsForStatusCCAction: any;
  chartOptionsForStatusAUFinding: any;
  chartOptionsForStatusOOSAction: any;

  chartOptionsForStatusCRActionDue: any;
  chartOptionsForStatusCAPAActionDue: any;
  chartOptionsForStatusDVActionDue: any;
  chartOptionsForStatusINActionDue: any;
  chartOptionsForStatusQIActionDue: any;
  chartOptionsForStatusCCActionDue: any;
  chartOptionsForStatusAUFindingDue: any;
  chartOptionsForStatusOOSActionDue: any;
  moduleChartsFinding() {
    this.chartOptionsForStatusAUFinding = {
      animationEnabled: true,
      exportEnabled: true,
      legend: {
        cursor: "pointer",
      },
      title: {
        text: "AU Findings Status",
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          console.log("Title clicked!");
        }
      },
      dataPointMaxWidth: this.dashboardCountListAUFinding.length > 15 ? 20 : 38,
      dataPointMinWidth: this.dashboardCountListAUFinding.length > 15 ? 20 : 38,
      axisY: {
        gridThickness: this.dashboardCountListAUFinding.length === 1 ? 0 : 1,
        gridColor: "#DEEBFE",
        tickLength: this.dashboardCountListAUFinding.length === 1 ? 0 : 5,
        lineThickness: 0,
        labelFontSize: this.dashboardCountListAUFinding.length === 1 ? 0 : 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE",
        interval: this.getDaYAxisInterval(this.dashboardCountListAUFinding),
        labelFormatter: (e: any) => {
          return this.dashboardCountListAUFinding.length === 1 ? "" : e.value;
        }
      },
      axisX: this.dashboardCountListAUFinding.length === 1 ? {
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any; }) => e.label,
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      } : {
        tickLength: 5,
        lineThickness: 1,
        labelAngle: this.dashboardCountListAUFinding.length > 15 ? -45 : 0,
        interval: 1,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any }) => {
          let formattedLabel = null;
          if (e.label != null) {
            if (e.label.length > 20) {
              formattedLabel = e.label.substring(0, 19) + '...';
            } else {
              formattedLabel = e.label;
            }
          }
          return formattedLabel;
        }, lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      },
      data: [{
        type: "column", // Use "horizontalBar" for horizontal bar chart
        dataPoints: this.dashboardCountListAUFinding,
        // color: "#BA7393",
        indexLabel: "{y}",
        indexLabelFontColor: "#0F3659",
        indexLabelFontSize: 12,
        indexLabelFontFamily: "Poppins",
        click: this.handleModuleChartClickAUFinding.bind(this)
      }]
    };

    this.chartOptionsForStatusAUFindingDue = {
      animationEnabled: true,
      exportEnabled: true,
      legend: {
        cursor: "pointer",
      },
      title: {
        text: "AU Findings Due Status",
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          console.log("Title clicked!");
        }
      },
      dataPointMaxWidth: this.dashboardCountListAUFindingDue.length > 15 ? 20 : 38,
      dataPointMinWidth: this.dashboardCountListAUFindingDue.length > 15 ? 20 : 38,
      axisY: {
        gridThickness: this.dashboardCountListAUFindingDue.length === 1 ? 0 : 1,
        gridColor: "#DEEBFE",
        tickLength: this.dashboardCountListAUFindingDue.length === 1 ? 0 : 5,
        lineThickness: 0,
        labelFontSize: this.dashboardCountListAUFindingDue.length === 1 ? 0 : 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE",
        interval: this.getDaYAxisInterval(this.dashboardCountListAUFindingDue),
        labelFormatter: (e: any) => {
          return this.dashboardCountListAUFindingDue.length === 1 ? "" : e.value;
        }
      },
      axisX: this.dashboardCountListAUFindingDue.length === 1 ? {
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any; }) => e.label,
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      } : {
        tickLength: 5,
        lineThickness: 1,
        labelAngle: this.dashboardCountListAUFindingDue.length > 15 ? -45 : 0,
        interval: 1,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any }) => {
          let formattedLabel = null;
          if (e.label != null) {
            if (e.label.length > 20) {
              formattedLabel = e.label.substring(0, 19) + '...';
            } else {
              formattedLabel = e.label;
            }
          }
          return formattedLabel;
        }, lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      },
      data: [{
        type: "column", // Use "horizontalBar" for horizontal bar chart
        dataPoints: this.dashboardCountListAUFindingDue,
        // color: "#BA7393",
        indexLabel: "{y}",
        indexLabelFontColor: "#0F3659",
        indexLabelFontSize: 12,
        indexLabelFontFamily: "Poppins",
        click: this.handleModuleChartClickAUFindingDue.bind(this)
      }]
    };
    try {
      let chart = new CanvasJS.Chart("chartOptionsForStatusAUFindingid", this.chartOptionsForStatusAUFinding);
      chart.render();
    } catch (error) {
      console.log("error", error);
    }
    try {
      let chart = new CanvasJS.Chart("chartOptionsForStatusAUFindingDueid", this.chartOptionsForStatusAUFindingDue);
      chart.render();
    } catch (error) {
      console.log("error", error);
    }
  }
  moduleChartsAction() {
    console.log("chart in")
    console.log("this.dashboardCountListCRAction.length=", this.dashboardCountListCRAction.length);
    console.log("this.dashboardCountListCAPAAction.length=", this.dashboardCountListCAPAAction.length);
    console.log("this.dashboardCountListDVAction.length=", this.dashboardCountListDVAction.length);
    console.log("this.dashboardCountListINAction.length=", this.dashboardCountListINAction.length);
    console.log("this.dashboardCountListQIAction.length=", this.dashboardCountListQIAction.length);
    console.log("this.dashboardCountListCCAction.length=", this.dashboardCountListCCAction.length);
    console.log("this.dashboardCountListOOSAction.length=", this.dashboardCountListOOSAction.length);
    this.chartOptionsForStatusCRAction = {
      animationEnabled: true,
      exportEnabled: true,
      legend: {
        cursor: "pointer",
      },
      title: {
        text: "CR Action Status",
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          console.log("Title clicked!");
        }
      },
      dataPointMaxWidth: this.dashboardCountListCRAction.length > 15 ? 20 : 38,
      dataPointMinWidth: this.dashboardCountListCRAction.length > 15 ? 20 : 38,
      axisY: {
        gridThickness: this.dashboardCountListCRAction.length === 1 ? 0 : 1,
        gridColor: "#DEEBFE",
        tickLength: this.dashboardCountListCRAction.length === 1 ? 0 : 5,
        lineThickness: 0,
        labelFontSize: this.dashboardCountListCRAction.length === 1 ? 0 : 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE",
        interval: this.getDaYAxisInterval(this.dashboardCountListCRAction),
        labelFormatter: (e: any) => {
          return this.dashboardCountListCRAction.length === 1 ? "" : e.value;
        }
      },
      axisX: this.dashboardCountListCRAction.length === 1 ? {
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any; }) => e.label,
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      } : {
        tickLength: 5,
        lineThickness: 1,
        labelAngle: this.dashboardCountListCRAction.length > 15 ? -45 : 0,
        interval: 1,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any }) => {
          let formattedLabel = null;
          if (e.label != null) {
            if (e.label.length > 10) {
              formattedLabel = e.label.substring(0, 9) + '...';
            } else {
              formattedLabel = e.label;
            }
          }
          return formattedLabel;
        }, lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      },
      data: [{
        type: "column", // Use "horizontalBar" for horizontal bar chart
        dataPoints: this.dashboardCountListCRAction,
        // color: "#BA7393",
        indexLabel: "{y}",
        indexLabelFontColor: "#0F3659",
        indexLabelFontSize: 12,
        indexLabelFontFamily: "Poppins",
        click: this.handleModuleChartClickCRAction.bind(this)
      }]
    };

    this.chartOptionsForStatusCAPAAction = {
      animationEnabled: true,
      exportEnabled: true,
      legend: {
        cursor: "pointer",
      },
      title: {
        text: "CAPA Action Status",
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          console.log("Title clicked!");
        }
      },
      dataPointMaxWidth: this.dashboardCountListCAPAAction.length > 15 ? 20 : 38,
      dataPointMinWidth: this.dashboardCountListCAPAAction.length > 15 ? 20 : 38,
      axisY: {
        gridThickness: this.dashboardCountListCAPAAction.length === 1 ? 0 : 1,
        gridColor: "#DEEBFE",
        tickLength: this.dashboardCountListCAPAAction.length === 1 ? 0 : 5,
        lineThickness: 0,
        labelFontSize: this.dashboardCountListCAPAAction.length === 1 ? 0 : 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE",
        interval: this.getDaYAxisInterval(this.dashboardCountListCAPAAction),
        labelFormatter: (e: any) => {
          return this.dashboardCountListCAPAAction.length === 1 ? "" : e.value;
        }
      },
      axisX: this.dashboardCountListCAPAAction.length === 1 ? {
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any; }) => e.label,
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      } : {
        tickLength: 5,
        lineThickness: 1,
        labelAngle: this.dashboardCountListCAPAAction.length > 15 ? -45 : 0,
        interval: 1,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any }) => {
          let formattedLabel = null;
          if (e.label != null) {
            if (e.label.length > 10) {
              formattedLabel = e.label.substring(0, 9) + '...';
            } else {
              formattedLabel = e.label;
            }
          }
          return formattedLabel;
        }, lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      },
      data: [{
        type: "column", // Use "horizontalBar" for horizontal bar chart
        dataPoints: this.dashboardCountListCAPAAction,
        // color: "#BA7393",
        indexLabel: "{y}",
        indexLabelFontColor: "#0F3659",
        indexLabelFontSize: 12,
        indexLabelFontFamily: "Poppins",
        click: this.handleModuleChartClickCAPAAction.bind(this)
      }]
    };


    this.chartOptionsForStatusDVAction = {
      animationEnabled: true,
      exportEnabled: true,
      legend: {
        cursor: "pointer",
      },
      title: {
        text: "DV Action Status",
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          console.log("Title clicked!");
        }
      },
      dataPointMaxWidth: this.dashboardCountListDVAction.length > 15 ? 20 : 38,
      dataPointMinWidth: this.dashboardCountListDVAction.length > 15 ? 20 : 38,
      axisY: {
        gridThickness: this.dashboardCountListDVAction.length === 1 ? 0 : 1,
        gridColor: "#DEEBFE",
        tickLength: this.dashboardCountListDVAction.length === 1 ? 0 : 5,
        lineThickness: 0,
        labelFontSize: this.dashboardCountListDVAction.length === 1 ? 0 : 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE",
        interval: this.getDaYAxisInterval(this.dashboardCountListDVAction),
        labelFormatter: (e: any) => {
          return this.dashboardCountListDVAction.length === 1 ? "" : e.value;
        }
      },
      axisX: this.dashboardCountListDVAction.length === 1 ? {
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any; }) => e.label,
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      } : {
        tickLength: 5,
        lineThickness: 1,
        labelAngle: this.dashboardCountListDVAction.length > 15 ? -45 : 0,
        interval: 1,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any }) => {
          let formattedLabel = null;
          if (e.label != null) {
            if (e.label.length > 10) {
              formattedLabel = e.label.substring(0, 9) + '...';
            } else {
              formattedLabel = e.label;
            }
          }
          return formattedLabel;
        }, lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      },
      data: [{
        type: "column", // Use "horizontalBar" for horizontal bar chart
        dataPoints: this.dashboardCountListDVAction,
        //color: "#BA7393",
        indexLabel: "{y}",
        indexLabelFontColor: "#0F3659",
        indexLabelFontSize: 12,
        indexLabelFontFamily: "Poppins",
        click: this.handleModuleChartClickDVAction.bind(this)
      }]
    };

    this.chartOptionsForStatusINAction = {
      animationEnabled: true,
      exportEnabled: true,
      legend: {
        cursor: "pointer",
      },
      title: {
        text: "IN Action Status",
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          console.log("Title clicked!");
        }
      },
      dataPointMaxWidth: this.dashboardCountListINAction.length > 15 ? 20 : 38,
      dataPointMinWidth: this.dashboardCountListINAction.length > 15 ? 20 : 38,
      axisY: {
        gridThickness: this.dashboardCountListINAction.length === 1 ? 0 : 1,
        gridColor: "#DEEBFE",
        tickLength: this.dashboardCountListINAction.length === 1 ? 0 : 5,
        lineThickness: 0,
        labelFontSize: this.dashboardCountListINAction.length === 1 ? 0 : 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE",
        interval: this.getDaYAxisInterval(this.dashboardCountListINAction),
        labelFormatter: (e: any) => {
          return this.dashboardCountListINAction.length === 1 ? "" : e.value;
        }
      },
      axisX: this.dashboardCountListINAction.length === 1 ? {
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any; }) => e.label,
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      } : {
        tickLength: 5,
        lineThickness: 1,
        labelAngle: this.dashboardCountListINAction.length > 15 ? -45 : 0,
        interval: 1,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any }) => {
          let formattedLabel = null;
          if (e.label != null) {
            if (e.label.length > 10) {
              formattedLabel = e.label.substring(0, 9) + '...';
            } else {
              formattedLabel = e.label;
            }
          }
          return formattedLabel;
        }, lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      },
      data: [{
        type: "column", // Use "horizontalBar" for horizontal bar chart
        dataPoints: this.dashboardCountListINAction,
        // color: "#BA7393",
        indexLabel: "{y}",
        indexLabelFontColor: "#0F3659",
        indexLabelFontSize: 12,
        indexLabelFontFamily: "Poppins",
        click: this.handleModuleChartClickINAction.bind(this)
      }]
    };



    this.chartOptionsForStatusQIAction = {
      animationEnabled: true,
      exportEnabled: true,
      legend: {
        cursor: "pointer",
      },
      title: {
        text: "QI Action Status",
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          console.log("Title clicked!");
        }
      },
      dataPointMaxWidth: this.dashboardCountListQIAction.length > 15 ? 20 : 38,
      dataPointMinWidth: this.dashboardCountListQIAction.length > 15 ? 20 : 38,
      axisY: {
        gridThickness: this.dashboardCountListQIAction.length === 1 ? 0 : 1,
        gridColor: "#DEEBFE",
        tickLength: this.dashboardCountListQIAction.length === 1 ? 0 : 5,
        lineThickness: 0,
        labelFontSize: this.dashboardCountListQIAction.length === 1 ? 0 : 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE",
        interval: this.getDaYAxisInterval(this.dashboardCountListQIAction),
        labelFormatter: (e: any) => {
          return this.dashboardCountListQIAction.length === 1 ? "" : e.value;
        }
      },
      axisX: this.dashboardCountListQIAction.length === 1 ? {
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any; }) => e.label,
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      } : {
        tickLength: 5,
        lineThickness: 1,
        labelAngle: this.dashboardCountListQIAction.length > 15 ? -45 : 0,
        interval: 1,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any }) => {
          let formattedLabel = null;
          if (e.label != null) {
            if (e.label.length > 10) {
              formattedLabel = e.label.substring(0, 9) + '...';
            } else {
              formattedLabel = e.label;
            }
          }
          return formattedLabel;
        }, lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      },
      data: [{
        type: "column", // Use "horizontalBar" for horizontal bar chart
        dataPoints: this.dashboardCountListQIAction,
        // color: "#BA7393",
        indexLabel: "{y}",
        indexLabelFontColor: "#0F3659",
        indexLabelFontSize: 12,
        indexLabelFontFamily: "Poppins",
        click: this.handleModuleChartClickQIAction.bind(this)
      }]
    };


    this.chartOptionsForStatusCCAction = {
      animationEnabled: true,
      exportEnabled: true,
      legend: {
        cursor: "pointer",
      },
      title: {
        text: "CC Action Status",
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          console.log("Title clicked!");
        }
      },
      dataPointMaxWidth: this.dashboardCountListCCAction.length > 15 ? 20 : 38,
      dataPointMinWidth: this.dashboardCountListCCAction.length > 15 ? 20 : 38,
      axisY: {
        gridThickness: this.dashboardCountListCCAction.length === 1 ? 0 : 1,
        gridColor: "#DEEBFE",
        tickLength: this.dashboardCountListCCAction.length === 1 ? 0 : 5,
        lineThickness: 0,
        labelFontSize: this.dashboardCountListCCAction.length === 1 ? 0 : 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE",
        interval: this.getDaYAxisInterval(this.dashboardCountListCCAction),
        labelFormatter: (e: any) => {
          return this.dashboardCountListCCAction.length === 1 ? "" : e.value;
        }
      },
      axisX: this.dashboardCountListCCAction.length === 1 ? {
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any; }) => e.label,
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      } : {
        tickLength: 5,
        lineThickness: 1,
        labelAngle: this.dashboardCountListCCAction.length > 15 ? -45 : 0,
        interval: 1,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any }) => {
          let formattedLabel = null;
          if (e.label != null) {
            if (e.label.length > 10) {
              formattedLabel = e.label.substring(0, 9) + '...';
            } else {
              formattedLabel = e.label;
            }
          }
          return formattedLabel;
        }, lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      },
      data: [{
        type: "column", // Use "horizontalBar" for horizontal bar chart
        dataPoints: this.dashboardCountListCCAction,
        //color: "#BA7393",
        indexLabel: "{y}",
        indexLabelFontColor: "#0F3659",
        indexLabelFontSize: 12,
        indexLabelFontFamily: "Poppins",
        click: this.handleModuleChartClickCCAction.bind(this)
      }]
    };




    this.chartOptionsForStatusOOSAction = {
      animationEnabled: true,
      exportEnabled: true,
      legend: {
        cursor: "pointer",
      },
      title: {
        text: "OOS Action Status",
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          console.log("Title clicked!");
        }
      },
      dataPointMaxWidth: this.dashboardCountListOOSAction.length > 15 ? 20 : 38,
      dataPointMinWidth: this.dashboardCountListOOSAction.length > 15 ? 20 : 38,
      axisY: {
        gridThickness: this.dashboardCountListOOSAction.length === 1 ? 0 : 1,
        gridColor: "#DEEBFE",
        tickLength: this.dashboardCountListOOSAction.length === 1 ? 0 : 5,
        lineThickness: 0,
        labelFontSize: this.dashboardCountListOOSAction.length === 1 ? 0 : 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE",
        interval: this.getDaYAxisInterval(this.dashboardCountListOOSAction),
        labelFormatter: (e: any) => {
          return this.dashboardCountListOOSAction.length === 1 ? "" : e.value;
        }
      },
      axisX: this.dashboardCountListOOSAction.length === 1 ? {
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any; }) => e.label,
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      } : {
        tickLength: 5,
        lineThickness: 1,
        labelAngle: this.dashboardCountListOOSAction.length > 15 ? -45 : 0,
        interval: 1,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any }) => {
          let formattedLabel = null;
          if (e.label != null) {
            if (e.label.length > 10) {
              formattedLabel = e.label.substring(0, 9) + '...';
            } else {
              formattedLabel = e.label;
            }
          }
          return formattedLabel;
        }, lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      },
      data: [{
        type: "column", // Use "horizontalBar" for horizontal bar chart
        dataPoints: this.dashboardCountListOOSAction,
        //color: "#BA7393",
        indexLabel: "{y}",
        indexLabelFontColor: "#0F3659",
        indexLabelFontSize: 12,
        indexLabelFontFamily: "Poppins",
        click: this.handleModuleChartClickOOSAction.bind(this)
      }]
    };


    //due

    this.chartOptionsForStatusCRActionDue = {
      animationEnabled: true,
      exportEnabled: true,
      legend: {
        cursor: "pointer",
      },
      title: {
        text: "CR Action Due Status",
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          console.log("Title clicked!");
        }
      },
      dataPointMaxWidth: this.dashboardCountListCRActionDue.length > 15 ? 20 : 38,
      dataPointMinWidth: this.dashboardCountListCRActionDue.length > 15 ? 20 : 38,
      axisY: {
        gridThickness: this.dashboardCountListCRActionDue.length === 1 ? 0 : 1,
        gridColor: "#DEEBFE",
        tickLength: this.dashboardCountListCRActionDue.length === 1 ? 0 : 5,
        lineThickness: 0,
        labelFontSize: this.dashboardCountListCRActionDue.length === 1 ? 0 : 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE",
        interval: this.getDaYAxisInterval(this.dashboardCountListCRActionDue),
        labelFormatter: (e: any) => {
          return this.dashboardCountListCRActionDue.length === 1 ? "" : e.value;
        }
      },
      axisX: this.dashboardCountListCRActionDue.length === 1 ? {
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any; }) => e.label,
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      } : {
        tickLength: 5,
        lineThickness: 1,
        labelAngle: this.dashboardCountListCRActionDue.length > 15 ? -45 : 0,
        interval: 1,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any }) => {
          let formattedLabel = null;
          if (e.label != null) {
            if (e.label.length > 10) {
              formattedLabel = e.label.substring(0, 9) + '...';
            } else {
              formattedLabel = e.label;
            }
          }
          return formattedLabel;
        }, lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      },
      data: [{
        type: "column", // Use "horizontalBar" for horizontal bar chart
        dataPoints: this.dashboardCountListCRActionDue,
        // color: "#BA7393",
        indexLabel: "{y}",
        indexLabelFontColor: "#0F3659",
        indexLabelFontSize: 12,
        indexLabelFontFamily: "Poppins",
        click: this.handleModuleChartClickCRActionDue.bind(this)
      }]
    };

    this.chartOptionsForStatusCAPAActionDue = {
      animationEnabled: true,
      exportEnabled: true,
      legend: {
        cursor: "pointer",
      },
      title: {
        text: "CAPA Action Due Status",
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          console.log("Title clicked!");
        }
      },
      dataPointMaxWidth: this.dashboardCountListCAPAActionDue.length > 15 ? 20 : 38,
      dataPointMinWidth: this.dashboardCountListCAPAActionDue.length > 15 ? 20 : 38,
      axisY: {
        gridThickness: this.dashboardCountListCAPAActionDue.length === 1 ? 0 : 1,
        gridColor: "#DEEBFE",
        tickLength: this.dashboardCountListCAPAActionDue.length === 1 ? 0 : 5,
        lineThickness: 0,
        labelFontSize: this.dashboardCountListCAPAActionDue.length === 1 ? 0 : 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE",
        interval: this.getDaYAxisInterval(this.dashboardCountListCAPAActionDue),
        labelFormatter: (e: any) => {
          return this.dashboardCountListCAPAActionDue.length === 1 ? "" : e.value;
        }
      },
      axisX: this.dashboardCountListCAPAActionDue.length === 1 ? {
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any; }) => e.label,
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      } : {
        tickLength: 5,
        lineThickness: 1,
        labelAngle: this.dashboardCountListCAPAActionDue.length > 15 ? -45 : 0,
        interval: 1,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any }) => {
          let formattedLabel = null;
          if (e.label != null) {
            if (e.label.length > 10) {
              formattedLabel = e.label.substring(0, 9) + '...';
            } else {
              formattedLabel = e.label;
            }
          }
          return formattedLabel;
        }, lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      },
      data: [{
        type: "column", // Use "horizontalBar" for horizontal bar chart
        dataPoints: this.dashboardCountListCAPAActionDue,
        // color: "#BA7393",
        indexLabel: "{y}",
        indexLabelFontColor: "#0F3659",
        indexLabelFontSize: 12,
        indexLabelFontFamily: "Poppins",
        click: this.handleModuleChartClickCAPAActionDue.bind(this)
      }]
    };


    this.chartOptionsForStatusDVActionDue = {
      animationEnabled: true,
      exportEnabled: true,
      legend: {
        cursor: "pointer",
      },
      title: {
        text: "DV Action Due Status",
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          console.log("Title clicked!");
        }
      },
      dataPointMaxWidth: this.dashboardCountListDVActionDue.length > 15 ? 20 : 38,
      dataPointMinWidth: this.dashboardCountListDVActionDue.length > 15 ? 20 : 38,
      axisY: {
        gridThickness: this.dashboardCountListDVActionDue.length === 1 ? 0 : 1,
        gridColor: "#DEEBFE",
        tickLength: this.dashboardCountListDVActionDue.length === 1 ? 0 : 5,
        lineThickness: 0,
        labelFontSize: this.dashboardCountListDVActionDue.length === 1 ? 0 : 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE",
        interval: this.getDaYAxisInterval(this.dashboardCountListDVActionDue),
        labelFormatter: (e: any) => {
          return this.dashboardCountListDVActionDue.length === 1 ? "" : e.value;
        }
      },
      axisX: this.dashboardCountListDVActionDue.length === 1 ? {
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any; }) => e.label,
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      } : {
        tickLength: 5,
        lineThickness: 1,
        labelAngle: this.dashboardCountListDVActionDue.length > 15 ? -45 : 0,
        interval: 1,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any }) => {
          let formattedLabel = null;
          if (e.label != null) {
            if (e.label.length > 10) {
              formattedLabel = e.label.substring(0, 9) + '...';
            } else {
              formattedLabel = e.label;
            }
          }
          return formattedLabel;
        }, lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      },
      data: [{
        type: "column", // Use "horizontalBar" for horizontal bar chart
        dataPoints: this.dashboardCountListDVActionDue,
        //color: "#BA7393",
        indexLabel: "{y}",
        indexLabelFontColor: "#0F3659",
        indexLabelFontSize: 12,
        indexLabelFontFamily: "Poppins",
        click: this.handleModuleChartClickDVActionDue.bind(this)
      }]
    };

    this.chartOptionsForStatusINActionDue = {
      animationEnabled: true,
      exportEnabled: true,
      legend: {
        cursor: "pointer",
      },
      title: {
        text: "IN Action Due Status",
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          console.log("Title clicked!");
        }
      },
      dataPointMaxWidth: this.dashboardCountListINActionDue.length > 15 ? 20 : 38,
      dataPointMinWidth: this.dashboardCountListINActionDue.length > 15 ? 20 : 38,
      axisY: {
        gridThickness: this.dashboardCountListINActionDue.length === 1 ? 0 : 1,
        gridColor: "#DEEBFE",
        tickLength: this.dashboardCountListINActionDue.length === 1 ? 0 : 5,
        lineThickness: 0,
        labelFontSize: this.dashboardCountListINActionDue.length === 1 ? 0 : 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE",
        interval: this.getDaYAxisInterval(this.dashboardCountListINActionDue),
        labelFormatter: (e: any) => {
          return this.dashboardCountListINActionDue.length === 1 ? "" : e.value;
        }
      },
      axisX: this.dashboardCountListINActionDue.length === 1 ? {
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any; }) => e.label,
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      } : {
        tickLength: 5,
        lineThickness: 1,
        labelAngle: this.dashboardCountListINActionDue.length > 15 ? -45 : 0,
        interval: 1,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any }) => {
          let formattedLabel = null;
          if (e.label != null) {
            if (e.label.length > 10) {
              formattedLabel = e.label.substring(0, 9) + '...';
            } else {
              formattedLabel = e.label;
            }
          }
          return formattedLabel;
        }, lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      },
      data: [{
        type: "column", // Use "horizontalBar" for horizontal bar chart
        dataPoints: this.dashboardCountListINActionDue,
        // color: "#BA7393",
        indexLabel: "{y}",
        indexLabelFontColor: "#0F3659",
        indexLabelFontSize: 12,
        indexLabelFontFamily: "Poppins",
        click: this.handleModuleChartClickINActionDue.bind(this)
      }]
    };



    this.chartOptionsForStatusQIActionDue = {
      animationEnabled: true,
      exportEnabled: true,
      legend: {
        cursor: "pointer",
      },
      title: {
        text: "QI Action Due Status",
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          console.log("Title clicked!");
        }
      },
      dataPointMaxWidth: this.dashboardCountListQIActionDue.length > 15 ? 20 : 38,
      dataPointMinWidth: this.dashboardCountListQIActionDue.length > 15 ? 20 : 38,
      axisY: {
        gridThickness: this.dashboardCountListQIActionDue.length === 1 ? 0 : 1,
        gridColor: "#DEEBFE",
        tickLength: this.dashboardCountListQIActionDue.length === 1 ? 0 : 5,
        lineThickness: 0,
        labelFontSize: this.dashboardCountListQIActionDue.length === 1 ? 0 : 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE",
        interval: this.getDaYAxisInterval(this.dashboardCountListQIActionDue),
        labelFormatter: (e: any) => {
          return this.dashboardCountListQIActionDue.length === 1 ? "" : e.value;
        }
      },
      axisX: this.dashboardCountListQIActionDue.length === 1 ? {
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any; }) => e.label,
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      } : {
        tickLength: 5,
        lineThickness: 1,
        labelAngle: this.dashboardCountListQIActionDue.length > 15 ? -45 : 0,
        interval: 1,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any }) => {
          let formattedLabel = null;
          if (e.label != null) {
            if (e.label.length > 10) {
              formattedLabel = e.label.substring(0, 9) + '...';
            } else {
              formattedLabel = e.label;
            }
          }
          return formattedLabel;
        }, lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      },
      data: [{
        type: "column", // Use "horizontalBar" for horizontal bar chart
        dataPoints: this.dashboardCountListQIActionDue,
        // color: "#BA7393",
        indexLabel: "{y}",
        indexLabelFontColor: "#0F3659",
        indexLabelFontSize: 12,
        indexLabelFontFamily: "Poppins",
        click: this.handleModuleChartClickQIActionDue.bind(this)
      }]
    };


    this.chartOptionsForStatusCCActionDue = {
      animationEnabled: true,
      exportEnabled: true,
      legend: {
        cursor: "pointer",
      },
      title: {
        text: "CC Action Due Status",
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          console.log("Title clicked!");
        }
      },
      dataPointMaxWidth: this.dashboardCountListCCActionDue.length > 15 ? 20 : 38,
      dataPointMinWidth: this.dashboardCountListCCActionDue.length > 15 ? 20 : 38,
      axisY: {
        gridThickness: this.dashboardCountListCCActionDue.length === 1 ? 0 : 1,
        gridColor: "#DEEBFE",
        tickLength: this.dashboardCountListCCActionDue.length === 1 ? 0 : 5,
        lineThickness: 0,
        labelFontSize: this.dashboardCountListCCActionDue.length === 1 ? 0 : 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE",
        interval: this.getDaYAxisInterval(this.dashboardCountListCCActionDue),
        labelFormatter: (e: any) => {
          return this.dashboardCountListCCActionDue.length === 1 ? "" : e.value;
        }
      },
      axisX: this.dashboardCountListCCActionDue.length === 1 ? {
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any; }) => e.label,
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      } : {
        tickLength: 5,
        lineThickness: 1,
        labelAngle: this.dashboardCountListCCActionDue.length > 15 ? -45 : 0,
        interval: 1,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any }) => {
          let formattedLabel = null;
          if (e.label != null) {
            if (e.label.length > 10) {
              formattedLabel = e.label.substring(0, 9) + '...';
            } else {
              formattedLabel = e.label;
            }
          }
          return formattedLabel;
        }, lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      },
      data: [{
        type: "column", // Use "horizontalBar" for horizontal bar chart
        dataPoints: this.dashboardCountListCCActionDue,
        //color: "#BA7393",
        indexLabel: "{y}",
        indexLabelFontColor: "#0F3659",
        indexLabelFontSize: 12,
        indexLabelFontFamily: "Poppins",
        click: this.handleModuleChartClickCCActionDue.bind(this)
      }]
    };




    this.chartOptionsForStatusOOSActionDue = {
      animationEnabled: true,
      exportEnabled: true,
      legend: {
        cursor: "pointer",
      },
      title: {
        text: "OOS Action Due Status",
        fontSize: 20,
        fontFamily: "Poppins",
        horizontalAlign: "left",
        fontColor: "#0F3659",
        fontWeight: "bold",
        click: function (e: any) {
          console.log("Title clicked!");
        }
      },
      dataPointMaxWidth: this.dashboardCountListOOSActionDue.length > 15 ? 20 : 38,
      dataPointMinWidth: this.dashboardCountListOOSActionDue.length > 15 ? 20 : 38,
      axisY: {
        gridThickness: this.dashboardCountListOOSActionDue.length === 1 ? 0 : 1,
        gridColor: "#DEEBFE",
        tickLength: this.dashboardCountListOOSActionDue.length === 1 ? 0 : 5,
        lineThickness: 0,
        labelFontSize: this.dashboardCountListOOSActionDue.length === 1 ? 0 : 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE",
        interval: this.getDaYAxisInterval(this.dashboardCountListOOSActionDue),
        labelFormatter: (e: any) => {
          return this.dashboardCountListOOSActionDue.length === 1 ? "" : e.value;
        }
      },
      axisX: this.dashboardCountListOOSActionDue.length === 1 ? {
        tickLength: 0,
        lineThickness: 0,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any; }) => e.label,
        lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      } : {
        tickLength: 5,
        lineThickness: 1,
        labelAngle: this.dashboardCountListOOSActionDue.length > 15 ? -45 : 0,
        interval: 1,
        labelFontSize: 12,
        labelFontColor: "#0F3659",
        labelFontFamily: "Poppins",
        labelFormatter: (e: { label: any }) => {
          let formattedLabel = null;
          if (e.label != null) {
            if (e.label.length > 10) {
              formattedLabel = e.label.substring(0, 9) + '...';
            } else {
              formattedLabel = e.label;
            }
          }
          return formattedLabel;
        }, lineColor: "#DEEBFE",
        tickColor: "#DEEBFE"
      },
      data: [{
        type: "column", // Use "horizontalBar" for horizontal bar chart
        dataPoints: this.dashboardCountListOOSActionDue,
        //color: "#BA7393",
        indexLabel: "{y}",
        indexLabelFontColor: "#0F3659",
        indexLabelFontSize: 12,
        indexLabelFontFamily: "Poppins",
        click: this.handleModuleChartClickOOSActionDue.bind(this)
      }]
    };

    try {
      let chart = new CanvasJS.Chart("chartOptionsForStatusCRActionid", this.chartOptionsForStatusCRAction);
      chart.render();
    } catch (error) {
      console.log("error", error);
    }

    try {
      let chart = new CanvasJS.Chart("chartOptionsForStatusCAPAActionid", this.chartOptionsForStatusCAPAAction);
      chart.render();
    } catch (error) {
      console.log("error", error);
    }
    try {
      let chart = new CanvasJS.Chart("chartOptionsForStatusDVActionid", this.chartOptionsForStatusDVAction);
      chart.render();
    } catch (error) {
      console.log("error", error);
    }

    try {
      let chart = new CanvasJS.Chart("chartOptionsForStatusINActionid", this.chartOptionsForStatusINAction);
      chart.render();
    } catch (error) {
      console.log("error", error);
    }

    try {
      let chart = new CanvasJS.Chart("chartOptionsForStatusQIActionid", this.chartOptionsForStatusQIAction);
      chart.render();
    } catch (error) {
      console.log("error", error);
    }

    try {
      let chart = new CanvasJS.Chart("chartOptionsForStatusCCActionid", this.chartOptionsForStatusCCAction);
      chart.render();
    } catch (error) {
      console.log("error", error);
    }

    try {
      let chart = new CanvasJS.Chart("chartOptionsForStatusOOSActionid", this.chartOptionsForStatusOOSAction);
      chart.render();
    } catch (error) {
      console.log("error", error);
    }


    try {
      let chart = new CanvasJS.Chart("chartOptionsForStatusCRActionDueid", this.chartOptionsForStatusCRActionDue);
      chart.render();
    } catch (error) {
      console.log("error", error);
    }

    try {
      let chart = new CanvasJS.Chart("chartOptionsForStatusCAPAActionDueid", this.chartOptionsForStatusCAPAActionDue);
      chart.render();
    } catch (error) {
      console.log("error", error);
    }
    try {
      let chart = new CanvasJS.Chart("chartOptionsForStatusDVActionDueid", this.chartOptionsForStatusDVActionDue);
      chart.render();
    } catch (error) {
      console.log("error", error);
    }

    try {
      let chart = new CanvasJS.Chart("chartOptionsForStatusINActionDueid", this.chartOptionsForStatusINActionDue);
      chart.render();
    } catch (error) {
      console.log("error", error);
    }

    try {
      let chart = new CanvasJS.Chart("chartOptionsForStatusQIActionDueid", this.chartOptionsForStatusQIActionDue);
      chart.render();
    } catch (error) {
      console.log("error", error);
    }

    try {
      let chart = new CanvasJS.Chart("chartOptionsForStatusCCActionDueid", this.chartOptionsForStatusCCActionDue);
      chart.render();
    } catch (error) {
      console.log("error", error);
    }

    try {
      let chart = new CanvasJS.Chart("chartOptionsForStatusOOSActionDueid", this.chartOptionsForStatusOOSActionDue);
      chart.render();
    } catch (error) {
      console.log("error", error);
    }
  }
  handleModuleChartClickCR(e: any): void {
    console.log('org==:', this.dashboardCountListCR[e.dataPointIndex].label);
    this.titleName = "CR Module Reports";
    this.tableDataListActivity('', "CR", this.dashboardCountListCR[e.dataPointIndex].label, 'o');
  }
  handleModuleChartClickCAPA(e: any): void {
    console.log('org==:', this.dashboardCountListCAPA[e.dataPointIndex].label);
    this.titleName = "CAPA Module Reports";
    this.tableDataListActivity('', "CAPA", this.dashboardCountListCAPA[e.dataPointIndex].label, 'o');
  }
  handleModuleChartClickDV(e: any): void {
    console.log('org==:', this.dashboardCountListDV[e.dataPointIndex].label);
    this.titleName = "DV Module Reports";
    this.tableDataListActivity('', "DV", this.dashboardCountListDV[e.dataPointIndex].label, 'o');
  }
  handleModuleChartClickIN(e: any): void {
    console.log('org==:', this.dashboardCountListIN[e.dataPointIndex].label);
    this.titleName = "IN Module Reports";
    this.tableDataListActivity('', "IN", this.dashboardCountListIN[e.dataPointIndex].label, 'o');
  }
  handleModuleChartClickCC(e: any): void {
    console.log('org==:', this.dashboardCountListCC[e.dataPointIndex].label);
    this.titleName = "CC Module Reports";
    this.tableDataListActivity('', "CC", this.dashboardCountListCC[e.dataPointIndex].label, 'o');
  }
  handleModuleChartClickQI(e: any): void {
    console.log('org==:', this.dashboardCountListQI[e.dataPointIndex].label);
    this.titleName = "QI Module Reports";
    this.tableDataListActivity('', "QI", this.dashboardCountListQI[e.dataPointIndex].label, 'o');
  }
  handleModuleChartClickAU(e: any): void {
    console.log('org==:', this.dashboardCountListAU[e.dataPointIndex].label);
    this.titleName = "AU Module Reports";
    this.tableDataListActivity('', "AU", this.dashboardCountListAU[e.dataPointIndex].label, 'o');
  }
  handleModuleChartClickOOS(e: any): void {
    console.log('org==:', this.dashboardCountListOOS[e.dataPointIndex].label);
    this.titleName = "OOS Module Reports";
    this.tableDataListActivity('', "OOS", this.dashboardCountListOOS[e.dataPointIndex].label, 'o');
  }
  handleModuleChartClickCRDue(e: any): void {
    console.log('org==:', this.dashboardCountListCRDue[e.dataPointIndex].label);
    this.titleName = "CR Module Reports";
    this.tableDataListActivity('due', "CR", this.dashboardCountListCRDue[e.dataPointIndex].label, 'o');
  }
  handleModuleChartClickCAPADue(e: any): void {
    console.log('org==:', this.dashboardCountListCAPADue[e.dataPointIndex].label);
    this.titleName = "CAPA Module Reports";
    this.tableDataListActivity('due', "CAPA", this.dashboardCountListCAPADue[e.dataPointIndex].label, 'o');
  }
  handleModuleChartClickDVDue(e: any): void {
    console.log('org==:', this.dashboardCountListDVDue[e.dataPointIndex].label);
    this.titleName = "DV Module Reports";
    this.tableDataListActivity('due', "DV", this.dashboardCountListDVDue[e.dataPointIndex].label, 'o');
  }
  handleModuleChartClickINDue(e: any): void {
    console.log('org==:', this.dashboardCountListINDue[e.dataPointIndex].label);
    this.titleName = "IN Module Reports";
    this.tableDataListActivity('due', "IN", this.dashboardCountListINDue[e.dataPointIndex].label, 'o');
  }
  handleModuleChartClickCCDue(e: any): void {
    console.log('org==:', this.dashboardCountListCCDue[e.dataPointIndex].label);
    this.titleName = "CC Module Reports";
    this.tableDataListActivity('due', "CC", this.dashboardCountListCCDue[e.dataPointIndex].label, 'o');
  }
  handleModuleChartClickQIDue(e: any): void {
    console.log('org==:', this.dashboardCountListQIDue[e.dataPointIndex].label);
    this.titleName = "QI Module Reports";
    this.tableDataListActivity('due', "QI", this.dashboardCountListQIDue[e.dataPointIndex].label, 'o');
  }
  handleModuleChartClickAUDue(e: any): void {
    console.log('org==:', this.dashboardCountListAUDue[e.dataPointIndex].label);
    this.titleName = "AU Module Reports";
    this.tableDataListActivity('due', "AU", this.dashboardCountListAUDue[e.dataPointIndex].label, 'o');
  }
  handleModuleChartClickOOSDue(e: any): void {
    console.log('org==:', this.dashboardCountListOOSDue[e.dataPointIndex].label);
    this.titleName = "OOS Module Reports";
    this.tableDataListActivity('due', "OOS", this.dashboardCountListOOSDue[e.dataPointIndex].label, 'o');
  }


  handleModuleChartClickCRAction(e: any): void {
    console.log('org==:', this.dashboardCountListCRAction[e.dataPointIndex].label);
    this.titleName = "CR Module Reports";
    this.tableDataListAction('', "CR", this.dashboardCountListCRAction[e.dataPointIndex].label, 'o');
  }
  handleModuleChartClickCAPAAction(e: any): void {
    console.log('org==:', this.dashboardCountListCAPAAction[e.dataPointIndex].label);
    this.titleName = "CAPA Module Reports";
    this.tableDataListAction('', "CAPA", this.dashboardCountListCAPAAction[e.dataPointIndex].label, 'o');
  }
  handleModuleChartClickDVAction(e: any): void {
    console.log('org==:', this.dashboardCountListDVAction[e.dataPointIndex].label);
    this.titleName = "DV Module Reports";
    this.tableDataListAction('', "DV", this.dashboardCountListDVAction[e.dataPointIndex].label, 'o');
  }
  handleModuleChartClickINAction(e: any): void {
    console.log('org==:', this.dashboardCountListINAction[e.dataPointIndex].label);
    this.titleName = "IN Module Reports";
    this.tableDataListAction('', "IN", this.dashboardCountListINAction[e.dataPointIndex].label, 'o');
  }
  handleModuleChartClickCCAction(e: any): void {
    console.log('org==:', this.dashboardCountListCCAction[e.dataPointIndex].label);
    this.titleName = "CC Module Reports";
    this.tableDataListAction('', "CC", this.dashboardCountListCCAction[e.dataPointIndex].label, 'o');
  }
  handleModuleChartClickQIAction(e: any): void {
    console.log('org==:', this.dashboardCountListQIAction[e.dataPointIndex].label);
    this.titleName = "QI Module Reports";
    this.tableDataListAction('', "QI", this.dashboardCountListQIAction[e.dataPointIndex].label, 'o');
  }
  handleModuleChartClickAUFinding(e: any): void {
    console.log('org==:', this.dashboardCountListAUFinding[e.dataPointIndex].label);
    this.titleName = "AU Module Reports";
    this.tableDataListAction('', "AU", this.dashboardCountListAUFinding[e.dataPointIndex].label, 'o');
  }
  handleModuleChartClickOOSAction(e: any): void {
    console.log('org==:', this.dashboardCountListOOSAction[e.dataPointIndex].label);
    this.titleName = "OOS Module Reports";
    this.tableDataListAction('', "OOS", this.dashboardCountListOOSAction[e.dataPointIndex].label, 'o');
  }
  handleModuleChartClickCRActionDue(e: any): void {
    console.log('org==:', this.dashboardCountListCRActionDue[e.dataPointIndex].label);
    this.titleName = "CR Module Reports";
    this.tableDataListAction('due', "CR", this.dashboardCountListCRActionDue[e.dataPointIndex].label, 'o');
  }
  handleModuleChartClickCAPAActionDue(e: any): void {
    console.log('org==:', this.dashboardCountListCAPAActionDue[e.dataPointIndex].label);
    this.titleName = "CAPA Module Reports";
    this.tableDataListAction('due', "CAPA", this.dashboardCountListCAPAActionDue[e.dataPointIndex].label, 'o');
  }
  handleModuleChartClickDVActionDue(e: any): void {
    console.log('org==:', this.dashboardCountListDVActionDue[e.dataPointIndex].label);
    this.titleName = "DV Module Reports";
    this.tableDataListAction('due', "DV", this.dashboardCountListDVActionDue[e.dataPointIndex].label, 'o');
  }
  handleModuleChartClickINActionDue(e: any): void {
    console.log('org==:', this.dashboardCountListINActionDue[e.dataPointIndex].label);
    this.titleName = "IN Module Reports";
    this.tableDataListAction('due', "IN", this.dashboardCountListINActionDue[e.dataPointIndex].label, 'o');
  }
  handleModuleChartClickCCActionDue(e: any): void {
    console.log('org==:', this.dashboardCountListCCActionDue[e.dataPointIndex].label);
    this.titleName = "CC Module Reports";
    this.tableDataListAction('due', "CC", this.dashboardCountListCCActionDue[e.dataPointIndex].label, 'o');
  }
  handleModuleChartClickQIActionDue(e: any): void {
    console.log('org==:', this.dashboardCountListQIActionDue[e.dataPointIndex].label);
    this.titleName = "QI Module Reports";
    this.tableDataListAction('due', "QI", this.dashboardCountListQIActionDue[e.dataPointIndex].label, 'o');
  }
  handleModuleChartClickAUFindingDue(e: any): void {
    console.log('org==:', this.dashboardCountListAUFindingDue[e.dataPointIndex].label);
    this.titleName = "AU Module Reports";
    this.tableDataListAction('findingDue', "AU", this.dashboardCountListAUFindingDue[e.dataPointIndex].label, 'o');
  }
  handleModuleChartClickOOSActionDue(e: any): void {
    console.log('org==:', this.dashboardCountListOOSActionDue[e.dataPointIndex].label);
    this.titleName = "OOS Module Reports";
    this.tableDataListAction('due', "OOS", this.dashboardCountListOOSActionDue[e.dataPointIndex].label, 'o');
  }
  columnsListForExcel: any;
  fieldLabelsListForExcel: any;
  invisibleColumnForExcel: any;
  activityRepVwDataForGrid: any = [];

  tableDataListAction(org: any, module: any, status: any, val: any) {
    console.log("org=", org);
    console.log("module=", module)
    console.log("status=", status)
    console.log("val=", val)
    this.item = "";
    this.item1 = "";
    let selectedQmsGroup1 = "";
    let selectedQmsDept1 = "";
    let selectedOrgValue1 = "";
    if (this.selectedQmsGroup.length != 0) {
      for (let j = 0; j < this.selectedQmsGroup.length; j++) {
        selectedQmsGroup1 += "'" + this.selectedQmsGroup[j] + "'";
        selectedQmsGroup1 += j == this.selectedQmsGroup.length - 1 ? "" : ",";
      }
    }

    if (this.selectedQmsDept.length != 0) {
      for (let j = 0; j < this.selectedQmsDept.length; j++) {
        selectedQmsDept1 += "'" + this.selectedQmsDept[j] + "'";
        selectedQmsDept1 += j == this.selectedQmsDept.length - 1 ? "" : ",";
      }
    }

    if (this.selectedOrgValue.length != 0) {
      for (let j = 0; j < this.selectedOrgValue.length; j++) {
        selectedOrgValue1 += this.selectedOrgValue[j];
        selectedOrgValue1 += j == this.selectedOrgValue.length - 1 ? "" : ",";
      }
    }
    if (this.selectedModule) {
      this.selectedModules = this.selectedModule;
    } else {
      this.selectedModules = module
    }
    this.whereValsForExcel = "";
    this.item = selectedOrgValue1 ?? null;
    this.whereValsForExcel = this.whereValsForExcel + " Where ORG_ID in(" + this.item + ")";
    if (org == "due") {
      if (status == "Open") {
        this.whereValsForExcel = this.whereValsForExcel + " AND CHART_STATUS='Open' AND OVERDUE='N'";
      } else if (status == "Closed") {
        this.whereValsForExcel = this.whereValsForExcel + " AND CHART_STATUS='Closed' AND CLOSED_OVERDUE='N'";
      } else if (status == "Open Overdue") {
        this.whereValsForExcel = this.whereValsForExcel + " AND CHART_STATUS='Open' AND OVERDUE='Y'";
      } else if (status == "Closed Overdue") {
        this.whereValsForExcel = this.whereValsForExcel + " AND CHART_STATUS='Closed' AND CLOSED_OVERDUE='Y'";
      } else if (status == "Overdue Response Duedate") {
        this.whereValsForExcel = this.whereValsForExcel + " AND CHART_STATUS='Open' AND OVERDUE_RESPOND_DUEDATE='Y'";
      } else if (status == "Overdue Expected Closure Date") {
        this.whereValsForExcel = this.whereValsForExcel + " AND CHART_STATUS='Open' AND OVERDUE_EXPECTED_CLOSURE_DATE='Y'";
      } else if (status == "Open Overdue Response Duedate") {
        this.whereValsForExcel = this.whereValsForExcel + " AND CHART_STATUS='Open' AND OVERDUE_RESPOND_DUEDATE='Y'";
      } else if (status == "Open Overdue Expected Closure Date") {
        this.whereValsForExcel = this.whereValsForExcel + " AND CHART_STATUS='Open' AND OVERDUE_EXPECTED_CLOSURE_DATE='Y'";
      } else if (status == "Closed Overdue Response Duedate") {
        this.whereValsForExcel = this.whereValsForExcel + " AND CHART_STATUS='Open' AND OVERDUE_RESPOND_DUEDATE='Y'";
      } else if (status == "Closed Overdue Expected Closure Date") {
        this.whereValsForExcel = this.whereValsForExcel + " AND CHART_STATUS='Open' AND OVERDUE_EXPECTED_CLOSURE_DATE='Y'";
      }
    } else if (org == "findingDue") {
      if (status == "Open") {
        this.whereValsForExcel = this.whereValsForExcel + " AND CHART_STATUS='Open' AND OVERDUE_RESPOND_DUEDATE='N' AND OVERDUE_EXPECTED_CLOSURE_DATE='N'";
      } else if (status == "Closed") {
        this.whereValsForExcel = this.whereValsForExcel + " AND CHART_STATUS='Closed' AND CLOSED_OVERDUE_RESPOND_DUEDATE='N' AND CLOSED_OVERDUE_EXPECTED_CLOSURE_DATE='N'";
      } else if (status == "Open Overdue Response Duedate") {
        this.whereValsForExcel = this.whereValsForExcel + " AND CHART_STATUS='Open' AND OVERDUE_RESPOND_DUEDATE='Y'";
      } else if (status == "Open Overdue Expected Closure Date") {
        this.whereValsForExcel = this.whereValsForExcel + " AND CHART_STATUS='Open' AND OVERDUE_EXPECTED_CLOSURE_DATE='Y'";
      } else if (status == "Closed Overdue Response Duedate") {
        this.whereValsForExcel = this.whereValsForExcel + " AND CHART_STATUS='Closed' AND CLOSED_OVERDUE_RESPOND_DUEDATE='Y'";
      } else if (status == "Closed Overdue Expected Closure Date") {
        this.whereValsForExcel = this.whereValsForExcel + " AND CHART_STATUS='Closed' AND CLOSED_OVERDUE_EXPECTED_CLOSURE_DATE='Y'";
      }

    } else {
      if (status == "Open") {
        this.whereValsForExcel = this.whereValsForExcel + " AND CHART_STATUS='Open'";
      } else if (status == "Closed") {
        this.whereValsForExcel = this.whereValsForExcel + " AND CHART_STATUS='Closed'";
      } else if (status == "Overdue") {
        this.whereValsForExcel = this.whereValsForExcel + " AND CHART_STATUS='Open' AND OVERDUE='Y'";
      } else if (status == "Overdue Response Duedate") {
        this.whereValsForExcel = this.whereValsForExcel + " AND CHART_STATUS='Open' AND OVERDUE_RESPOND_DUEDATE='Y'";
      } else if (status == "Overdue Expected Closure Date") {
        this.whereValsForExcel = this.whereValsForExcel + " AND CHART_STATUS='Open' AND OVERDUE_EXPECTED_CLOSURE_DATE='Y'";
      } else if (status == "Total") {
        this.whereValsForExcel = this.whereValsForExcel + " AND CHART_STATUS!='Deleted/Obsoleted/Deferred'";
        this.whereValsForExcel = this.whereValsForExcel + " AND CHART_STATUS!='Deleted/Obsoleted'";
      } else if (status == "Response Pending") {
        this.whereValsForExcel = this.whereValsForExcel + " AND CHART_STATUS='Open' AND RESPONSE_VERIFICATION_PENDING='Y'";
      } else if (status == "Response Completed or Finalized") {
        this.whereValsForExcel = this.whereValsForExcel + " AND CHART_STATUS='Closed' AND RESPONSE_COMPLETED_OR_FINALIZED='Y'";
      } else if (status == "Implementation Pending") {
        this.whereValsForExcel = this.whereValsForExcel + " AND CHART_STATUS='Open' AND IMPLEMENTATION_VERIFICATION_PENDING='Y'";
      } else if (status == "Implementation Completed") {
        this.whereValsForExcel = this.whereValsForExcel + " AND CHART_STATUS='Closed' AND IMPLEMENTATION_VERIFICATION_COMPLETED='Y'";
      }
    }

    this.clickedVal =
      module +
      "-" +
      this.selectedType +
      (status ? "-" + status : "");

    if (selectedQmsGroup1) {
      this.whereValsForExcel = this.whereValsForExcel + " AND GROUP_NAME in(" + selectedQmsGroup1 + ")";
    }
    if (selectedQmsDept1 && this.selectedType == 'Activity') {
      this.whereValsForExcel = this.whereValsForExcel + " AND DEPT_CODE in(" + selectedQmsDept1 + ")";
    } else if (selectedQmsDept1 && this.selectedType == 'Action') {
      this.whereValsForExcel = this.whereValsForExcel + " AND DEPARTMENT in(" + selectedQmsDept1 + ")";
    } else if (selectedQmsDept1 && this.selectedType == 'Finding') {
      this.whereValsForExcel = this.whereValsForExcel + " AND AUDIT_DEPARTMENT in(" + selectedQmsDept1 + ")";
    }
    if (this.selectedModules) {
      this.whereValsForExcel = this.whereValsForExcel + " AND MODULE in('" + this.selectedModules + "')";
    }
    let data = {

      groupId: null,
      module: this.selectedModules,
      dateRangeAt: this.specificIntervalVal ? 'CREATED' : null,
      fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
      toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
      intervals: this.selectedIntervalValue ? this.selectedIntervalValue : null,
      stageName: null,
      status: null,
      deptCode: null,

    }
    this.activityRepVwDataForGrid = [];
    let gridName = "QMS_OVERALL_ACTIONS";

    if (module === "AU") {
      gridName = "QMS_OVERALL_AU_FINDINGS";
    } else if (module === "OOS") {
      gridName = "OOS_ACTIONS_REP";
    }
    const data01 = {

      groupId: null,
      gridName: gridName
    }
    if (module == 'AU') {
      this.dynamicGridName = "QMS_OVERALL_AU_FINDINGS";
      this.dynamicGridViewName = "QMS_OVERALL_AU_FINDINGS_VW";
    } else if (module == 'OOS') {
      this.dynamicGridName = "OOS_ACTIONS_REP";
      this.dynamicGridViewName = "QMS_OOS_ACTIONS_REP_VW";
    } else {
      this.dynamicGridName = "QMS_OVERALL_ACTIONS";
      this.dynamicGridViewName = "QMS_OVERALL_ACTIONS_VW";
    }

    this.appService.getDynamicGridHeaders(data01).subscribe({
      next: (response: any) => {

        this.columnsListForExcel = response.columnsList ?? "";
        this.fieldLabelsListForExcel = response.fieldLabelsList ?? "";
        this.invisibleColumnForExcel = response.invisibleColumn ?? "";
        this.makeStickyColumns = response.fixedFieldCnt;
        this.columnList = this.fieldLabelsListForExcel;
        const data1: any = {

          gridName: this.dynamicGridViewName,
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || "",
          annualRefNo: null,
          refno: null,
          taskId: this.item1,
          taskNo: this.item,
          groupIds: selectedQmsGroup1,
          deptIds: selectedQmsDept1,
          wherVal: this.whereValsForExcel,
          reModule: "qms"
        }

        this.reportObj = { ...data1, ...data };
        this.appService.usergridddynamicDataMainDashboard(this.reportObj).subscribe({
          next: (response1: any) => {
            this.activityRepVwDataForGrid = response1;
            console.log("activityRepVwDataForGrid1=", this.activityRepVwDataForGrid);
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const size of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(size + 'px');
            }
            for (let y = this.columnLists.columnsListarray.length - 1; y >= 0; y--) {
              if (this.columnLists.invisibleColumnarray.includes(this.columnLists.columnsListarray[y])) {
                this.columnLists.columnsListarray.splice(y, 1);
                this.columnLists.fieldColumnarray.splice(y, 1);
                this.columnLists.fieldSizeListArray.splice(y, 1);
              }
            }
            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const dataType of this.dataTypeList) {
                  if (dataType.columnName === this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = dataType.fieldType;
                  }
                }
              }
              for (const record of this.activityRepVwDataForGrid) {
                for (const dataType of this.dataTypeList) {
                  if (dataType.fieldType === 'CHECKBOX') {
                    record[dataType.columnName] = record[dataType.columnName] === "Y";
                  }
                }
              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.setPageAction(1, 0);
            });
            this.message.gridList = this.activityRepVwDataForGrid;
            this.collectionSize = this.activityRepVwDataForGrid.length;
            this.totalPages = Math.ceil(this.activityRepVwDataForGrid.length / this.itemsPerPage);

            this.isProcessing = false;
          }, error: (error: any) => {
            this.isProcessing = false;
            throw error;
          }
        });
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
    this.clickedVal = module + "-" + this.selectedType + "-" + status;

    console.log(" this.clickedVal===", this.clickedVal);
    this.visibleReportPopup = this.dialog.open(this.reportPopup, this.reportPopupConfig);
  }


  getDaYAxisInterval(val: any) {
    const maxValue = Math.max(val.map((item: { count: number }) => item.count));
    if (maxValue <= 5) {
      return 1;
    } else if (maxValue <= 10) {
      return 2;
    } else if (maxValue <= 50) {
      return 5;
    } else if (maxValue <= 100) {
      return 10;
    } else if (maxValue <= 500) {
      return 50;
    } else if (maxValue <= 1000) {
      return 100;
    } else {
      return 200; // Adjust based on your data range
    }
  };


  //excel

  generateModuleSummary(val: any): any[] {

    if (!val?.length) {
      return [];
    }

    const moduleSummary: any = {};

    val.forEach((item: any) => {

      const module = item.module;
      const orgLongName = item.orgLongName;
      const status = item.chartStatus?.trim();
      const count = Number(item.count) || 0;

      // Initialize module object
      if (!moduleSummary[module]) {
        moduleSummary[module] = {
          OrgLongName: orgLongName,
          Module: module,
          Total: 0,
          Open: 0,
          Closed: 0,
          Overdue: 0,
          Deleted: 0
        };
      }
      // Total
      moduleSummary[module].Total += count;
      // Deleted / Obsolete
      if (status === 'Deleted/Obsoleted' || status === 'Deleted/Obsoleted/Deferred') {
        moduleSummary[module].Deleted += count;
        // return;
      }



      // Open
      if (status === 'Open') {
        moduleSummary[module].Open += count;
      }

      // Closed
      if (status === 'Closed') {
        moduleSummary[module].Closed += count;
      }

      // Overdue
      if (item.overdue === 'Y') {
        moduleSummary[module].Overdue += count;
      }

    });

    return Object.values(moduleSummary);
  }


  generateGroupSummary(val: any): any[] {
    if (!val?.length) {
      return [];
    }
    const moduleSummary: any = {};
    val.forEach((item: any) => {
      const module = item.module;
      const groupName = item.groupName;
      const status = item.chartStatus?.trim();
      const count = Number(item.count) || 0;
      // Unique key for Module + Group
      const key = module + '_' + groupName;

      // Initialize object
      if (!moduleSummary[key]) {
        moduleSummary[key] = {
          OrgLongName: this.getOrgNameForGroup(groupName, ''),
          Module: module,
          GroupName: groupName,
          Total: 0,
          Open: 0,
          Closed: 0,
          Overdue: 0,
          Deleted: 0
        };
      }
      // Total
      moduleSummary[key].Total += count;
      // Deleted / Obsolete
      if (status === 'Deleted/Obsoleted' || status === 'Deleted/Obsoleted/Deferred') {
        moduleSummary[key].Deleted += count;
        // return;
      }
      // Open
      if (status === 'Open') {
        moduleSummary[key].Open += count;
      }

      // Closed
      if (status === 'Closed') {
        moduleSummary[key].Closed += count;
      }

      // Overdue
      if (item.overdue === 'Y') {
        moduleSummary[key].Overdue += count;
      }

    });

    return Object.values(moduleSummary);
  }

  exportExcelFromFrontendcall() {
    this.exportExcelFromFrontend(this.excelDashboardCountList)
  }
  exportGroupExcelFromFrontendcall() {
    this.exportExcelFromFrontend(this.excelGroupDashboardCountList)
  }

  exportExcelFromFrontend(data: any) {
    // 🔹 Information Sheet Data
    const infoData = [
      { Key: 'Report Name', Value: 'Module Summary Report' },
      { Key: 'Generated Date', Value: new Date().toLocaleDateString() },
      { Key: 'Generated Time', Value: new Date().toLocaleTimeString() },
      { Key: 'Generated By', Value: sessionStorage.getItem("reportsUserName") ? sessionStorage.getItem("reportsUserName") : localStorage.getItem("loggedUserName") }
    ];
    const infoWorksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(infoData);
    // 🔹 Module Summary Sheet
    const dataWorksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    // 🔹 Workbook with 2 sheets
    const workbook: XLSX.WorkBook = {
      Sheets: {
        'Information': infoWorksheet,
        'Module Summary': dataWorksheet
      },
      SheetNames: ['Information', 'Module Summary']
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array'
    });
    const blob: Blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    FileSaver.saveAs(blob, 'Module_Summary.xlsx');
  }


  setPageAction(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.activityRepVwDataForGrid.length, page, this.perPage, targetpage);
    if (this.activityRepVwDataForGrid.length > 0) {
      this.pagedItems = this.activityRepVwDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }
  paginationCallAction(value: number) {
    this.perPage = value;
    this.setPageAction(this.pager.currentPage, 0);
  }

  getClobData3(list: any, colunName: any) {
    this.isProcessing = true;
    let modifiedColumnName = colunName;
    switch (colunName) {
      case "CHANGE_DESCRIPTION":
        modifiedColumnName = "Change Description";
        break;
      case "CURRENT_STATE":
        modifiedColumnName = "Current State";
        break;
      case "PROPOSED_CHANGE":
        modifiedColumnName = "Proposed Change";
        break;
      case "CHANGE_JUSTIFICATION":
        modifiedColumnName = "Change Justification";
        break;
      case "RISK_ASSESSMENT":
        modifiedColumnName = "Risk Assessment";
        break;
      case "DV_DESCRIPTION":
        modifiedColumnName = "Deviation Description";
        break;
      case "SCOPE":
        modifiedColumnName = "Scope";
        break;
      case "INITIAL_ASSESSMENT":
        modifiedColumnName = "Initial Assessment";
        break;
      case "INVESTIGATION_PLAN":
        modifiedColumnName = "Investigation Plan";
        break;
      case "INVESTIGATION_DETAILS":
        modifiedColumnName = "Investigation Details";
        break;
      case "ROOT_CAUSE_ANALYSIS":
        modifiedColumnName = "Root Cause Analysis";
        break;
      case "IMPACT_ASSESSMENT":
        modifiedColumnName = "Impact Assessment";
        break;
      case "CONCLUSION":
        modifiedColumnName = "Conclusion";
        break;
      case "LAST_ACTION_COMMENTS":
        modifiedColumnName = "Last Action Comments";
        break;
      case "REPORTER_COMMENTS":
        modifiedColumnName = "Reporter Comments";
        break;
      case "ROOT_CAUSE":
        modifiedColumnName = "Root Cause";
        break;
      default:
        break;
    }

    if (this.dynamicGridViewName == "QMS_OVERALL_ACTIONS_VW") {
      let docObj = {

        actionId: list.ACTION_ID,
        tableView: this.dynamicGridViewName,
        columnName: colunName,
      };

      console.log("popview", modifiedColumnName);
      this.htmlContent = "";
      this.appService.getClobToViewOverAllAction(docObj).subscribe({
        next: (Response: any) => {
          console.log(Response.result);
          this.htmlContent = Response.result;
          this.editorComponent.openEditor(this.htmlContent, modifiedColumnName);
        }, error: (error: any) => {
          this.isProcessing = false;
          throw error;
        }
      });

      this.isProcessing = false;

    } else {
      let docObj = {

        primeIdentifier: list.PRIM_IDENTIFIER,
        tableView: this.dynamicGridViewName,
        columnName: colunName,
      };

      console.log("popview", modifiedColumnName);
      this.htmlContent = "";
      this.appService.getClobToViewAudit(docObj).subscribe({
        next: (Response: any) => {
          console.log(Response.result);
          this.htmlContent = Response.result;
          this.editorComponent.openEditor(this.htmlContent, modifiedColumnName);
        }, error: (error: any) => {
          this.isProcessing = false;
          throw error;
        }
      });

      this.isProcessing = false;
    }

  }

  applyFilter33(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.activityRepVwDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.activityRepVwDataForGrid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }

  generateReportActionFindings(value: any) {

    if (value == 'Pdf' && this.manuallyPicked && !this.selectedColumns.length) {
      this.showSnackBar('Please select the Columns', 'E');
    } else {
      this.appService.isProcessingRep = true;
      this.data = {};
      this.data1 = {};
      this.data2 = {};


      this.data = {
        orgId: this.selectedOrgValue[0].toString(),
        gridName: this.dynamicGridName,
        groupId: null
      }
      this.appService.getDynamicGridHeaders(this.data).subscribe((response: any) => {

        response.orderByClause ??= "";
        this.data1 = {
          gridName: this.dynamicGridViewName,
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          selectedUserId: null,
          selectedFolderPath: null,
          selectedDocumentTypeName: this.selectedDocumentTypeName,
          selectedDocContainer: this.selectedDocContainer,
          manualEntryDataFields: response.manualEntryDataFields,
          wherVal: this.whereValsForExcel,
          reModule: "",
          mainDash: "QMS",
          logoId: 0,
          isSaveRep: this.isSaveReport ? 'Y' : 'N',
          reportName: this.reportName ?? "Dashboard_Report",
          currentStatus: "NA",
          groupName: this.reportName + "",
          module: this.selectedModules
        }
        this.data2 = {

          groupId: null,
          module: this.selectedModules,
          dateRangeAt: this.specificIntervalVal ? 'CREATED' : null,
          fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
          toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
          intervals: this.selectedIntervalValue ? this.selectedIntervalValue : null,
          stageName: null,
          status: null,
          deptCode: null,
        }
        this.reportObj = { ...this.data1, ...this.data, ...this.data2 };
        debugger;
        if (this.selectedType == "Activity") {
          if (value == 'Excel') {
            const pdfData = {
              ...this.reportObj, title: "Activity", columns: [],
              "informationTab": {
                "Report Name": "Activity",
                "Exported By": localStorage.getItem("loggedUserName")
              }
            }
            this.appService.downloadexcelForChart(pdfData, "Activity.xlsx");
          } else {
            const pdfData = {
              ...this.reportObj, title: "Activity", columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray).slice(0, 10).join(','), pdfPageSize: this.excelPdf.pdfPageSize
            }
            this.appService.downloadPdfForChart(pdfData, "Activity.pdf");
          }
        } else {
          if (value == 'Excel') {
            const pdfData = {
              ...this.reportObj, title: this.selectedType == "Finding" ? "Finding" : "Action", columns: [],
              "informationTab": {
                "Report Name": this.selectedType == "Finding" ? "Finding" : "Action",
                "Exported By": localStorage.getItem("loggedUserName")
              }
            }
            this.appService.downloadexcelForChart(pdfData, this.selectedType == "Finding" ? "Finding" + ".xlsx" : "Action" + ".xlsx");
          } else {
            const pdfData = {
              ...this.reportObj, title: this.selectedType == "Finding" ? "Finding" : "Action", columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray).slice(0, 10).join(','), pdfPageSize: this.excelPdf.pdfPageSize
            }
            this.appService.downloadPdfForChart(pdfData, this.selectedType == "Finding" ? "Finding" + ".pdf" : "Action" + ".pdf");
          }
        }

      });
    }


  }


  chartDoubleClicks(val: any) {
    if (val == "Finding") {
      this.tableDataListAction('', "AU", "All", 'o');
    } else if (val == "ActionCR") {
      this.tableDataListAction('', "AU", "All", 'o');
    }
    else if (val == "ActionCAPA") {
      this.tableDataListAction('', "CAPA", "All", 'o');
    } else if (val == "ActionDV") {
      this.tableDataListAction('', "DV", "All", 'o');
    } else if (val == "ActionIN") {
      this.tableDataListAction('', "IN", "All", 'o');
    } else if (val == "ActionCC") {
      this.tableDataListAction('', "CC", "All", 'o');
    } else if (val == "ActionOOS") {
      this.tableDataListAction('', "OOS", "All", 'o');
    } else if (val == "ActionQI") {
      this.tableDataListAction('', "QI", "All", 'o');
    }
  }
  tableDataListActivity(org: any, module: any, status: any, val: any) {
    this.typeOfGrid = "dy";
    console.log("org=", org);
    console.log("module=", module)
    console.log("status=", status)
    console.log("val=", val)
    this.item = "";
    this.item1 = "";
    let selectedQmsGroup1 = "";
    let selectedQmsDept1 = "";
    let selectedOrgValue1 = "";
    if (this.selectedQmsGroup.length != 0) {
      for (let j = 0; j < this.selectedQmsGroup.length; j++) {
        selectedQmsGroup1 += "'" + this.selectedQmsGroup[j] + "'";
        selectedQmsGroup1 += j == this.selectedQmsGroup.length - 1 ? "" : ",";
      }
    }

    if (this.selectedQmsDept.length != 0) {
      for (let j = 0; j < this.selectedQmsDept.length; j++) {
        selectedQmsDept1 += "'" + this.selectedQmsDept[j] + "'";
        selectedQmsDept1 += j == this.selectedQmsDept.length - 1 ? "" : ",";
      }
    }

    if (this.selectedOrgValue.length != 0) {
      for (let j = 0; j < this.selectedOrgValue.length; j++) {
        selectedOrgValue1 += this.selectedOrgValue[j];
        selectedOrgValue1 += j == this.selectedOrgValue.length - 1 ? "" : ",";
      }
    }
    if (!this.selectedModule) {
      this.selectedModules = module;
    } else {
      this.selectedModules = this.selectedModule;
    }
    this.whereValsForExcel = "";
    this.item = selectedOrgValue1 ?? null;
    this.whereValsForExcel = this.whereValsForExcel + " Where ORG_ID in(" + this.item + ")";
    if (org == "due") {
      const statusConditions: { [key: string]: string } = {
        Open: " AND CHART_STATUS='Open' AND OVERDUE='N'",
        Closed: " AND CHART_STATUS='Closed' AND CLOSED_OVERDUE='N'",
        "Open Overdue": " AND CHART_STATUS='Open' AND OVERDUE='Y'",
        "Closed Overdue": " AND CHART_STATUS='Closed' AND CLOSED_OVERDUE='Y'",
        "Overdue Response Duedate":
          " AND CHART_STATUS='Open' AND OVERDUE_RESPOND_DUEDATE='Y'",
        "Overdue Expected Closure Date":
          " AND CHART_STATUS='Open' AND OVERDUE_EXPECTED_CLOSURE_DATE='Y'",
      };

      this.whereValsForExcel += statusConditions[status] || "";
    } else {
      const statusConditions: { [key: string]: string } = {
        Open: " AND CHART_STATUS='Open'",
        Closed: " AND CHART_STATUS='Closed'",
        Overdue: " AND CHART_STATUS='Open' AND OVERDUE='Y'",
        "Overdue Response Duedate":
          " AND CHART_STATUS='Open' AND OVERDUE_RESPOND_DUEDATE='Y'",
        "Overdue Expected Closure Date":
          " AND CHART_STATUS='Open' AND OVERDUE_EXPECTED_CLOSURE_DATE='Y'",
        Total:
          " AND CHART_STATUS!='Deleted/Obsoleted/Deferred'" +
          " AND CHART_STATUS!='Deleted/Obsoleted'",
      };

      this.whereValsForExcel += statusConditions[status] || "";
    }


    this.clickedVal = `${module}-${this.selectedType}${status ? "-" + status : ""}`;
    if (selectedQmsGroup1) {
      this.whereValsForExcel = this.whereValsForExcel + " AND GROUP_NAME in(" + selectedQmsGroup1 + ")";
    }
    if (selectedQmsDept1 && this.selectedType == 'Activity') {
      this.whereValsForExcel = this.whereValsForExcel + " AND DEPT_CODE in(" + selectedQmsDept1 + ")";
    } else if (selectedQmsDept1 && this.selectedType == 'Action') {
      this.whereValsForExcel = this.whereValsForExcel + " AND DEPARTMENT in(" + selectedQmsDept1 + ")";
    } else if (selectedQmsDept1 && this.selectedType == 'Finding') {
      this.whereValsForExcel = this.whereValsForExcel + " AND AUDIT_DEPARTMENT in(" + selectedQmsDept1 + ")";
    }
    if (this.selectedModules) {
      this.whereValsForExcel = this.whereValsForExcel + " AND MODULE in('" + this.selectedModules + "')";
    }
    let data = {

      groupId: null,
      module: this.selectedModules,
      dateRangeAt: this.specificIntervalVal ? 'CREATED' : null,
      fromDate: this.fromDate ? this.appService.dateZoneConvertion(new Date(this.fromDate)) : null,
      toDate: this.toDate ? this.appService.dateZoneConvertion(new Date(this.toDate)) : null,
      intervals: this.selectedIntervalValue ? this.selectedIntervalValue : null,
      stageName: null,
      status: null,
      deptCode: null,
    }
    this.activityRepVwDataForGrid = [];
    let invisibleColumn = "";
    if (this.selectedModules) {
      if (this.selectedModules == 'CR') {
        invisibleColumn = "INVESTIGATOR_NAME,INVESTIGATOR_FULLNAME,INVESTIGATION_REQUIRED,ANNUAL_REF_NO,SUB_GROUP_NAME,PRIMARY_AUDITEE,VENDOR_NAME,DEVIATION_CRITICALITY,PEER_REVIEW_COMPLETED_ON,IS_QANDA_REQD";
      } else if (this.selectedModules == 'CAPA') {
        invisibleColumn = "INVESTIGATOR_NAME,INVESTIGATOR_FULLNAME,INVESTIGATION_REQUIRED,ANNUAL_REF_NO,SUB_GROUP_NAME,PRIMARY_AUDITEE,VENDOR_NAME,DEVIATION_CRITICALITY,PEER_REVIEW_COMPLETED_ON,IS_QANDA_REQD";
      } else if (this.selectedModules == 'DV') {
        invisibleColumn = "ANNUAL_REF_NO,SUB_GROUP_NAME,PRIMARY_AUDITEE,VENDOR_NAME,PEER_REVIEW_COMPLETED_ON,IS_QANDA_REQD";
      } else if (this.selectedModules == 'IN') {
        invisibleColumn = "DEPARTMENT_HEAD_USER_NAME,QA_ACCEPTOR_NAME,QA_ACCEPTOR_FULLNAME,REOPEN_OR_REVOKED_ON,ANNUAL_REF_NO,SUB_GROUP_NAME,PRIMARY_AUDITEE,VENDOR_NAME,DEVIATION_CRITICALITY,PEER_REVIEW_COMPLETED_ON,IS_QANDA_REQD";
      } else if (this.selectedModules == 'QI') {
        invisibleColumn = "DEPARTMENT_HEAD_USER_NAME,QA_ACCEPTOR_NAME,QA_ACCEPTOR_FULLNAME,ANNUAL_REF_NO,SUB_GROUP_NAME,PRIMARY_AUDITEE,VENDOR_NAME,DEVIATION_CRITICALITY,PEER_REVIEW_COMPLETED_ON,IS_QANDA_REQD";
      } else if (this.selectedModules == 'CC') {
        invisibleColumn = "DEPARTMENT_HEAD_USER_NAME,QA_ACCEPTOR_NAME,QA_ACCEPTOR_FULLNAME,REOPEN_OR_REVOKED_ON,ANNUAL_REF_NO,SUB_GROUP_NAME,PRIMARY_AUDITEE,VENDOR_NAME,DEVIATION_CRITICALITY,PEER_REVIEW_COMPLETED_ON,IS_QANDA_REQD";
      } else if (this.selectedModules == 'AU') {
        invisibleColumn = "DEPARTMENT_HEAD_USER_NAME,REOPEN_OR_REVOKED_ON,INVESTIGATOR_NAME,INVESTIGATOR_FULLNAME,INVESTIGATION_REQUIRED,DEVIATION_CRITICALITY";
      } else if (this.selectedModules == 'OOS') {
        invisibleColumn = "TASK_TYPE,REQUESTED_AT,CORE_BUSINESS_AREA_NAME,IS_QANDA_REQD,EFFECTIVENESS_CHECK_REQD,ANNUAL_REF_NO,SUB_GROUP_NAME,PRIMARY_AUDITEE,VENDOR_NAME,DEVIATION_CRITICALITY,PEER_REVIEW_COMPLETED_ON";
      }

    }

    if (this.selectedType == 'Activity') {
      this.dynamicGridName = "ALL_TASKS_FOR_DASHBOARD";
      this.dynamicGridViewName = "QMS_ALL_TASKS_FOR_DASHBOARD_VW";
    } else if (this.selectedType == 'Finding') {
      this.dynamicGridName = "QMS_OVERALL_AU_FINDINGS";
      this.dynamicGridViewName = "QMS_OVERALL_AU_FINDINGS_VW";
    } else if (this.selectedType == 'Action') {
      this.dynamicGridName = "QMS_OVERALL_ACTIONS";
      this.dynamicGridViewName = "QMS_OVERALL_ACTIONS_VW";
    }

    const data01 = {

      groupId: null,
      gridName: this.dynamicGridName,
    }


    this.appService.getDynamicGridHeaders(data01).subscribe({
      next: (response: any) => {

        this.columnsListForExcel = response.columnsList ?? "";
        this.fieldLabelsListForExcel = response.fieldLabelsList ?? "";
        this.invisibleColumnForExcel = response.invisibleColumn ?? "";
        this.makeStickyColumns = response.fixedFieldCnt;
        this.columnList = this.fieldLabelsListForExcel;
        const data1: any = {

          gridName: this.dynamicGridViewName,
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn + "," + invisibleColumn,
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || "",
          annualRefNo: null,
          refno: null,
          taskId: this.item1,
          taskNo: this.item,
          groupIds: selectedQmsGroup1,
          deptIds: selectedQmsDept1,
          wherVal: this.whereValsForExcel,
          reModule: "qms"
        }

        this.reportObj = { ...data1, ...data };
        this.appService.usergridddynamicDataMainDashboard(this.reportObj).subscribe({
          next: (response1: any) => {
            this.activityRepVwDataForGrid = response1;
            console.log("activityRepVwDataForGrid1=", this.activityRepVwDataForGrid);
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const size of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(size + 'px');
            }
            for (let y = this.columnLists.columnsListarray.length - 1; y >= 0; y--) {
              if (this.columnLists.invisibleColumnarray.includes(this.columnLists.columnsListarray[y])) {
                this.columnLists.columnsListarray.splice(y, 1);
                this.columnLists.fieldColumnarray.splice(y, 1);
                this.columnLists.fieldSizeListArray.splice(y, 1);
              }
            }
            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const dataType of this.dataTypeList) {
                  if (dataType.columnName === this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = dataType.fieldType;
                  }
                }
              }
              for (const record of this.activityRepVwDataForGrid) {
                for (const dataType of this.dataTypeList) {
                  if (dataType.fieldType === 'CHECKBOX') {
                    record[dataType.columnName] = record[dataType.columnName] === "Y";
                  }
                }
              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.setPageAction(1, 0);
            });
            this.message.gridList = this.activityRepVwDataForGrid;
            this.collectionSize = this.activityRepVwDataForGrid.length;
            this.totalPages = Math.ceil(this.activityRepVwDataForGrid.length / this.itemsPerPage);

            this.isProcessing = false;
          }, error: (error: any) => {
            this.isProcessing = false;
            throw error;
          }
        });
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
    this.clickedVal = module + "-" + this.selectedType + "-" + status;

    console.log(" this.clickedVal===", this.clickedVal);
    this.visibleReportPopup1 = this.dialog.open(this.reportPopup1, this.reportPopupConfig);
  }
}
